"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: area_page.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPageListing_IntegerRange = exports.AreaPageListing = exports.AreaPageListingResponse = exports.AreaPageListingRequest = exports.Filter = exports.TypeOfProperty = exports.Range_Float = exports.Range_Date = exports.Range_Integer = exports.Range = exports.AreaPageListing_Provider = exports.AreaPageListing_Status = exports.AreaPageListing_ListingType = exports.PropertyType = exports.Style = exports.SortBy = exports.protobufPackage = void 0;
exports.sortByFromJSON = sortByFromJSON;
exports.sortByToJSON = sortByToJSON;
exports.styleFromJSON = styleFromJSON;
exports.styleToJSON = styleToJSON;
exports.propertyTypeFromJSON = propertyTypeFromJSON;
exports.propertyTypeToJSON = propertyTypeToJSON;
exports.areaPageListing_ListingTypeFromJSON = areaPageListing_ListingTypeFromJSON;
exports.areaPageListing_ListingTypeToJSON = areaPageListing_ListingTypeToJSON;
exports.areaPageListing_StatusFromJSON = areaPageListing_StatusFromJSON;
exports.areaPageListing_StatusToJSON = areaPageListing_StatusToJSON;
exports.areaPageListing_ProviderFromJSON = areaPageListing_ProviderFromJSON;
exports.areaPageListing_ProviderToJSON = areaPageListing_ProviderToJSON;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const timestamp_1 = require("../google/protobuf/timestamp");
const display_1 = require("./property/display");
const standard_status_1 = require("./property/standard_status");
exports.protobufPackage = "domain";
var SortBy;
(function (SortBy) {
    SortBy[SortBy["NotSet"] = 0] = "NotSet";
    SortBy[SortBy["PriceAsc"] = 1] = "PriceAsc";
    SortBy[SortBy["PriceDesc"] = 2] = "PriceDesc";
    SortBy[SortBy["DateAsd"] = 3] = "DateAsd";
    SortBy[SortBy["DateDesc"] = 4] = "DateDesc";
    SortBy[SortBy["BedroomsDesc"] = 5] = "BedroomsDesc";
    SortBy[SortBy["BedroomsAsc"] = 6] = "BedroomsAsc";
    SortBy[SortBy["BathroomsDesc"] = 7] = "BathroomsDesc";
    SortBy[SortBy["BathroomsAsc"] = 8] = "BathroomsAsc";
    SortBy[SortBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SortBy || (exports.SortBy = SortBy = {}));
function sortByFromJSON(object) {
    switch (object) {
        case 0:
        case "NotSet":
            return SortBy.NotSet;
        case 1:
        case "PriceAsc":
            return SortBy.PriceAsc;
        case 2:
        case "PriceDesc":
            return SortBy.PriceDesc;
        case 3:
        case "DateAsd":
            return SortBy.DateAsd;
        case 4:
        case "DateDesc":
            return SortBy.DateDesc;
        case 5:
        case "BedroomsDesc":
            return SortBy.BedroomsDesc;
        case 6:
        case "BedroomsAsc":
            return SortBy.BedroomsAsc;
        case 7:
        case "BathroomsDesc":
            return SortBy.BathroomsDesc;
        case 8:
        case "BathroomsAsc":
            return SortBy.BathroomsAsc;
        case -1:
        case "UNRECOGNIZED":
        default:
            return SortBy.UNRECOGNIZED;
    }
}
function sortByToJSON(object) {
    switch (object) {
        case SortBy.NotSet:
            return "NotSet";
        case SortBy.PriceAsc:
            return "PriceAsc";
        case SortBy.PriceDesc:
            return "PriceDesc";
        case SortBy.DateAsd:
            return "DateAsd";
        case SortBy.DateDesc:
            return "DateDesc";
        case SortBy.BedroomsDesc:
            return "BedroomsDesc";
        case SortBy.BedroomsAsc:
            return "BedroomsAsc";
        case SortBy.BathroomsDesc:
            return "BathroomsDesc";
        case SortBy.BathroomsAsc:
            return "BathroomsAsc";
        case SortBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var Style;
(function (Style) {
    Style[Style["All"] = 0] = "All";
    /** vacant_land - Vacant Land */
    Style[Style["vacant_land"] = 111] = "vacant_land";
    Style[Style["other_unspecified"] = 24] = "other_unspecified";
    /** house_detached - Free-standing residential buildings. */
    Style[Style["house_detached"] = 101] = "house_detached";
    /** house_attached - Includes semi-detached homes and row or town houses. */
    Style[Style["house_attached"] = 102] = "house_attached";
    /** house_new_development - Houses which are newly built or under construction. */
    Style[Style["house_new_development"] = 103] = "house_new_development";
    /** house_other - Other */
    Style[Style["house_other"] = 104] = "house_other";
    /** condo_highrise - Individually owned residential units in tall apartment buildings or structures. */
    Style[Style["condo_highrise"] = 105] = "condo_highrise";
    /** condo_lowrise - Individually owned residences that are only a few stories tall, such as townhouses. */
    Style[Style["condo_lowrise"] = 106] = "condo_lowrise";
    /** condo_new_development - Condos which are newly built, planned or under construction. */
    Style[Style["condo_new_development"] = 107] = "condo_new_development";
    /** condo_other - Other */
    Style[Style["condo_other"] = 108] = "condo_other";
    /** townhouse - Condo townhouses */
    Style[Style["townhouse"] = 109] = "townhouse";
    /** house_semidetached - Semi-detached homes */
    Style[Style["house_semidetached"] = 110] = "house_semidetached";
    /** multifamily_other - Multifamily homes */
    Style[Style["multifamily_other"] = 112] = "multifamily_other";
    Style[Style["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Style || (exports.Style = Style = {}));
function styleFromJSON(object) {
    switch (object) {
        case 0:
        case "All":
            return Style.All;
        case 111:
        case "vacant_land":
            return Style.vacant_land;
        case 24:
        case "other_unspecified":
            return Style.other_unspecified;
        case 101:
        case "house_detached":
            return Style.house_detached;
        case 102:
        case "house_attached":
            return Style.house_attached;
        case 103:
        case "house_new_development":
            return Style.house_new_development;
        case 104:
        case "house_other":
            return Style.house_other;
        case 105:
        case "condo_highrise":
            return Style.condo_highrise;
        case 106:
        case "condo_lowrise":
            return Style.condo_lowrise;
        case 107:
        case "condo_new_development":
            return Style.condo_new_development;
        case 108:
        case "condo_other":
            return Style.condo_other;
        case 109:
        case "townhouse":
            return Style.townhouse;
        case 110:
        case "house_semidetached":
            return Style.house_semidetached;
        case 112:
        case "multifamily_other":
            return Style.multifamily_other;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Style.UNRECOGNIZED;
    }
}
function styleToJSON(object) {
    switch (object) {
        case Style.All:
            return "All";
        case Style.vacant_land:
            return "vacant_land";
        case Style.other_unspecified:
            return "other_unspecified";
        case Style.house_detached:
            return "house_detached";
        case Style.house_attached:
            return "house_attached";
        case Style.house_new_development:
            return "house_new_development";
        case Style.house_other:
            return "house_other";
        case Style.condo_highrise:
            return "condo_highrise";
        case Style.condo_lowrise:
            return "condo_lowrise";
        case Style.condo_new_development:
            return "condo_new_development";
        case Style.condo_other:
            return "condo_other";
        case Style.townhouse:
            return "townhouse";
        case Style.house_semidetached:
            return "house_semidetached";
        case Style.multifamily_other:
            return "multifamily_other";
        case Style.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["singleFamily"] = 0] = "singleFamily";
    PropertyType[PropertyType["singleFamilyAndBasement"] = 1] = "singleFamilyAndBasement";
    PropertyType[PropertyType["duplex"] = 2] = "duplex";
    PropertyType[PropertyType["triplex"] = 3] = "triplex";
    PropertyType[PropertyType["fourplex"] = 4] = "fourplex";
    PropertyType[PropertyType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PropertyType || (exports.PropertyType = PropertyType = {}));
function propertyTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "singleFamily":
            return PropertyType.singleFamily;
        case 1:
        case "singleFamilyAndBasement":
            return PropertyType.singleFamilyAndBasement;
        case 2:
        case "duplex":
            return PropertyType.duplex;
        case 3:
        case "triplex":
            return PropertyType.triplex;
        case 4:
        case "fourplex":
            return PropertyType.fourplex;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PropertyType.UNRECOGNIZED;
    }
}
function propertyTypeToJSON(object) {
    switch (object) {
        case PropertyType.singleFamily:
            return "singleFamily";
        case PropertyType.singleFamilyAndBasement:
            return "singleFamilyAndBasement";
        case PropertyType.duplex:
            return "duplex";
        case PropertyType.triplex:
            return "triplex";
        case PropertyType.fourplex:
            return "fourplex";
        case PropertyType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AreaPageListing_ListingType;
(function (AreaPageListing_ListingType) {
    AreaPageListing_ListingType[AreaPageListing_ListingType["Unspecified"] = 0] = "Unspecified";
    AreaPageListing_ListingType[AreaPageListing_ListingType["rent"] = 1] = "rent";
    AreaPageListing_ListingType[AreaPageListing_ListingType["buy"] = 2] = "buy";
    AreaPageListing_ListingType[AreaPageListing_ListingType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AreaPageListing_ListingType || (exports.AreaPageListing_ListingType = AreaPageListing_ListingType = {}));
function areaPageListing_ListingTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "Unspecified":
            return AreaPageListing_ListingType.Unspecified;
        case 1:
        case "rent":
            return AreaPageListing_ListingType.rent;
        case 2:
        case "buy":
            return AreaPageListing_ListingType.buy;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AreaPageListing_ListingType.UNRECOGNIZED;
    }
}
function areaPageListing_ListingTypeToJSON(object) {
    switch (object) {
        case AreaPageListing_ListingType.Unspecified:
            return "Unspecified";
        case AreaPageListing_ListingType.rent:
            return "rent";
        case AreaPageListing_ListingType.buy:
            return "buy";
        case AreaPageListing_ListingType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
var AreaPageListing_Status;
(function (AreaPageListing_Status) {
    AreaPageListing_Status[AreaPageListing_Status["Unknown"] = 0] = "Unknown";
    AreaPageListing_Status[AreaPageListing_Status["Deleted"] = -1] = "Deleted";
    /** Duplicate - duplicate found marking before deleting. */
    AreaPageListing_Status[AreaPageListing_Status["Duplicate"] = -10] = "Duplicate";
    AreaPageListing_Status[AreaPageListing_Status["Available"] = 1] = "Available";
    AreaPageListing_Status[AreaPageListing_Status["NotAvailable"] = 2] = "NotAvailable";
    /** NotAvailableSold - Not available, sold. */
    AreaPageListing_Status[AreaPageListing_Status["NotAvailableSold"] = 3] = "NotAvailableSold";
    /** NotAvailableOther - Not available, not sold. */
    AreaPageListing_Status[AreaPageListing_Status["NotAvailableOther"] = 4] = "NotAvailableOther";
    /** NoGeometryData - The property cannot be geolocated and has not geolocation data. */
    AreaPageListing_Status[AreaPageListing_Status["NoGeometryData"] = -2] = "NoGeometryData";
})(AreaPageListing_Status || (exports.AreaPageListing_Status = AreaPageListing_Status = {}));
function areaPageListing_StatusFromJSON(object) {
    switch (object) {
        case 0:
        case "Unknown":
            return AreaPageListing_Status.Unknown;
        case -1:
        case "Deleted":
            return AreaPageListing_Status.Deleted;
        case -10:
        case "Duplicate":
            return AreaPageListing_Status.Duplicate;
        case 1:
        case "Available":
            return AreaPageListing_Status.Available;
        case 2:
        case "NotAvailable":
            return AreaPageListing_Status.NotAvailable;
        case 3:
        case "NotAvailableSold":
            return AreaPageListing_Status.NotAvailableSold;
        case 4:
        case "NotAvailableOther":
            return AreaPageListing_Status.NotAvailableOther;
        case -2:
        case "NoGeometryData":
            return AreaPageListing_Status.NoGeometryData;
        default:
            return AreaPageListing_Status.Deleted;
    }
}
function areaPageListing_StatusToJSON(object) {
    switch (object) {
        case AreaPageListing_Status.Unknown:
            return "Unknown";
        case AreaPageListing_Status.Deleted:
            return "Deleted";
        case AreaPageListing_Status.Duplicate:
            return "Duplicate";
        case AreaPageListing_Status.Available:
            return "Available";
        case AreaPageListing_Status.NotAvailable:
            return "NotAvailable";
        case AreaPageListing_Status.NotAvailableSold:
            return "NotAvailableSold";
        case AreaPageListing_Status.NotAvailableOther:
            return "NotAvailableOther";
        case AreaPageListing_Status.NoGeometryData:
            return "NoGeometryData";
        default:
            return "Deleted";
    }
}
var AreaPageListing_Provider;
(function (AreaPageListing_Provider) {
    AreaPageListing_Provider[AreaPageListing_Provider["NoProvider"] = 0] = "NoProvider";
    AreaPageListing_Provider[AreaPageListing_Provider["VrebIdx"] = 30005] = "VrebIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["LdonIdx"] = 30010] = "LdonIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["NsarIdx"] = 30003] = "NsarIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["NsarVow"] = 30004] = "NsarVow";
    AreaPageListing_Provider[AreaPageListing_Provider["AlbIdx"] = 30006] = "AlbIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["CrebIdx"] = 30012] = "CrebIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["BrcIdx"] = 30008] = "BrcIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["TrebVow"] = 30000] = "TrebVow";
    AreaPageListing_Provider[AreaPageListing_Provider["TrebIdx"] = 30001] = "TrebIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["RahbIdx"] = 30007] = "RahbIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["ItsoIdx"] = 30009] = "ItsoIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["OrebVow"] = 30011] = "OrebVow";
    AreaPageListing_Provider[AreaPageListing_Provider["CreaDdf"] = 30002] = "CreaDdf";
    AreaPageListing_Provider[AreaPageListing_Provider["ItsoVow"] = 31013] = "ItsoVow";
    AreaPageListing_Provider[AreaPageListing_Provider["Pillar9Idx"] = 31014] = "Pillar9Idx";
    AreaPageListing_Provider[AreaPageListing_Provider["Pillar9Vow"] = 31015] = "Pillar9Vow";
    AreaPageListing_Provider[AreaPageListing_Provider["RebgvIdx"] = 31016] = "RebgvIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["RebgvVow"] = 31017] = "RebgvVow";
    AreaPageListing_Provider[AreaPageListing_Provider["StellarMlsIdx"] = 31018] = "StellarMlsIdx";
    AreaPageListing_Provider[AreaPageListing_Provider["MiamiSefIdxPlus"] = 31019] = "MiamiSefIdxPlus";
    AreaPageListing_Provider[AreaPageListing_Provider["BrightMls"] = 31020] = "BrightMls";
    AreaPageListing_Provider[AreaPageListing_Provider["AberdeenBoardOfRealtors"] = 31021] = "AberdeenBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AdirondackChamplainValleyMls"] = 31022] = "AdirondackChamplainValleyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["AikenMls"] = 31023] = "AikenMls";
    AreaPageListing_Provider[AreaPageListing_Provider["AlamanceMultipleListingService"] = 31024] = "AlamanceMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["AlaskaMultipleListingService"] = 31025] = "AlaskaMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["AlleghenyHighlandAssociationOfRealtors"] = 31026] = "AlleghenyHighlandAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AmeliaIslandundefinedNassauCountyAssociationOfRealtors"] = 31027] = "AmeliaIslandundefinedNassauCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ArizonaRegionalMultipleListingService"] = 31028] = "ArizonaRegionalMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["ArizonaRegionalMultipleListingServiceExpPortalOnly"] = 31029] = "ArizonaRegionalMultipleListingServiceExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["AshlandAreaBoardOfRealtors"] = 31030] = "AshlandAreaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AshlandBoardOfRealtors"] = 31031] = "AshlandBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AspenGlenwoodMls"] = 31032] = "AspenGlenwoodMls";
    AreaPageListing_Provider[AreaPageListing_Provider["AssociatedMultilistServicesOfOklahoma"] = 31033] = "AssociatedMultilistServicesOfOklahoma";
    AreaPageListing_Provider[AreaPageListing_Provider["AthensAreaAssociationOfRealtors"] = 31034] = "AthensAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AthensCountyBoardOfRealtors"] = 31035] = "AthensCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["AustinCentralTexasRealtyInformationService"] = 31036] = "AustinCentralTexasRealtyInformationService";
    AreaPageListing_Provider[AreaPageListing_Provider["BadlandsBoardOfRealtorsIncMls"] = 31037] = "BadlandsBoardOfRealtorsIncMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BakersfieldAssociationOfRealtors"] = 31038] = "BakersfieldAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BaldwinRealtors"] = 31039] = "BaldwinRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BayAreaRealEstateInformationServicesInc"] = 31040] = "BayAreaRealEstateInformationServicesInc";
    AreaPageListing_Provider[AreaPageListing_Provider["BeachesMls"] = 31041] = "BeachesMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BeachesMlsExpPortalOnly"] = 31042] = "BeachesMlsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["BeaumontBoardOfRealtorsIncMls"] = 31043] = "BeaumontBoardOfRealtorsIncMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BerkshireCountyBoardOfRealtors"] = 31044] = "BerkshireCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BigSkyCountryMls"] = 31045] = "BigSkyCountryMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BillingsAssociationOfRealtors"] = 31046] = "BillingsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BillingsAssociationOfRealtorsExpPortalOnly"] = 31047] = "BillingsAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["BismarckMandanBoardOfRealtors"] = 31048] = "BismarckMandanBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BlackHillsAssociationOfRealtors"] = 31049] = "BlackHillsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BluegrassRealtors"] = 31050] = "BluegrassRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BonitaSpringsEsteroAssociationOfRealtors"] = 31051] = "BonitaSpringsEsteroAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["Brasil"] = 31052] = "Brasil";
    AreaPageListing_Provider[AreaPageListing_Provider["BrazoriaCountyBoardOfRealtors"] = 31053] = "BrazoriaCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["BrooklynNewYorkMls"] = 31054] = "BrooklynNewYorkMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BrunswickCountyMls"] = 31055] = "BrunswickCountyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["BryancollegeStationRegionalMls"] = 31056] = "BryancollegeStationRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CalaverasCountyAssociationOfRealtors"] = 31057] = "CalaverasCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CaliforniaRegionalMultipleListingService"] = 31058] = "CaliforniaRegionalMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["CambriaSomersetAssociationOfRealtors"] = 31059] = "CambriaSomersetAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CanopyMls"] = 31060] = "CanopyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CapeCodundefinedIslandsAssociationOfRealtors"] = 31061] = "CapeCodundefinedIslandsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CapeFearRealtors"] = 31062] = "CapeFearRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CapeMayCountyAssociationOfRealtors"] = 31063] = "CapeMayCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CapitalAreaTechnologyRealtorServices"] = 31064] = "CapitalAreaTechnologyRealtorServices";
    AreaPageListing_Provider[AreaPageListing_Provider["CarpetCapitalAssociationOfRealtors"] = 31065] = "CarpetCapitalAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CarpetCapitalAssociationOfRealtorsExpPortalOnly"] = 31066] = "CarpetCapitalAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["CarteretCountyAssociationOfRealtors"] = 31067] = "CarteretCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CedarRapidsAreaAssociationOfRealtors"] = 31068] = "CedarRapidsAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralGeorgiaMls"] = 31069] = "CentralGeorgiaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralGeorgiaMlsExpPortalOnly"] = 31070] = "CentralGeorgiaMlsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralHillCountryBoardOfRealtors"] = 31071] = "CentralHillCountryBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralIllinoisBoardOfRealtors"] = 31072] = "CentralIllinoisBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralJerseyMultipleListingSystemInc"] = 31073] = "CentralJerseyMultipleListingSystemInc";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralMississippiMls"] = 31074] = "CentralMississippiMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralPanhandleAssociationOfRealtors"] = 31075] = "CentralPanhandleAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralSusquehannaValleyBoardOfRealtors"] = 31076] = "CentralSusquehannaValleyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralTexasMultipleListingService"] = 31077] = "CentralTexasMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralVirginiaRegionalMultipleListingService"] = 31078] = "CentralVirginiaRegionalMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralWestTennesseeAssociationOfRealtors"] = 31079] = "CentralWestTennesseeAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CentralWisconsinMls"] = 31080] = "CentralWisconsinMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CharlottesvilleAreaAssociationOfRealtors"] = 31081] = "CharlottesvilleAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ChsRegionalMls"] = 31082] = "ChsRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["ClatsopAssociationOfRealtors"] = 31083] = "ClatsopAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ClearfieldjeffersonAssociationOfRealtors"] = 31084] = "ClearfieldjeffersonAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CoastalCarolinaAssociationOfRealtors"] = 31085] = "CoastalCarolinaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["CoeurDaleneMultipleListingService"] = 31086] = "CoeurDaleneMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["ColoradoRealEstateNetworkInc"] = 31087] = "ColoradoRealEstateNetworkInc";
    AreaPageListing_Provider[AreaPageListing_Provider["Columbia"] = 31088] = "Columbia";
    AreaPageListing_Provider[AreaPageListing_Provider["ColumbiaBoardOfRealtors"] = 31089] = "ColumbiaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ColumbiaGreeneAndNorthernDutchessMls"] = 31090] = "ColumbiaGreeneAndNorthernDutchessMls";
    AreaPageListing_Provider[AreaPageListing_Provider["ColumbusAndCentralOhioMultipleListingService"] = 31091] = "ColumbusAndCentralOhioMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["ColumbusBoardOfRealtors"] = 31092] = "ColumbusBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ConsolidatedMlsInc"] = 31093] = "ConsolidatedMlsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["ContraCostaAorBayEastAorAndBridgeMls"] = 31094] = "ContraCostaAorBayEastAorAndBridgeMls";
    AreaPageListing_Provider[AreaPageListing_Provider["CooperativeArkansasRealtorsMultipleListingService"] = 31095] = "CooperativeArkansasRealtorsMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["CorpusChristiAssociationOfRealtors"] = 31096] = "CorpusChristiAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["Crea"] = 31097] = "Crea";
    AreaPageListing_Provider[AreaPageListing_Provider["DaytonaBeachAreaAssociationOfRealtors"] = 31098] = "DaytonaBeachAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["DaytonRealtorsMls"] = 31099] = "DaytonRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["DemoMls"] = 31100] = "DemoMls";
    AreaPageListing_Provider[AreaPageListing_Provider["DesMoinesAreaAssociationOfRealtorsInc"] = 31101] = "DesMoinesAreaAssociationOfRealtorsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["DixieGilchristLevyCountiesBoardOfRealtors"] = 31102] = "DixieGilchristLevyCountiesBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["DominicanRepublic"] = 31103] = "DominicanRepublic";
    AreaPageListing_Provider[AreaPageListing_Provider["DublinBoardOfRealtors"] = 31104] = "DublinBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["DummyMlsForQa"] = 31105] = "DummyMlsForQa";
    AreaPageListing_Provider[AreaPageListing_Provider["ElkoCountyBoardOfRealtors"] = 31106] = "ElkoCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ElmiracorningRegionalBoardOfRealtorsMls"] = 31107] = "ElmiracorningRegionalBoardOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["EmeraldCoastAssociationOfRealtors"] = 31108] = "EmeraldCoastAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["EmeraldCoastAssociationOfRealtorsExpPortalOnly"] = 31109] = "EmeraldCoastAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal1"] = 31110] = "ExpPortal1";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal10"] = 31111] = "ExpPortal10";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal11"] = 31112] = "ExpPortal11";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal12"] = 31113] = "ExpPortal12";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal13"] = 31114] = "ExpPortal13";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal14"] = 31115] = "ExpPortal14";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal15"] = 31116] = "ExpPortal15";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal18"] = 31117] = "ExpPortal18";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal19"] = 31118] = "ExpPortal19";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal2"] = 31119] = "ExpPortal2";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal20"] = 31120] = "ExpPortal20";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal21"] = 31121] = "ExpPortal21";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal22"] = 31122] = "ExpPortal22";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal23"] = 31123] = "ExpPortal23";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal24Smart"] = 31124] = "ExpPortal24Smart";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal24CrMls"] = 31125] = "ExpPortal24CrMls";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal3"] = 31126] = "ExpPortal3";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal4"] = 31127] = "ExpPortal4";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal5"] = 31128] = "ExpPortal5";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal6"] = 31129] = "ExpPortal6";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal7"] = 31130] = "ExpPortal7";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal8"] = 31131] = "ExpPortal8";
    AreaPageListing_Provider[AreaPageListing_Provider["ExpPortal9"] = 31132] = "ExpPortal9";
    AreaPageListing_Provider[AreaPageListing_Provider["FargoMoorheadAreaAssociationOfRealtors"] = 31133] = "FargoMoorheadAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["FirelandsMls"] = 31134] = "FirelandsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["FirstMultipleListingService"] = 31135] = "FirstMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["FlintHillsAssociationOfRealtors"] = 31136] = "FlintHillsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["FloridaKeysBoardOfRealtors"] = 31137] = "FloridaKeysBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["FortDodgeMls"] = 31138] = "FortDodgeMls";
    AreaPageListing_Provider[AreaPageListing_Provider["France"] = 31139] = "France";
    AreaPageListing_Provider[AreaPageListing_Provider["FresnoMls"] = 31140] = "FresnoMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GalvestonAssociationOfRealtorsMls"] = 31141] = "GalvestonAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GardenStateMls"] = 31142] = "GardenStateMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GardenStateMlsExpPortalOnly"] = 31143] = "GardenStateMlsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["GeorgiaMultipleListingService"] = 31144] = "GeorgiaMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["Germany"] = 31145] = "Germany";
    AreaPageListing_Provider[AreaPageListing_Provider["GlobalMlsInc"] = 31146] = "GlobalMlsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["GoldsboroWayneCountyAssociationOfRealtors"] = 31147] = "GoldsboroWayneCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GrandCountyBoardOfRealtors"] = 31148] = "GrandCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GrandIslandBoardOfRealtors"] = 31149] = "GrandIslandBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GrandJunctionAreaRealtorsAssociationMls"] = 31150] = "GrandJunctionAreaRealtorsAssociationMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterAlabamaMls"] = 31151] = "GreaterAlabamaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterAntelopeValleyAssociationOfRealtors"] = 31152] = "GreaterAntelopeValleyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterAugustaAssociationOfRealtors"] = 31153] = "GreaterAugustaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterBatonRougeAssociationOfRealtors"] = 31154] = "GreaterBatonRougeAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterChattanoogaAssociationOfRealtors"] = 31155] = "GreaterChattanoogaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterChattanoogaAssociationOfRealtorsExpPortalOnly"] = 31156] = "GreaterChattanoogaAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterElPasoAssociationOfRealtors"] = 31157] = "GreaterElPasoAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterErieBoardOfRealtorsMls"] = 31158] = "GreaterErieBoardOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterGreenvilleAssociationOfRealtors"] = 31159] = "GreaterGreenvilleAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterLasVegasAssociationOfRealtorsInc"] = 31160] = "GreaterLasVegasAssociationOfRealtorsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterLehighValleyRealtors"] = 31161] = "GreaterLehighValleyRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterLouisvilleAssociationOfRealtors"] = 31162] = "GreaterLouisvilleAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterMasonCityBoardOfRealtors"] = 31163] = "GreaterMasonCityBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterMcallenAssociationOfRealtors"] = 31164] = "GreaterMcallenAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterRegionalAssociationOfRealtors"] = 31411] = "GreaterRegionalAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterNorthwestIndianaAssociationOfRealtors"] = 31165] = "GreaterNorthwestIndianaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterOwensboroRealtorAssociation"] = 31166] = "GreaterOwensboroRealtorAssociation";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterPortsmouthAreaMultipleListingService"] = 31167] = "GreaterPortsmouthAreaMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterSouthernMls"] = 31168] = "GreaterSouthernMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterTylerAssociationOfRealtors"] = 31169] = "GreaterTylerAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GreaterTylerAssociationOfRealtorsExpPortalOnly"] = 31170] = "GreaterTylerAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["GreatPlainsRegionalMls"] = 31171] = "GreatPlainsRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreatSmokyMountainsAssociationOfRealtors"] = 31172] = "GreatSmokyMountainsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["Greece"] = 31173] = "Greece";
    AreaPageListing_Provider[AreaPageListing_Provider["GreenvillepittAssociationOfRealtorsMls"] = 31174] = "GreenvillepittAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["GreenwichAssociationOfRealtors"] = 31175] = "GreenwichAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["GulfCoastMultipleListingService"] = 31176] = "GulfCoastMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["GulfSouthRealEstateInformationNetwork"] = 31177] = "GulfSouthRealEstateInformationNetwork";
    AreaPageListing_Provider[AreaPageListing_Provider["HattiesburgAreaAssociationOfRealtors"] = 31178] = "HattiesburgAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HawaiiInformationService"] = 31179] = "HawaiiInformationService";
    AreaPageListing_Provider[AreaPageListing_Provider["HeartlandAssociationOfRealtors"] = 31180] = "HeartlandAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HeartlandMls"] = 31181] = "HeartlandMls";
    AreaPageListing_Provider[AreaPageListing_Provider["HeartOfKentuckyAssociationOfRealtors"] = 31182] = "HeartOfKentuckyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HernandoCountyAssociationOfRealtors"] = 31183] = "HernandoCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HighCountryAssociationOfRealtors"] = 31184] = "HighCountryAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HighlandLakesAssociationOfRealtorsMls"] = 31185] = "HighlandLakesAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["HighlandsCashiersBoardOfRealtors"] = 31186] = "HighlandsCashiersBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HinesvilleAreaBoardOfRealtorsIncMls"] = 31187] = "HinesvilleAreaBoardOfRealtorsIncMls";
    AreaPageListing_Provider[AreaPageListing_Provider["HonoluluBoardOfRealtors"] = 31188] = "HonoluluBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HonoluluBoardOfRealtorsExp"] = 31189] = "HonoluluBoardOfRealtorsExp";
    AreaPageListing_Provider[AreaPageListing_Provider["HopkinsvilleChristianCountyBoardOfRealtors"] = 31190] = "HopkinsvilleChristianCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HotSpringsBoardOfRealtors"] = 31191] = "HotSpringsBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["HoustonRealtorsInformationService"] = 31192] = "HoustonRealtorsInformationService";
    AreaPageListing_Provider[AreaPageListing_Provider["HudsonCountyMultipleListingService"] = 31193] = "HudsonCountyMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["HumboldtCountyMls"] = 31194] = "HumboldtCountyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["InclineVillageBoardOfRealtors"] = 31195] = "InclineVillageBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["India"] = 31196] = "India";
    AreaPageListing_Provider[AreaPageListing_Provider["IndianaRegionalMls"] = 31197] = "IndianaRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["InformationAndRealEstateServices"] = 31198] = "InformationAndRealEstateServices";
    AreaPageListing_Provider[AreaPageListing_Provider["IntermountainMultipleListingService"] = 31199] = "IntermountainMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["IowaAssociationOfRealtors"] = 31200] = "IowaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["IowaGreatLakesBoardOfRealtors"] = 31201] = "IowaGreatLakesBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["Israel"] = 31202] = "Israel";
    AreaPageListing_Provider[AreaPageListing_Provider["Italy"] = 31203] = "Italy";
    AreaPageListing_Provider[AreaPageListing_Provider["JacksonvilleBoardOfRealtorsNc"] = 31204] = "JacksonvilleBoardOfRealtorsNc";
    AreaPageListing_Provider[AreaPageListing_Provider["JeffersonCityAreaBoardOfRealtors"] = 31205] = "JeffersonCityAreaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["KanabUtMls"] = 31206] = "KanabUtMls";
    AreaPageListing_Provider[AreaPageListing_Provider["KanawhaValleyBoardOfRealtors"] = 31207] = "KanawhaValleyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["KeyWestAssociationOfRealtorsMls"] = 31208] = "KeyWestAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["KnoxvilleAreaAssociationOfRealtors"] = 31209] = "KnoxvilleAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LakeCountryBoardOfRealtors"] = 31210] = "LakeCountryBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LakeHavasuAssociationMls"] = 31211] = "LakeHavasuAssociationMls";
    AreaPageListing_Provider[AreaPageListing_Provider["LakeSuperiorAreaRealtors"] = 31212] = "LakeSuperiorAreaRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LakewayAreaAssociationOfRealtors"] = 31213] = "LakewayAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LawrenceBoardOfRealtors"] = 31214] = "LawrenceBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LeeCountyAssociationOfRealtors"] = 31215] = "LeeCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LincolnCountyBoardOfRealtors"] = 31216] = "LincolnCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LongleafPineRealtors"] = 31217] = "LongleafPineRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LongviewAreaAssociationOfRealtors"] = 31218] = "LongviewAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LowcountryRegionalMultipleListingServiceInc"] = 31219] = "LowcountryRegionalMultipleListingServiceInc";
    AreaPageListing_Provider[AreaPageListing_Provider["LubbockAssociationOfRealtors"] = 31220] = "LubbockAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["LynchburgVirginiaMls"] = 31221] = "LynchburgVirginiaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MaineRealEstateInformationSystemInc"] = 31222] = "MaineRealEstateInformationSystemInc";
    AreaPageListing_Provider[AreaPageListing_Provider["MansfieldAssociationOfRealtors"] = 31223] = "MansfieldAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["MarcoIslandAreaAssociationOfRealtors"] = 31224] = "MarcoIslandAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["MarthasVineyardMls"] = 31225] = "MarthasVineyardMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MartinCountyRealtorsOfTheTreasureCoast"] = 31226] = "MartinCountyRealtorsOfTheTreasureCoast";
    AreaPageListing_Provider[AreaPageListing_Provider["MemphisAreaAssociationOfRealtors"] = 31227] = "MemphisAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["MercerTazewellCoBor"] = 31228] = "MercerTazewellCoBor";
    AreaPageListing_Provider[AreaPageListing_Provider["MetrolistCa"] = 31229] = "MetrolistCa";
    AreaPageListing_Provider[AreaPageListing_Provider["MetroMls"] = 31230] = "MetroMls";
    AreaPageListing_Provider[AreaPageListing_Provider["Mexico"] = 31231] = "Mexico";
    AreaPageListing_Provider[AreaPageListing_Provider["MiborServiceCorporation"] = 31232] = "MiborServiceCorporation";
    AreaPageListing_Provider[AreaPageListing_Provider["MichiganRegionalInformationCenter"] = 31233] = "MichiganRegionalInformationCenter";
    AreaPageListing_Provider[AreaPageListing_Provider["MidAmericaRegionalInformationSystems"] = 31234] = "MidAmericaRegionalInformationSystems";
    AreaPageListing_Provider[AreaPageListing_Provider["MiddleGeorgiaMls"] = 31235] = "MiddleGeorgiaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MiddleTennesseeRegionalMls"] = 31236] = "MiddleTennesseeRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MidhudsonMultipleListingService"] = 31237] = "MidhudsonMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["MidwestRealEstateData"] = 31238] = "MidwestRealEstateData";
    AreaPageListing_Provider[AreaPageListing_Provider["MilledgevilleMls"] = 31239] = "MilledgevilleMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsListingsInc"] = 31240] = "MlsListingsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsNow"] = 31241] = "MlsNow";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsOfCentralOregon"] = 31242] = "MlsOfCentralOregon";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsOfGreaterCincinnatiInc"] = 31243] = "MlsOfGreaterCincinnatiInc";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsOfYakimaAssociation"] = 31244] = "MlsOfYakimaAssociation";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsPropertyInformationNetwork"] = 31245] = "MlsPropertyInformationNetwork";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsTechnology"] = 31246] = "MlsTechnology";
    AreaPageListing_Provider[AreaPageListing_Provider["MlsUnited"] = 31247] = "MlsUnited";
    AreaPageListing_Provider[AreaPageListing_Provider["MonmouthoceanMultipleListingService"] = 31248] = "MonmouthoceanMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["MontanaRegionalMls"] = 31249] = "MontanaRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MontgomeryAreaAssociationOfRealtorsMls"] = 31250] = "MontgomeryAreaAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["MountainLakesBoardOfRealtors"] = 31251] = "MountainLakesBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["MtRushmoreAreaAssociationOfRealtors"] = 31252] = "MtRushmoreAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["MultipleListingServiceMirealsource"] = 31253] = "MultipleListingServiceMirealsource";
    AreaPageListing_Provider[AreaPageListing_Provider["MultipleListingServiceOfHiltonHeadIslandInc"] = 31254] = "MultipleListingServiceOfHiltonHeadIslandInc";
    AreaPageListing_Provider[AreaPageListing_Provider["MultipleListingServiceOfSouthernArizona"] = 31255] = "MultipleListingServiceOfSouthernArizona";
    AreaPageListing_Provider[AreaPageListing_Provider["NaplesAreaBoardOfRealtors"] = 31256] = "NaplesAreaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NeuseRiverRegionMlsInc"] = 31257] = "NeuseRiverRegionMlsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["NewCanaanBoardOfRealtors"] = 31258] = "NewCanaanBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NewJerseyMls"] = 31259] = "NewJerseyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["NewSmyrnaBeachBoardOfRealtors"] = 31260] = "NewSmyrnaBeachBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NewYorkStateAllianceOfMlss"] = 31261] = "NewYorkStateAllianceOfMlss";
    AreaPageListing_Provider[AreaPageListing_Provider["NewZealand"] = 31262] = "NewZealand";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthCentralWestVirginiaRealEstateInformationNetwork"] = 31263] = "NorthCentralWestVirginiaRealEstateInformationNetwork";
    AreaPageListing_Provider[AreaPageListing_Provider["NortheastArkansasBoardOfRealtors"] = 31264] = "NortheastArkansasBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NortheastGeorgiaBoardOfRealtors"] = 31265] = "NortheastGeorgiaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NortheastIowaRegionalBoardOfRealtors"] = 31266] = "NortheastIowaRegionalBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NortheastLouisianaAssociationOfRealtors"] = 31267] = "NortheastLouisianaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NortheastOklahomaBoardOfRealtors"] = 31268] = "NortheastOklahomaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthernArizonaAssociationOfRealtors"] = 31269] = "NorthernArizonaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthernGreatLakesRealtorsMls"] = 31270] = "NorthernGreatLakesRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthernKentuckyMultipleListingService"] = 31271] = "NorthernKentuckyMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthernNevadaRegionalMlsInc"] = 31272] = "NorthernNevadaRegionalMlsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthFloridaMls"] = 31273] = "NorthFloridaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthSantaBarbaraCountyRegionalMls"] = 31274] = "NorthSantaBarbaraCountyRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["Northstarmls"] = 31275] = "Northstarmls";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthTexasRealEstateInformationSystems"] = 31276] = "NorthTexasRealEstateInformationSystems";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwestArkansasBoardOfRealtors"] = 31277] = "NorthwestArkansasBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwesternWisconsinMultipleListingService"] = 31278] = "NorthwesternWisconsinMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwestIowaMls"] = 31279] = "NorthwestIowaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwestMississippiAssociationOfRealtors"] = 31280] = "NorthwestMississippiAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwestMls"] = 31281] = "NorthwestMls";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwestOhioRealEstateInformationSystems"] = 31282] = "NorthwestOhioRealEstateInformationSystems";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthwoodsAssociationOfRealtors"] = 31283] = "NorthwoodsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["OldKentuckyHomeBoardOfRealtors"] = 31284] = "OldKentuckyHomeBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["OnekeyMls"] = 31285] = "OnekeyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["OuterBanksAssociationOfRealtors"] = 31286] = "OuterBanksAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["OzarkGatewayAssociationOfRealtors"] = 31287] = "OzarkGatewayAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PacificRegionalMls"] = 31288] = "PacificRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["PageLakePowellMls"] = 31289] = "PageLakePowellMls";
    AreaPageListing_Provider[AreaPageListing_Provider["PalestineAssociationOfRealtors"] = 31290] = "PalestineAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PalmBeachBoardOfRealtors"] = 31291] = "PalmBeachBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PalmettoMultipleListingService"] = 31292] = "PalmettoMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["Panama"] = 31293] = "Panama";
    AreaPageListing_Provider[AreaPageListing_Provider["ParkCityBoardOfRealtors"] = 31294] = "ParkCityBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PearlRiverCountyBoardOfRealtors"] = 31295] = "PearlRiverCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PensacolaAssociationOfRealtors"] = 31296] = "PensacolaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PermianBasinBoardOfRealtors"] = 31297] = "PermianBasinBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PikesPeakAssociationOfRealtors"] = 31298] = "PikesPeakAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PikewayneAssociationOfRealtorsMls"] = 31299] = "PikewayneAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["PoconoMountainsAssociationOfRealtors"] = 31300] = "PoconoMountainsAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PortNechesPortArthurNederlandBoardOfRealtorsIncMls"] = 31301] = "PortNechesPortArthurNederlandBoardOfRealtorsIncMls";
    AreaPageListing_Provider[AreaPageListing_Provider["Portugal"] = 31302] = "Portugal";
    AreaPageListing_Provider[AreaPageListing_Provider["PrescottAreaAssociationOfRealtors"] = 31303] = "PrescottAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["Primemls"] = 31304] = "Primemls";
    AreaPageListing_Provider[AreaPageListing_Provider["PuebloAssociationOfRealtors"] = 31305] = "PuebloAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["PuertoRico"] = 31306] = "PuertoRico";
    AreaPageListing_Provider[AreaPageListing_Provider["Qamls2"] = 31307] = "Qamls2";
    AreaPageListing_Provider[AreaPageListing_Provider["Qamls3"] = 31308] = "Qamls3";
    AreaPageListing_Provider[AreaPageListing_Provider["Qamls4"] = 31309] = "Qamls4";
    AreaPageListing_Provider[AreaPageListing_Provider["RandolphCountyBoardOfRealtors"] = 31310] = "RandolphCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RangeAssociationOfRealtors"] = 31311] = "RangeAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RealcompLimitedIi"] = 31312] = "RealcompLimitedIi";
    AreaPageListing_Provider[AreaPageListing_Provider["RealEstateInformationNetworkInc"] = 31313] = "RealEstateInformationNetworkInc";
    AreaPageListing_Provider[AreaPageListing_Provider["Realmls"] = 31314] = "Realmls";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfAcadiana"] = 31315] = "RealtorAssociationOfAcadiana";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfFranklinAndGulfCounties"] = 31316] = "RealtorAssociationOfFranklinAndGulfCounties";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfNortheastWisconsin"] = 31317] = "RealtorAssociationOfNortheastWisconsin";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfSouthernKentuckyInc"] = 31318] = "RealtorAssociationOfSouthernKentuckyInc";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfSouthernMinnesota"] = 31319] = "RealtorAssociationOfSouthernMinnesota";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorAssociationOfTheSiouxEmpireMls"] = 31320] = "RealtorAssociationOfTheSiouxEmpireMls";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorsAssociationOfCitrusCounty"] = 31321] = "RealtorsAssociationOfCitrusCounty";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorsAssociationOfIndianRiverCounty"] = 31322] = "RealtorsAssociationOfIndianRiverCounty";
    AreaPageListing_Provider[AreaPageListing_Provider["RealtorsAssociationOfMauiInc"] = 31323] = "RealtorsAssociationOfMauiInc";
    AreaPageListing_Provider[AreaPageListing_Provider["Recolorado"] = 31324] = "Recolorado";
    AreaPageListing_Provider[AreaPageListing_Provider["RegionalMultipleListingServices"] = 31325] = "RegionalMultipleListingServices";
    AreaPageListing_Provider[AreaPageListing_Provider["RidgecrestAreaAssociationOfRealtors"] = 31326] = "RidgecrestAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RiverCountiesAssociationOfRealtors"] = 31327] = "RiverCountiesAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RmlsAllianceLlc"] = 31328] = "RmlsAllianceLlc";
    AreaPageListing_Provider[AreaPageListing_Provider["RoanokeValleyAssociationOfRealtors"] = 31329] = "RoanokeValleyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RockfordAreaMls"] = 31330] = "RockfordAreaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["RockyMountAreaAssociationOfRealtors"] = 31331] = "RockyMountAreaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RoyalPalmCoastRealtorAssociation"] = 31332] = "RoyalPalmCoastRealtorAssociation";
    AreaPageListing_Provider[AreaPageListing_Provider["RuidosolincolnCountyAssociationOfRealtors"] = 31333] = "RuidosolincolnCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["RussellvilleBoardOfRealtors"] = 31334] = "RussellvilleBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SanAngeloAssociationOfRealtors"] = 31335] = "SanAngeloAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SanAntonioBoardOfRealtors"] = 31336] = "SanAntonioBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SanDiegoMls"] = 31337] = "SanDiegoMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SanFranciscoAssociationOfRealtors"] = 31338] = "SanFranciscoAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SanJuanAssociationOfRealtors"] = 31339] = "SanJuanAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SantaBarbaraMultipleListingService"] = 31340] = "SantaBarbaraMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["SantaFeAssociationOfRealtorsInc"] = 31341] = "SantaFeAssociationOfRealtorsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["SavannahMultilistCorporation"] = 31342] = "SavannahMultilistCorporation";
    AreaPageListing_Provider[AreaPageListing_Provider["SciotoValleyAssociationOfRealtors"] = 31343] = "SciotoValleyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SedonaVerdeValleyAssociationOfRealtors"] = 31344] = "SedonaVerdeValleyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["ShastaMls"] = 31345] = "ShastaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SmartMls"] = 31346] = "SmartMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SnakeRiverRegionalMls"] = 31347] = "SnakeRiverRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthAfrica"] = 31348] = "SouthAfrica";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthBrowardBoardOfRealtors"] = 31349] = "SouthBrowardBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthCentralAssociationOfRealtorsMls"] = 31350] = "SouthCentralAssociationOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthCentralKansasMls"] = 31351] = "SouthCentralKansasMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthCentralWisconsinMlsCorporation"] = 31352] = "SouthCentralWisconsinMlsCorporation";
    AreaPageListing_Provider[AreaPageListing_Provider["SoutheastAlaskaMls"] = 31353] = "SoutheastAlaskaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SoutheastKansasMultipleListingSystem"] = 31354] = "SoutheastKansasMultipleListingSystem";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthernIndianaRealtorAssociation"] = 31355] = "SouthernIndianaRealtorAssociation";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthernMissouriRegionalMlsLlc"] = 31356] = "SouthernMissouriRegionalMlsLlc";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthernNewMexicoMls"] = 31357] = "SouthernNewMexicoMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthGeorgiaMls"] = 31358] = "SouthGeorgiaMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthJerseyShoreRegionalMls"] = 31359] = "SouthJerseyShoreRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthPadreIslandBoardOfRealtors"] = 31360] = "SouthPadreIslandBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthwestMls"] = 31361] = "SouthwestMls";
    AreaPageListing_Provider[AreaPageListing_Provider["SouthwestVirginiaAssociationOfRealtors"] = 31362] = "SouthwestVirginiaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SpaceCoastAssociationOfRealtors"] = 31363] = "SpaceCoastAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SpaceCoastAssociationOfRealtorsExpPortalOnly"] = 31364] = "SpaceCoastAssociationOfRealtorsExpPortalOnly";
    AreaPageListing_Provider[AreaPageListing_Provider["Spain"] = 31365] = "Spain";
    AreaPageListing_Provider[AreaPageListing_Provider["SpartanburgAssociationOfRealtorsInc"] = 31366] = "SpartanburgAssociationOfRealtorsInc";
    AreaPageListing_Provider[AreaPageListing_Provider["SpokaneAssociationOfRealtors"] = 31367] = "SpokaneAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["StatenIslandBoardOfRealtors"] = 31368] = "StatenIslandBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["StateWideMlsOfRhodeIslandInc"] = 31369] = "StateWideMlsOfRhodeIslandInc";
    AreaPageListing_Provider[AreaPageListing_Provider["StAugustineStJohnsCountyBoardOfRealtors"] = 31370] = "StAugustineStJohnsCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["StillwaterBoardOfRealtors"] = 31371] = "StillwaterBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["StrategicMlsAlliance"] = 31372] = "StrategicMlsAlliance";
    AreaPageListing_Provider[AreaPageListing_Provider["SummitAssociationOfRealtors"] = 31373] = "SummitAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["SunflowerAssociationOfRealtors"] = 31374] = "SunflowerAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TahoeSierraBoardOfRealtors"] = 31375] = "TahoeSierraBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TaosCountyAssociationOfRealtors"] = 31376] = "TaosCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TennesseeVirginiaRegionalMultipleListingService"] = 31377] = "TennesseeVirginiaRegionalMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["TetonBoardOfRealtors"] = 31378] = "TetonBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TexarkanaBoardOfRealtors"] = 31379] = "TexarkanaBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TillamookCountyBoardOfRealtorsMls"] = 31380] = "TillamookCountyBoardOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["TopsailIslandAssociationOfRealtors"] = 31381] = "TopsailIslandAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["TriadMultipleListingService"] = 31382] = "TriadMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["TriangleMls"] = 31383] = "TriangleMls";
    AreaPageListing_Provider[AreaPageListing_Provider["TrinityCountyMls"] = 31384] = "TrinityCountyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["TulareCountyMls"] = 31385] = "TulareCountyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["TuolumneCountyAssociationOfRealtors"] = 31386] = "TuolumneCountyAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["UlsterCountyBoardOfRealtorsMls"] = 31387] = "UlsterCountyBoardOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["UpperCumberlandAssociationOfRealtors"] = 31388] = "UpperCumberlandAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["UpperPeninsulaAssociationOfRealtors"] = 31389] = "UpperPeninsulaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["VailBoardOfRealtorsMls"] = 31390] = "VailBoardOfRealtorsMls";
    AreaPageListing_Provider[AreaPageListing_Provider["ValleyMls"] = 31391] = "ValleyMls";
    AreaPageListing_Provider[AreaPageListing_Provider["WacoAssociationOfRealtors"] = 31392] = "WacoAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WasatchFrontRegionalMls"] = 31393] = "WasatchFrontRegionalMls";
    AreaPageListing_Provider[AreaPageListing_Provider["WashingtonBeaufortCountyBoardOfRealtors"] = 31394] = "WashingtonBeaufortCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WashingtonCountyBoardOfRealtors"] = 31395] = "WashingtonCountyBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WestAlabamaMultipleListingService"] = 31396] = "WestAlabamaMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["WestCentralAssociationOfRealtors"] = 31397] = "WestCentralAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WestcliffeListingService"] = 31398] = "WestcliffeListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["WesternArizonaRealtorDataExchange"] = 31399] = "WesternArizonaRealtorDataExchange";
    AreaPageListing_Provider[AreaPageListing_Provider["WesternRegionalInformationSystemsAndTechnologyInc"] = 31400] = "WesternRegionalInformationSystemsAndTechnologyInc";
    AreaPageListing_Provider[AreaPageListing_Provider["WesternUpstateAssociationOfRealtors"] = 31401] = "WesternUpstateAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WestPennMultiList"] = 31402] = "WestPennMultiList";
    AreaPageListing_Provider[AreaPageListing_Provider["WheelingBoardOfRealtors"] = 31403] = "WheelingBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WhiteMountainAssociationOfRealtors"] = 31404] = "WhiteMountainAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WillametteValleyMultipleListingService"] = 31405] = "WillametteValleyMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["WilsonBoardOfRealtors"] = 31406] = "WilsonBoardOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["WinnipegRegionalRealEstateBoard"] = 31407] = "WinnipegRegionalRealEstateBoard";
    AreaPageListing_Provider[AreaPageListing_Provider["WyomingMls"] = 31408] = "WyomingMls";
    AreaPageListing_Provider[AreaPageListing_Provider["YumaAssociationOfRealtors"] = 31409] = "YumaAssociationOfRealtors";
    AreaPageListing_Provider[AreaPageListing_Provider["NorthCarolinaRegionalMultipleListingService"] = 31412] = "NorthCarolinaRegionalMultipleListingService";
    AreaPageListing_Provider[AreaPageListing_Provider["AgentUpload"] = 90000] = "AgentUpload";
    AreaPageListing_Provider[AreaPageListing_Provider["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AreaPageListing_Provider || (exports.AreaPageListing_Provider = AreaPageListing_Provider = {}));
function areaPageListing_ProviderFromJSON(object) {
    switch (object) {
        case 0:
        case "NoProvider":
            return AreaPageListing_Provider.NoProvider;
        case 30005:
        case "VrebIdx":
            return AreaPageListing_Provider.VrebIdx;
        case 30010:
        case "LdonIdx":
            return AreaPageListing_Provider.LdonIdx;
        case 30003:
        case "NsarIdx":
            return AreaPageListing_Provider.NsarIdx;
        case 30004:
        case "NsarVow":
            return AreaPageListing_Provider.NsarVow;
        case 30006:
        case "AlbIdx":
            return AreaPageListing_Provider.AlbIdx;
        case 30012:
        case "CrebIdx":
            return AreaPageListing_Provider.CrebIdx;
        case 30008:
        case "BrcIdx":
            return AreaPageListing_Provider.BrcIdx;
        case 30000:
        case "TrebVow":
            return AreaPageListing_Provider.TrebVow;
        case 30001:
        case "TrebIdx":
            return AreaPageListing_Provider.TrebIdx;
        case 30007:
        case "RahbIdx":
            return AreaPageListing_Provider.RahbIdx;
        case 30009:
        case "ItsoIdx":
            return AreaPageListing_Provider.ItsoIdx;
        case 30011:
        case "OrebVow":
            return AreaPageListing_Provider.OrebVow;
        case 30002:
        case "CreaDdf":
            return AreaPageListing_Provider.CreaDdf;
        case 31013:
        case "ItsoVow":
            return AreaPageListing_Provider.ItsoVow;
        case 31014:
        case "Pillar9Idx":
            return AreaPageListing_Provider.Pillar9Idx;
        case 31015:
        case "Pillar9Vow":
            return AreaPageListing_Provider.Pillar9Vow;
        case 31016:
        case "RebgvIdx":
            return AreaPageListing_Provider.RebgvIdx;
        case 31017:
        case "RebgvVow":
            return AreaPageListing_Provider.RebgvVow;
        case 31018:
        case "StellarMlsIdx":
            return AreaPageListing_Provider.StellarMlsIdx;
        case 31019:
        case "MiamiSefIdxPlus":
            return AreaPageListing_Provider.MiamiSefIdxPlus;
        case 31020:
        case "BrightMls":
            return AreaPageListing_Provider.BrightMls;
        case 31021:
        case "AberdeenBoardOfRealtors":
            return AreaPageListing_Provider.AberdeenBoardOfRealtors;
        case 31022:
        case "AdirondackChamplainValleyMls":
            return AreaPageListing_Provider.AdirondackChamplainValleyMls;
        case 31023:
        case "AikenMls":
            return AreaPageListing_Provider.AikenMls;
        case 31024:
        case "AlamanceMultipleListingService":
            return AreaPageListing_Provider.AlamanceMultipleListingService;
        case 31025:
        case "AlaskaMultipleListingService":
            return AreaPageListing_Provider.AlaskaMultipleListingService;
        case 31026:
        case "AlleghenyHighlandAssociationOfRealtors":
            return AreaPageListing_Provider.AlleghenyHighlandAssociationOfRealtors;
        case 31027:
        case "AmeliaIslandundefinedNassauCountyAssociationOfRealtors":
            return AreaPageListing_Provider.AmeliaIslandundefinedNassauCountyAssociationOfRealtors;
        case 31028:
        case "ArizonaRegionalMultipleListingService":
            return AreaPageListing_Provider.ArizonaRegionalMultipleListingService;
        case 31029:
        case "ArizonaRegionalMultipleListingServiceExpPortalOnly":
            return AreaPageListing_Provider.ArizonaRegionalMultipleListingServiceExpPortalOnly;
        case 31030:
        case "AshlandAreaBoardOfRealtors":
            return AreaPageListing_Provider.AshlandAreaBoardOfRealtors;
        case 31031:
        case "AshlandBoardOfRealtors":
            return AreaPageListing_Provider.AshlandBoardOfRealtors;
        case 31032:
        case "AspenGlenwoodMls":
            return AreaPageListing_Provider.AspenGlenwoodMls;
        case 31033:
        case "AssociatedMultilistServicesOfOklahoma":
            return AreaPageListing_Provider.AssociatedMultilistServicesOfOklahoma;
        case 31034:
        case "AthensAreaAssociationOfRealtors":
            return AreaPageListing_Provider.AthensAreaAssociationOfRealtors;
        case 31035:
        case "AthensCountyBoardOfRealtors":
            return AreaPageListing_Provider.AthensCountyBoardOfRealtors;
        case 31036:
        case "AustinCentralTexasRealtyInformationService":
            return AreaPageListing_Provider.AustinCentralTexasRealtyInformationService;
        case 31037:
        case "BadlandsBoardOfRealtorsIncMls":
            return AreaPageListing_Provider.BadlandsBoardOfRealtorsIncMls;
        case 31038:
        case "BakersfieldAssociationOfRealtors":
            return AreaPageListing_Provider.BakersfieldAssociationOfRealtors;
        case 31039:
        case "BaldwinRealtors":
            return AreaPageListing_Provider.BaldwinRealtors;
        case 31040:
        case "BayAreaRealEstateInformationServicesInc":
            return AreaPageListing_Provider.BayAreaRealEstateInformationServicesInc;
        case 31041:
        case "BeachesMls":
            return AreaPageListing_Provider.BeachesMls;
        case 31042:
        case "BeachesMlsExpPortalOnly":
            return AreaPageListing_Provider.BeachesMlsExpPortalOnly;
        case 31043:
        case "BeaumontBoardOfRealtorsIncMls":
            return AreaPageListing_Provider.BeaumontBoardOfRealtorsIncMls;
        case 31044:
        case "BerkshireCountyBoardOfRealtors":
            return AreaPageListing_Provider.BerkshireCountyBoardOfRealtors;
        case 31045:
        case "BigSkyCountryMls":
            return AreaPageListing_Provider.BigSkyCountryMls;
        case 31046:
        case "BillingsAssociationOfRealtors":
            return AreaPageListing_Provider.BillingsAssociationOfRealtors;
        case 31047:
        case "BillingsAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.BillingsAssociationOfRealtorsExpPortalOnly;
        case 31048:
        case "BismarckMandanBoardOfRealtors":
            return AreaPageListing_Provider.BismarckMandanBoardOfRealtors;
        case 31049:
        case "BlackHillsAssociationOfRealtors":
            return AreaPageListing_Provider.BlackHillsAssociationOfRealtors;
        case 31050:
        case "BluegrassRealtors":
            return AreaPageListing_Provider.BluegrassRealtors;
        case 31051:
        case "BonitaSpringsEsteroAssociationOfRealtors":
            return AreaPageListing_Provider.BonitaSpringsEsteroAssociationOfRealtors;
        case 31052:
        case "Brasil":
            return AreaPageListing_Provider.Brasil;
        case 31053:
        case "BrazoriaCountyBoardOfRealtors":
            return AreaPageListing_Provider.BrazoriaCountyBoardOfRealtors;
        case 31054:
        case "BrooklynNewYorkMls":
            return AreaPageListing_Provider.BrooklynNewYorkMls;
        case 31055:
        case "BrunswickCountyMls":
            return AreaPageListing_Provider.BrunswickCountyMls;
        case 31056:
        case "BryancollegeStationRegionalMls":
            return AreaPageListing_Provider.BryancollegeStationRegionalMls;
        case 31057:
        case "CalaverasCountyAssociationOfRealtors":
            return AreaPageListing_Provider.CalaverasCountyAssociationOfRealtors;
        case 31058:
        case "CaliforniaRegionalMultipleListingService":
            return AreaPageListing_Provider.CaliforniaRegionalMultipleListingService;
        case 31059:
        case "CambriaSomersetAssociationOfRealtors":
            return AreaPageListing_Provider.CambriaSomersetAssociationOfRealtors;
        case 31060:
        case "CanopyMls":
            return AreaPageListing_Provider.CanopyMls;
        case 31061:
        case "CapeCodundefinedIslandsAssociationOfRealtors":
            return AreaPageListing_Provider.CapeCodundefinedIslandsAssociationOfRealtors;
        case 31062:
        case "CapeFearRealtors":
            return AreaPageListing_Provider.CapeFearRealtors;
        case 31063:
        case "CapeMayCountyAssociationOfRealtors":
            return AreaPageListing_Provider.CapeMayCountyAssociationOfRealtors;
        case 31064:
        case "CapitalAreaTechnologyRealtorServices":
            return AreaPageListing_Provider.CapitalAreaTechnologyRealtorServices;
        case 31065:
        case "CarpetCapitalAssociationOfRealtors":
            return AreaPageListing_Provider.CarpetCapitalAssociationOfRealtors;
        case 31066:
        case "CarpetCapitalAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.CarpetCapitalAssociationOfRealtorsExpPortalOnly;
        case 31067:
        case "CarteretCountyAssociationOfRealtors":
            return AreaPageListing_Provider.CarteretCountyAssociationOfRealtors;
        case 31068:
        case "CedarRapidsAreaAssociationOfRealtors":
            return AreaPageListing_Provider.CedarRapidsAreaAssociationOfRealtors;
        case 31069:
        case "CentralGeorgiaMls":
            return AreaPageListing_Provider.CentralGeorgiaMls;
        case 31070:
        case "CentralGeorgiaMlsExpPortalOnly":
            return AreaPageListing_Provider.CentralGeorgiaMlsExpPortalOnly;
        case 31071:
        case "CentralHillCountryBoardOfRealtors":
            return AreaPageListing_Provider.CentralHillCountryBoardOfRealtors;
        case 31072:
        case "CentralIllinoisBoardOfRealtors":
            return AreaPageListing_Provider.CentralIllinoisBoardOfRealtors;
        case 31073:
        case "CentralJerseyMultipleListingSystemInc":
            return AreaPageListing_Provider.CentralJerseyMultipleListingSystemInc;
        case 31074:
        case "CentralMississippiMls":
            return AreaPageListing_Provider.CentralMississippiMls;
        case 31075:
        case "CentralPanhandleAssociationOfRealtors":
            return AreaPageListing_Provider.CentralPanhandleAssociationOfRealtors;
        case 31076:
        case "CentralSusquehannaValleyBoardOfRealtors":
            return AreaPageListing_Provider.CentralSusquehannaValleyBoardOfRealtors;
        case 31077:
        case "CentralTexasMultipleListingService":
            return AreaPageListing_Provider.CentralTexasMultipleListingService;
        case 31078:
        case "CentralVirginiaRegionalMultipleListingService":
            return AreaPageListing_Provider.CentralVirginiaRegionalMultipleListingService;
        case 31079:
        case "CentralWestTennesseeAssociationOfRealtors":
            return AreaPageListing_Provider.CentralWestTennesseeAssociationOfRealtors;
        case 31080:
        case "CentralWisconsinMls":
            return AreaPageListing_Provider.CentralWisconsinMls;
        case 31081:
        case "CharlottesvilleAreaAssociationOfRealtors":
            return AreaPageListing_Provider.CharlottesvilleAreaAssociationOfRealtors;
        case 31082:
        case "ChsRegionalMls":
            return AreaPageListing_Provider.ChsRegionalMls;
        case 31083:
        case "ClatsopAssociationOfRealtors":
            return AreaPageListing_Provider.ClatsopAssociationOfRealtors;
        case 31084:
        case "ClearfieldjeffersonAssociationOfRealtors":
            return AreaPageListing_Provider.ClearfieldjeffersonAssociationOfRealtors;
        case 31085:
        case "CoastalCarolinaAssociationOfRealtors":
            return AreaPageListing_Provider.CoastalCarolinaAssociationOfRealtors;
        case 31086:
        case "CoeurDaleneMultipleListingService":
            return AreaPageListing_Provider.CoeurDaleneMultipleListingService;
        case 31087:
        case "ColoradoRealEstateNetworkInc":
            return AreaPageListing_Provider.ColoradoRealEstateNetworkInc;
        case 31088:
        case "Columbia":
            return AreaPageListing_Provider.Columbia;
        case 31089:
        case "ColumbiaBoardOfRealtors":
            return AreaPageListing_Provider.ColumbiaBoardOfRealtors;
        case 31090:
        case "ColumbiaGreeneAndNorthernDutchessMls":
            return AreaPageListing_Provider.ColumbiaGreeneAndNorthernDutchessMls;
        case 31091:
        case "ColumbusAndCentralOhioMultipleListingService":
            return AreaPageListing_Provider.ColumbusAndCentralOhioMultipleListingService;
        case 31092:
        case "ColumbusBoardOfRealtors":
            return AreaPageListing_Provider.ColumbusBoardOfRealtors;
        case 31093:
        case "ConsolidatedMlsInc":
            return AreaPageListing_Provider.ConsolidatedMlsInc;
        case 31094:
        case "ContraCostaAorBayEastAorAndBridgeMls":
            return AreaPageListing_Provider.ContraCostaAorBayEastAorAndBridgeMls;
        case 31095:
        case "CooperativeArkansasRealtorsMultipleListingService":
            return AreaPageListing_Provider.CooperativeArkansasRealtorsMultipleListingService;
        case 31096:
        case "CorpusChristiAssociationOfRealtors":
            return AreaPageListing_Provider.CorpusChristiAssociationOfRealtors;
        case 31097:
        case "Crea":
            return AreaPageListing_Provider.Crea;
        case 31098:
        case "DaytonaBeachAreaAssociationOfRealtors":
            return AreaPageListing_Provider.DaytonaBeachAreaAssociationOfRealtors;
        case 31099:
        case "DaytonRealtorsMls":
            return AreaPageListing_Provider.DaytonRealtorsMls;
        case 31100:
        case "DemoMls":
            return AreaPageListing_Provider.DemoMls;
        case 31101:
        case "DesMoinesAreaAssociationOfRealtorsInc":
            return AreaPageListing_Provider.DesMoinesAreaAssociationOfRealtorsInc;
        case 31102:
        case "DixieGilchristLevyCountiesBoardOfRealtors":
            return AreaPageListing_Provider.DixieGilchristLevyCountiesBoardOfRealtors;
        case 31103:
        case "DominicanRepublic":
            return AreaPageListing_Provider.DominicanRepublic;
        case 31104:
        case "DublinBoardOfRealtors":
            return AreaPageListing_Provider.DublinBoardOfRealtors;
        case 31105:
        case "DummyMlsForQa":
            return AreaPageListing_Provider.DummyMlsForQa;
        case 31106:
        case "ElkoCountyBoardOfRealtors":
            return AreaPageListing_Provider.ElkoCountyBoardOfRealtors;
        case 31107:
        case "ElmiracorningRegionalBoardOfRealtorsMls":
            return AreaPageListing_Provider.ElmiracorningRegionalBoardOfRealtorsMls;
        case 31108:
        case "EmeraldCoastAssociationOfRealtors":
            return AreaPageListing_Provider.EmeraldCoastAssociationOfRealtors;
        case 31109:
        case "EmeraldCoastAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.EmeraldCoastAssociationOfRealtorsExpPortalOnly;
        case 31110:
        case "ExpPortal1":
            return AreaPageListing_Provider.ExpPortal1;
        case 31111:
        case "ExpPortal10":
            return AreaPageListing_Provider.ExpPortal10;
        case 31112:
        case "ExpPortal11":
            return AreaPageListing_Provider.ExpPortal11;
        case 31113:
        case "ExpPortal12":
            return AreaPageListing_Provider.ExpPortal12;
        case 31114:
        case "ExpPortal13":
            return AreaPageListing_Provider.ExpPortal13;
        case 31115:
        case "ExpPortal14":
            return AreaPageListing_Provider.ExpPortal14;
        case 31116:
        case "ExpPortal15":
            return AreaPageListing_Provider.ExpPortal15;
        case 31117:
        case "ExpPortal18":
            return AreaPageListing_Provider.ExpPortal18;
        case 31118:
        case "ExpPortal19":
            return AreaPageListing_Provider.ExpPortal19;
        case 31119:
        case "ExpPortal2":
            return AreaPageListing_Provider.ExpPortal2;
        case 31120:
        case "ExpPortal20":
            return AreaPageListing_Provider.ExpPortal20;
        case 31121:
        case "ExpPortal21":
            return AreaPageListing_Provider.ExpPortal21;
        case 31122:
        case "ExpPortal22":
            return AreaPageListing_Provider.ExpPortal22;
        case 31123:
        case "ExpPortal23":
            return AreaPageListing_Provider.ExpPortal23;
        case 31124:
        case "ExpPortal24Smart":
            return AreaPageListing_Provider.ExpPortal24Smart;
        case 31125:
        case "ExpPortal24CrMls":
            return AreaPageListing_Provider.ExpPortal24CrMls;
        case 31126:
        case "ExpPortal3":
            return AreaPageListing_Provider.ExpPortal3;
        case 31127:
        case "ExpPortal4":
            return AreaPageListing_Provider.ExpPortal4;
        case 31128:
        case "ExpPortal5":
            return AreaPageListing_Provider.ExpPortal5;
        case 31129:
        case "ExpPortal6":
            return AreaPageListing_Provider.ExpPortal6;
        case 31130:
        case "ExpPortal7":
            return AreaPageListing_Provider.ExpPortal7;
        case 31131:
        case "ExpPortal8":
            return AreaPageListing_Provider.ExpPortal8;
        case 31132:
        case "ExpPortal9":
            return AreaPageListing_Provider.ExpPortal9;
        case 31133:
        case "FargoMoorheadAreaAssociationOfRealtors":
            return AreaPageListing_Provider.FargoMoorheadAreaAssociationOfRealtors;
        case 31134:
        case "FirelandsMls":
            return AreaPageListing_Provider.FirelandsMls;
        case 31135:
        case "FirstMultipleListingService":
            return AreaPageListing_Provider.FirstMultipleListingService;
        case 31136:
        case "FlintHillsAssociationOfRealtors":
            return AreaPageListing_Provider.FlintHillsAssociationOfRealtors;
        case 31137:
        case "FloridaKeysBoardOfRealtors":
            return AreaPageListing_Provider.FloridaKeysBoardOfRealtors;
        case 31138:
        case "FortDodgeMls":
            return AreaPageListing_Provider.FortDodgeMls;
        case 31139:
        case "France":
            return AreaPageListing_Provider.France;
        case 31140:
        case "FresnoMls":
            return AreaPageListing_Provider.FresnoMls;
        case 31141:
        case "GalvestonAssociationOfRealtorsMls":
            return AreaPageListing_Provider.GalvestonAssociationOfRealtorsMls;
        case 31142:
        case "GardenStateMls":
            return AreaPageListing_Provider.GardenStateMls;
        case 31143:
        case "GardenStateMlsExpPortalOnly":
            return AreaPageListing_Provider.GardenStateMlsExpPortalOnly;
        case 31144:
        case "GeorgiaMultipleListingService":
            return AreaPageListing_Provider.GeorgiaMultipleListingService;
        case 31145:
        case "Germany":
            return AreaPageListing_Provider.Germany;
        case 31146:
        case "GlobalMlsInc":
            return AreaPageListing_Provider.GlobalMlsInc;
        case 31147:
        case "GoldsboroWayneCountyAssociationOfRealtors":
            return AreaPageListing_Provider.GoldsboroWayneCountyAssociationOfRealtors;
        case 31148:
        case "GrandCountyBoardOfRealtors":
            return AreaPageListing_Provider.GrandCountyBoardOfRealtors;
        case 31149:
        case "GrandIslandBoardOfRealtors":
            return AreaPageListing_Provider.GrandIslandBoardOfRealtors;
        case 31150:
        case "GrandJunctionAreaRealtorsAssociationMls":
            return AreaPageListing_Provider.GrandJunctionAreaRealtorsAssociationMls;
        case 31151:
        case "GreaterAlabamaMls":
            return AreaPageListing_Provider.GreaterAlabamaMls;
        case 31152:
        case "GreaterAntelopeValleyAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterAntelopeValleyAssociationOfRealtors;
        case 31153:
        case "GreaterAugustaAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterAugustaAssociationOfRealtors;
        case 31154:
        case "GreaterBatonRougeAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterBatonRougeAssociationOfRealtors;
        case 31155:
        case "GreaterChattanoogaAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterChattanoogaAssociationOfRealtors;
        case 31156:
        case "GreaterChattanoogaAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.GreaterChattanoogaAssociationOfRealtorsExpPortalOnly;
        case 31157:
        case "GreaterElPasoAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterElPasoAssociationOfRealtors;
        case 31158:
        case "GreaterErieBoardOfRealtorsMls":
            return AreaPageListing_Provider.GreaterErieBoardOfRealtorsMls;
        case 31159:
        case "GreaterGreenvilleAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterGreenvilleAssociationOfRealtors;
        case 31160:
        case "GreaterLasVegasAssociationOfRealtorsInc":
            return AreaPageListing_Provider.GreaterLasVegasAssociationOfRealtorsInc;
        case 31161:
        case "GreaterLehighValleyRealtors":
            return AreaPageListing_Provider.GreaterLehighValleyRealtors;
        case 31162:
        case "GreaterLouisvilleAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterLouisvilleAssociationOfRealtors;
        case 31163:
        case "GreaterMasonCityBoardOfRealtors":
            return AreaPageListing_Provider.GreaterMasonCityBoardOfRealtors;
        case 31164:
        case "GreaterMcallenAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterMcallenAssociationOfRealtors;
        case 31411:
        case "GreaterRegionalAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterRegionalAssociationOfRealtors;
        case 31165:
        case "GreaterNorthwestIndianaAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterNorthwestIndianaAssociationOfRealtors;
        case 31166:
        case "GreaterOwensboroRealtorAssociation":
            return AreaPageListing_Provider.GreaterOwensboroRealtorAssociation;
        case 31167:
        case "GreaterPortsmouthAreaMultipleListingService":
            return AreaPageListing_Provider.GreaterPortsmouthAreaMultipleListingService;
        case 31168:
        case "GreaterSouthernMls":
            return AreaPageListing_Provider.GreaterSouthernMls;
        case 31169:
        case "GreaterTylerAssociationOfRealtors":
            return AreaPageListing_Provider.GreaterTylerAssociationOfRealtors;
        case 31170:
        case "GreaterTylerAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.GreaterTylerAssociationOfRealtorsExpPortalOnly;
        case 31171:
        case "GreatPlainsRegionalMls":
            return AreaPageListing_Provider.GreatPlainsRegionalMls;
        case 31172:
        case "GreatSmokyMountainsAssociationOfRealtors":
            return AreaPageListing_Provider.GreatSmokyMountainsAssociationOfRealtors;
        case 31173:
        case "Greece":
            return AreaPageListing_Provider.Greece;
        case 31174:
        case "GreenvillepittAssociationOfRealtorsMls":
            return AreaPageListing_Provider.GreenvillepittAssociationOfRealtorsMls;
        case 31175:
        case "GreenwichAssociationOfRealtors":
            return AreaPageListing_Provider.GreenwichAssociationOfRealtors;
        case 31176:
        case "GulfCoastMultipleListingService":
            return AreaPageListing_Provider.GulfCoastMultipleListingService;
        case 31177:
        case "GulfSouthRealEstateInformationNetwork":
            return AreaPageListing_Provider.GulfSouthRealEstateInformationNetwork;
        case 31178:
        case "HattiesburgAreaAssociationOfRealtors":
            return AreaPageListing_Provider.HattiesburgAreaAssociationOfRealtors;
        case 31179:
        case "HawaiiInformationService":
            return AreaPageListing_Provider.HawaiiInformationService;
        case 31180:
        case "HeartlandAssociationOfRealtors":
            return AreaPageListing_Provider.HeartlandAssociationOfRealtors;
        case 31181:
        case "HeartlandMls":
            return AreaPageListing_Provider.HeartlandMls;
        case 31182:
        case "HeartOfKentuckyAssociationOfRealtors":
            return AreaPageListing_Provider.HeartOfKentuckyAssociationOfRealtors;
        case 31183:
        case "HernandoCountyAssociationOfRealtors":
            return AreaPageListing_Provider.HernandoCountyAssociationOfRealtors;
        case 31184:
        case "HighCountryAssociationOfRealtors":
            return AreaPageListing_Provider.HighCountryAssociationOfRealtors;
        case 31185:
        case "HighlandLakesAssociationOfRealtorsMls":
            return AreaPageListing_Provider.HighlandLakesAssociationOfRealtorsMls;
        case 31186:
        case "HighlandsCashiersBoardOfRealtors":
            return AreaPageListing_Provider.HighlandsCashiersBoardOfRealtors;
        case 31187:
        case "HinesvilleAreaBoardOfRealtorsIncMls":
            return AreaPageListing_Provider.HinesvilleAreaBoardOfRealtorsIncMls;
        case 31188:
        case "HonoluluBoardOfRealtors":
            return AreaPageListing_Provider.HonoluluBoardOfRealtors;
        case 31189:
        case "HonoluluBoardOfRealtorsExp":
            return AreaPageListing_Provider.HonoluluBoardOfRealtorsExp;
        case 31190:
        case "HopkinsvilleChristianCountyBoardOfRealtors":
            return AreaPageListing_Provider.HopkinsvilleChristianCountyBoardOfRealtors;
        case 31191:
        case "HotSpringsBoardOfRealtors":
            return AreaPageListing_Provider.HotSpringsBoardOfRealtors;
        case 31192:
        case "HoustonRealtorsInformationService":
            return AreaPageListing_Provider.HoustonRealtorsInformationService;
        case 31193:
        case "HudsonCountyMultipleListingService":
            return AreaPageListing_Provider.HudsonCountyMultipleListingService;
        case 31194:
        case "HumboldtCountyMls":
            return AreaPageListing_Provider.HumboldtCountyMls;
        case 31195:
        case "InclineVillageBoardOfRealtors":
            return AreaPageListing_Provider.InclineVillageBoardOfRealtors;
        case 31196:
        case "India":
            return AreaPageListing_Provider.India;
        case 31197:
        case "IndianaRegionalMls":
            return AreaPageListing_Provider.IndianaRegionalMls;
        case 31198:
        case "InformationAndRealEstateServices":
            return AreaPageListing_Provider.InformationAndRealEstateServices;
        case 31199:
        case "IntermountainMultipleListingService":
            return AreaPageListing_Provider.IntermountainMultipleListingService;
        case 31200:
        case "IowaAssociationOfRealtors":
            return AreaPageListing_Provider.IowaAssociationOfRealtors;
        case 31201:
        case "IowaGreatLakesBoardOfRealtors":
            return AreaPageListing_Provider.IowaGreatLakesBoardOfRealtors;
        case 31202:
        case "Israel":
            return AreaPageListing_Provider.Israel;
        case 31203:
        case "Italy":
            return AreaPageListing_Provider.Italy;
        case 31204:
        case "JacksonvilleBoardOfRealtorsNc":
            return AreaPageListing_Provider.JacksonvilleBoardOfRealtorsNc;
        case 31205:
        case "JeffersonCityAreaBoardOfRealtors":
            return AreaPageListing_Provider.JeffersonCityAreaBoardOfRealtors;
        case 31206:
        case "KanabUtMls":
            return AreaPageListing_Provider.KanabUtMls;
        case 31207:
        case "KanawhaValleyBoardOfRealtors":
            return AreaPageListing_Provider.KanawhaValleyBoardOfRealtors;
        case 31208:
        case "KeyWestAssociationOfRealtorsMls":
            return AreaPageListing_Provider.KeyWestAssociationOfRealtorsMls;
        case 31209:
        case "KnoxvilleAreaAssociationOfRealtors":
            return AreaPageListing_Provider.KnoxvilleAreaAssociationOfRealtors;
        case 31210:
        case "LakeCountryBoardOfRealtors":
            return AreaPageListing_Provider.LakeCountryBoardOfRealtors;
        case 31211:
        case "LakeHavasuAssociationMls":
            return AreaPageListing_Provider.LakeHavasuAssociationMls;
        case 31212:
        case "LakeSuperiorAreaRealtors":
            return AreaPageListing_Provider.LakeSuperiorAreaRealtors;
        case 31213:
        case "LakewayAreaAssociationOfRealtors":
            return AreaPageListing_Provider.LakewayAreaAssociationOfRealtors;
        case 31214:
        case "LawrenceBoardOfRealtors":
            return AreaPageListing_Provider.LawrenceBoardOfRealtors;
        case 31215:
        case "LeeCountyAssociationOfRealtors":
            return AreaPageListing_Provider.LeeCountyAssociationOfRealtors;
        case 31216:
        case "LincolnCountyBoardOfRealtors":
            return AreaPageListing_Provider.LincolnCountyBoardOfRealtors;
        case 31217:
        case "LongleafPineRealtors":
            return AreaPageListing_Provider.LongleafPineRealtors;
        case 31218:
        case "LongviewAreaAssociationOfRealtors":
            return AreaPageListing_Provider.LongviewAreaAssociationOfRealtors;
        case 31219:
        case "LowcountryRegionalMultipleListingServiceInc":
            return AreaPageListing_Provider.LowcountryRegionalMultipleListingServiceInc;
        case 31220:
        case "LubbockAssociationOfRealtors":
            return AreaPageListing_Provider.LubbockAssociationOfRealtors;
        case 31221:
        case "LynchburgVirginiaMls":
            return AreaPageListing_Provider.LynchburgVirginiaMls;
        case 31222:
        case "MaineRealEstateInformationSystemInc":
            return AreaPageListing_Provider.MaineRealEstateInformationSystemInc;
        case 31223:
        case "MansfieldAssociationOfRealtors":
            return AreaPageListing_Provider.MansfieldAssociationOfRealtors;
        case 31224:
        case "MarcoIslandAreaAssociationOfRealtors":
            return AreaPageListing_Provider.MarcoIslandAreaAssociationOfRealtors;
        case 31225:
        case "MarthasVineyardMls":
            return AreaPageListing_Provider.MarthasVineyardMls;
        case 31226:
        case "MartinCountyRealtorsOfTheTreasureCoast":
            return AreaPageListing_Provider.MartinCountyRealtorsOfTheTreasureCoast;
        case 31227:
        case "MemphisAreaAssociationOfRealtors":
            return AreaPageListing_Provider.MemphisAreaAssociationOfRealtors;
        case 31228:
        case "MercerTazewellCoBor":
            return AreaPageListing_Provider.MercerTazewellCoBor;
        case 31229:
        case "MetrolistCa":
            return AreaPageListing_Provider.MetrolistCa;
        case 31230:
        case "MetroMls":
            return AreaPageListing_Provider.MetroMls;
        case 31231:
        case "Mexico":
            return AreaPageListing_Provider.Mexico;
        case 31232:
        case "MiborServiceCorporation":
            return AreaPageListing_Provider.MiborServiceCorporation;
        case 31233:
        case "MichiganRegionalInformationCenter":
            return AreaPageListing_Provider.MichiganRegionalInformationCenter;
        case 31234:
        case "MidAmericaRegionalInformationSystems":
            return AreaPageListing_Provider.MidAmericaRegionalInformationSystems;
        case 31235:
        case "MiddleGeorgiaMls":
            return AreaPageListing_Provider.MiddleGeorgiaMls;
        case 31236:
        case "MiddleTennesseeRegionalMls":
            return AreaPageListing_Provider.MiddleTennesseeRegionalMls;
        case 31237:
        case "MidhudsonMultipleListingService":
            return AreaPageListing_Provider.MidhudsonMultipleListingService;
        case 31238:
        case "MidwestRealEstateData":
            return AreaPageListing_Provider.MidwestRealEstateData;
        case 31239:
        case "MilledgevilleMls":
            return AreaPageListing_Provider.MilledgevilleMls;
        case 31240:
        case "MlsListingsInc":
            return AreaPageListing_Provider.MlsListingsInc;
        case 31241:
        case "MlsNow":
            return AreaPageListing_Provider.MlsNow;
        case 31242:
        case "MlsOfCentralOregon":
            return AreaPageListing_Provider.MlsOfCentralOregon;
        case 31243:
        case "MlsOfGreaterCincinnatiInc":
            return AreaPageListing_Provider.MlsOfGreaterCincinnatiInc;
        case 31244:
        case "MlsOfYakimaAssociation":
            return AreaPageListing_Provider.MlsOfYakimaAssociation;
        case 31245:
        case "MlsPropertyInformationNetwork":
            return AreaPageListing_Provider.MlsPropertyInformationNetwork;
        case 31246:
        case "MlsTechnology":
            return AreaPageListing_Provider.MlsTechnology;
        case 31247:
        case "MlsUnited":
            return AreaPageListing_Provider.MlsUnited;
        case 31248:
        case "MonmouthoceanMultipleListingService":
            return AreaPageListing_Provider.MonmouthoceanMultipleListingService;
        case 31249:
        case "MontanaRegionalMls":
            return AreaPageListing_Provider.MontanaRegionalMls;
        case 31250:
        case "MontgomeryAreaAssociationOfRealtorsMls":
            return AreaPageListing_Provider.MontgomeryAreaAssociationOfRealtorsMls;
        case 31251:
        case "MountainLakesBoardOfRealtors":
            return AreaPageListing_Provider.MountainLakesBoardOfRealtors;
        case 31252:
        case "MtRushmoreAreaAssociationOfRealtors":
            return AreaPageListing_Provider.MtRushmoreAreaAssociationOfRealtors;
        case 31253:
        case "MultipleListingServiceMirealsource":
            return AreaPageListing_Provider.MultipleListingServiceMirealsource;
        case 31254:
        case "MultipleListingServiceOfHiltonHeadIslandInc":
            return AreaPageListing_Provider.MultipleListingServiceOfHiltonHeadIslandInc;
        case 31255:
        case "MultipleListingServiceOfSouthernArizona":
            return AreaPageListing_Provider.MultipleListingServiceOfSouthernArizona;
        case 31256:
        case "NaplesAreaBoardOfRealtors":
            return AreaPageListing_Provider.NaplesAreaBoardOfRealtors;
        case 31257:
        case "NeuseRiverRegionMlsInc":
            return AreaPageListing_Provider.NeuseRiverRegionMlsInc;
        case 31258:
        case "NewCanaanBoardOfRealtors":
            return AreaPageListing_Provider.NewCanaanBoardOfRealtors;
        case 31259:
        case "NewJerseyMls":
            return AreaPageListing_Provider.NewJerseyMls;
        case 31260:
        case "NewSmyrnaBeachBoardOfRealtors":
            return AreaPageListing_Provider.NewSmyrnaBeachBoardOfRealtors;
        case 31261:
        case "NewYorkStateAllianceOfMlss":
            return AreaPageListing_Provider.NewYorkStateAllianceOfMlss;
        case 31262:
        case "NewZealand":
            return AreaPageListing_Provider.NewZealand;
        case 31263:
        case "NorthCentralWestVirginiaRealEstateInformationNetwork":
            return AreaPageListing_Provider.NorthCentralWestVirginiaRealEstateInformationNetwork;
        case 31264:
        case "NortheastArkansasBoardOfRealtors":
            return AreaPageListing_Provider.NortheastArkansasBoardOfRealtors;
        case 31265:
        case "NortheastGeorgiaBoardOfRealtors":
            return AreaPageListing_Provider.NortheastGeorgiaBoardOfRealtors;
        case 31266:
        case "NortheastIowaRegionalBoardOfRealtors":
            return AreaPageListing_Provider.NortheastIowaRegionalBoardOfRealtors;
        case 31267:
        case "NortheastLouisianaAssociationOfRealtors":
            return AreaPageListing_Provider.NortheastLouisianaAssociationOfRealtors;
        case 31268:
        case "NortheastOklahomaBoardOfRealtors":
            return AreaPageListing_Provider.NortheastOklahomaBoardOfRealtors;
        case 31269:
        case "NorthernArizonaAssociationOfRealtors":
            return AreaPageListing_Provider.NorthernArizonaAssociationOfRealtors;
        case 31270:
        case "NorthernGreatLakesRealtorsMls":
            return AreaPageListing_Provider.NorthernGreatLakesRealtorsMls;
        case 31271:
        case "NorthernKentuckyMultipleListingService":
            return AreaPageListing_Provider.NorthernKentuckyMultipleListingService;
        case 31272:
        case "NorthernNevadaRegionalMlsInc":
            return AreaPageListing_Provider.NorthernNevadaRegionalMlsInc;
        case 31273:
        case "NorthFloridaMls":
            return AreaPageListing_Provider.NorthFloridaMls;
        case 31274:
        case "NorthSantaBarbaraCountyRegionalMls":
            return AreaPageListing_Provider.NorthSantaBarbaraCountyRegionalMls;
        case 31275:
        case "Northstarmls":
            return AreaPageListing_Provider.Northstarmls;
        case 31276:
        case "NorthTexasRealEstateInformationSystems":
            return AreaPageListing_Provider.NorthTexasRealEstateInformationSystems;
        case 31277:
        case "NorthwestArkansasBoardOfRealtors":
            return AreaPageListing_Provider.NorthwestArkansasBoardOfRealtors;
        case 31278:
        case "NorthwesternWisconsinMultipleListingService":
            return AreaPageListing_Provider.NorthwesternWisconsinMultipleListingService;
        case 31279:
        case "NorthwestIowaMls":
            return AreaPageListing_Provider.NorthwestIowaMls;
        case 31280:
        case "NorthwestMississippiAssociationOfRealtors":
            return AreaPageListing_Provider.NorthwestMississippiAssociationOfRealtors;
        case 31281:
        case "NorthwestMls":
            return AreaPageListing_Provider.NorthwestMls;
        case 31282:
        case "NorthwestOhioRealEstateInformationSystems":
            return AreaPageListing_Provider.NorthwestOhioRealEstateInformationSystems;
        case 31283:
        case "NorthwoodsAssociationOfRealtors":
            return AreaPageListing_Provider.NorthwoodsAssociationOfRealtors;
        case 31284:
        case "OldKentuckyHomeBoardOfRealtors":
            return AreaPageListing_Provider.OldKentuckyHomeBoardOfRealtors;
        case 31285:
        case "OnekeyMls":
            return AreaPageListing_Provider.OnekeyMls;
        case 31286:
        case "OuterBanksAssociationOfRealtors":
            return AreaPageListing_Provider.OuterBanksAssociationOfRealtors;
        case 31287:
        case "OzarkGatewayAssociationOfRealtors":
            return AreaPageListing_Provider.OzarkGatewayAssociationOfRealtors;
        case 31288:
        case "PacificRegionalMls":
            return AreaPageListing_Provider.PacificRegionalMls;
        case 31289:
        case "PageLakePowellMls":
            return AreaPageListing_Provider.PageLakePowellMls;
        case 31290:
        case "PalestineAssociationOfRealtors":
            return AreaPageListing_Provider.PalestineAssociationOfRealtors;
        case 31291:
        case "PalmBeachBoardOfRealtors":
            return AreaPageListing_Provider.PalmBeachBoardOfRealtors;
        case 31292:
        case "PalmettoMultipleListingService":
            return AreaPageListing_Provider.PalmettoMultipleListingService;
        case 31293:
        case "Panama":
            return AreaPageListing_Provider.Panama;
        case 31294:
        case "ParkCityBoardOfRealtors":
            return AreaPageListing_Provider.ParkCityBoardOfRealtors;
        case 31295:
        case "PearlRiverCountyBoardOfRealtors":
            return AreaPageListing_Provider.PearlRiverCountyBoardOfRealtors;
        case 31296:
        case "PensacolaAssociationOfRealtors":
            return AreaPageListing_Provider.PensacolaAssociationOfRealtors;
        case 31297:
        case "PermianBasinBoardOfRealtors":
            return AreaPageListing_Provider.PermianBasinBoardOfRealtors;
        case 31298:
        case "PikesPeakAssociationOfRealtors":
            return AreaPageListing_Provider.PikesPeakAssociationOfRealtors;
        case 31299:
        case "PikewayneAssociationOfRealtorsMls":
            return AreaPageListing_Provider.PikewayneAssociationOfRealtorsMls;
        case 31300:
        case "PoconoMountainsAssociationOfRealtors":
            return AreaPageListing_Provider.PoconoMountainsAssociationOfRealtors;
        case 31301:
        case "PortNechesPortArthurNederlandBoardOfRealtorsIncMls":
            return AreaPageListing_Provider.PortNechesPortArthurNederlandBoardOfRealtorsIncMls;
        case 31302:
        case "Portugal":
            return AreaPageListing_Provider.Portugal;
        case 31303:
        case "PrescottAreaAssociationOfRealtors":
            return AreaPageListing_Provider.PrescottAreaAssociationOfRealtors;
        case 31304:
        case "Primemls":
            return AreaPageListing_Provider.Primemls;
        case 31305:
        case "PuebloAssociationOfRealtors":
            return AreaPageListing_Provider.PuebloAssociationOfRealtors;
        case 31306:
        case "PuertoRico":
            return AreaPageListing_Provider.PuertoRico;
        case 31307:
        case "Qamls2":
            return AreaPageListing_Provider.Qamls2;
        case 31308:
        case "Qamls3":
            return AreaPageListing_Provider.Qamls3;
        case 31309:
        case "Qamls4":
            return AreaPageListing_Provider.Qamls4;
        case 31310:
        case "RandolphCountyBoardOfRealtors":
            return AreaPageListing_Provider.RandolphCountyBoardOfRealtors;
        case 31311:
        case "RangeAssociationOfRealtors":
            return AreaPageListing_Provider.RangeAssociationOfRealtors;
        case 31312:
        case "RealcompLimitedIi":
            return AreaPageListing_Provider.RealcompLimitedIi;
        case 31313:
        case "RealEstateInformationNetworkInc":
            return AreaPageListing_Provider.RealEstateInformationNetworkInc;
        case 31314:
        case "Realmls":
            return AreaPageListing_Provider.Realmls;
        case 31315:
        case "RealtorAssociationOfAcadiana":
            return AreaPageListing_Provider.RealtorAssociationOfAcadiana;
        case 31316:
        case "RealtorAssociationOfFranklinAndGulfCounties":
            return AreaPageListing_Provider.RealtorAssociationOfFranklinAndGulfCounties;
        case 31317:
        case "RealtorAssociationOfNortheastWisconsin":
            return AreaPageListing_Provider.RealtorAssociationOfNortheastWisconsin;
        case 31318:
        case "RealtorAssociationOfSouthernKentuckyInc":
            return AreaPageListing_Provider.RealtorAssociationOfSouthernKentuckyInc;
        case 31319:
        case "RealtorAssociationOfSouthernMinnesota":
            return AreaPageListing_Provider.RealtorAssociationOfSouthernMinnesota;
        case 31320:
        case "RealtorAssociationOfTheSiouxEmpireMls":
            return AreaPageListing_Provider.RealtorAssociationOfTheSiouxEmpireMls;
        case 31321:
        case "RealtorsAssociationOfCitrusCounty":
            return AreaPageListing_Provider.RealtorsAssociationOfCitrusCounty;
        case 31322:
        case "RealtorsAssociationOfIndianRiverCounty":
            return AreaPageListing_Provider.RealtorsAssociationOfIndianRiverCounty;
        case 31323:
        case "RealtorsAssociationOfMauiInc":
            return AreaPageListing_Provider.RealtorsAssociationOfMauiInc;
        case 31324:
        case "Recolorado":
            return AreaPageListing_Provider.Recolorado;
        case 31325:
        case "RegionalMultipleListingServices":
            return AreaPageListing_Provider.RegionalMultipleListingServices;
        case 31326:
        case "RidgecrestAreaAssociationOfRealtors":
            return AreaPageListing_Provider.RidgecrestAreaAssociationOfRealtors;
        case 31327:
        case "RiverCountiesAssociationOfRealtors":
            return AreaPageListing_Provider.RiverCountiesAssociationOfRealtors;
        case 31328:
        case "RmlsAllianceLlc":
            return AreaPageListing_Provider.RmlsAllianceLlc;
        case 31329:
        case "RoanokeValleyAssociationOfRealtors":
            return AreaPageListing_Provider.RoanokeValleyAssociationOfRealtors;
        case 31330:
        case "RockfordAreaMls":
            return AreaPageListing_Provider.RockfordAreaMls;
        case 31331:
        case "RockyMountAreaAssociationOfRealtors":
            return AreaPageListing_Provider.RockyMountAreaAssociationOfRealtors;
        case 31332:
        case "RoyalPalmCoastRealtorAssociation":
            return AreaPageListing_Provider.RoyalPalmCoastRealtorAssociation;
        case 31333:
        case "RuidosolincolnCountyAssociationOfRealtors":
            return AreaPageListing_Provider.RuidosolincolnCountyAssociationOfRealtors;
        case 31334:
        case "RussellvilleBoardOfRealtors":
            return AreaPageListing_Provider.RussellvilleBoardOfRealtors;
        case 31335:
        case "SanAngeloAssociationOfRealtors":
            return AreaPageListing_Provider.SanAngeloAssociationOfRealtors;
        case 31336:
        case "SanAntonioBoardOfRealtors":
            return AreaPageListing_Provider.SanAntonioBoardOfRealtors;
        case 31337:
        case "SanDiegoMls":
            return AreaPageListing_Provider.SanDiegoMls;
        case 31338:
        case "SanFranciscoAssociationOfRealtors":
            return AreaPageListing_Provider.SanFranciscoAssociationOfRealtors;
        case 31339:
        case "SanJuanAssociationOfRealtors":
            return AreaPageListing_Provider.SanJuanAssociationOfRealtors;
        case 31340:
        case "SantaBarbaraMultipleListingService":
            return AreaPageListing_Provider.SantaBarbaraMultipleListingService;
        case 31341:
        case "SantaFeAssociationOfRealtorsInc":
            return AreaPageListing_Provider.SantaFeAssociationOfRealtorsInc;
        case 31342:
        case "SavannahMultilistCorporation":
            return AreaPageListing_Provider.SavannahMultilistCorporation;
        case 31343:
        case "SciotoValleyAssociationOfRealtors":
            return AreaPageListing_Provider.SciotoValleyAssociationOfRealtors;
        case 31344:
        case "SedonaVerdeValleyAssociationOfRealtors":
            return AreaPageListing_Provider.SedonaVerdeValleyAssociationOfRealtors;
        case 31345:
        case "ShastaMls":
            return AreaPageListing_Provider.ShastaMls;
        case 31346:
        case "SmartMls":
            return AreaPageListing_Provider.SmartMls;
        case 31347:
        case "SnakeRiverRegionalMls":
            return AreaPageListing_Provider.SnakeRiverRegionalMls;
        case 31348:
        case "SouthAfrica":
            return AreaPageListing_Provider.SouthAfrica;
        case 31349:
        case "SouthBrowardBoardOfRealtors":
            return AreaPageListing_Provider.SouthBrowardBoardOfRealtors;
        case 31350:
        case "SouthCentralAssociationOfRealtorsMls":
            return AreaPageListing_Provider.SouthCentralAssociationOfRealtorsMls;
        case 31351:
        case "SouthCentralKansasMls":
            return AreaPageListing_Provider.SouthCentralKansasMls;
        case 31352:
        case "SouthCentralWisconsinMlsCorporation":
            return AreaPageListing_Provider.SouthCentralWisconsinMlsCorporation;
        case 31353:
        case "SoutheastAlaskaMls":
            return AreaPageListing_Provider.SoutheastAlaskaMls;
        case 31354:
        case "SoutheastKansasMultipleListingSystem":
            return AreaPageListing_Provider.SoutheastKansasMultipleListingSystem;
        case 31355:
        case "SouthernIndianaRealtorAssociation":
            return AreaPageListing_Provider.SouthernIndianaRealtorAssociation;
        case 31356:
        case "SouthernMissouriRegionalMlsLlc":
            return AreaPageListing_Provider.SouthernMissouriRegionalMlsLlc;
        case 31357:
        case "SouthernNewMexicoMls":
            return AreaPageListing_Provider.SouthernNewMexicoMls;
        case 31358:
        case "SouthGeorgiaMls":
            return AreaPageListing_Provider.SouthGeorgiaMls;
        case 31359:
        case "SouthJerseyShoreRegionalMls":
            return AreaPageListing_Provider.SouthJerseyShoreRegionalMls;
        case 31360:
        case "SouthPadreIslandBoardOfRealtors":
            return AreaPageListing_Provider.SouthPadreIslandBoardOfRealtors;
        case 31361:
        case "SouthwestMls":
            return AreaPageListing_Provider.SouthwestMls;
        case 31362:
        case "SouthwestVirginiaAssociationOfRealtors":
            return AreaPageListing_Provider.SouthwestVirginiaAssociationOfRealtors;
        case 31363:
        case "SpaceCoastAssociationOfRealtors":
            return AreaPageListing_Provider.SpaceCoastAssociationOfRealtors;
        case 31364:
        case "SpaceCoastAssociationOfRealtorsExpPortalOnly":
            return AreaPageListing_Provider.SpaceCoastAssociationOfRealtorsExpPortalOnly;
        case 31365:
        case "Spain":
            return AreaPageListing_Provider.Spain;
        case 31366:
        case "SpartanburgAssociationOfRealtorsInc":
            return AreaPageListing_Provider.SpartanburgAssociationOfRealtorsInc;
        case 31367:
        case "SpokaneAssociationOfRealtors":
            return AreaPageListing_Provider.SpokaneAssociationOfRealtors;
        case 31368:
        case "StatenIslandBoardOfRealtors":
            return AreaPageListing_Provider.StatenIslandBoardOfRealtors;
        case 31369:
        case "StateWideMlsOfRhodeIslandInc":
            return AreaPageListing_Provider.StateWideMlsOfRhodeIslandInc;
        case 31370:
        case "StAugustineStJohnsCountyBoardOfRealtors":
            return AreaPageListing_Provider.StAugustineStJohnsCountyBoardOfRealtors;
        case 31371:
        case "StillwaterBoardOfRealtors":
            return AreaPageListing_Provider.StillwaterBoardOfRealtors;
        case 31372:
        case "StrategicMlsAlliance":
            return AreaPageListing_Provider.StrategicMlsAlliance;
        case 31373:
        case "SummitAssociationOfRealtors":
            return AreaPageListing_Provider.SummitAssociationOfRealtors;
        case 31374:
        case "SunflowerAssociationOfRealtors":
            return AreaPageListing_Provider.SunflowerAssociationOfRealtors;
        case 31375:
        case "TahoeSierraBoardOfRealtors":
            return AreaPageListing_Provider.TahoeSierraBoardOfRealtors;
        case 31376:
        case "TaosCountyAssociationOfRealtors":
            return AreaPageListing_Provider.TaosCountyAssociationOfRealtors;
        case 31377:
        case "TennesseeVirginiaRegionalMultipleListingService":
            return AreaPageListing_Provider.TennesseeVirginiaRegionalMultipleListingService;
        case 31378:
        case "TetonBoardOfRealtors":
            return AreaPageListing_Provider.TetonBoardOfRealtors;
        case 31379:
        case "TexarkanaBoardOfRealtors":
            return AreaPageListing_Provider.TexarkanaBoardOfRealtors;
        case 31380:
        case "TillamookCountyBoardOfRealtorsMls":
            return AreaPageListing_Provider.TillamookCountyBoardOfRealtorsMls;
        case 31381:
        case "TopsailIslandAssociationOfRealtors":
            return AreaPageListing_Provider.TopsailIslandAssociationOfRealtors;
        case 31382:
        case "TriadMultipleListingService":
            return AreaPageListing_Provider.TriadMultipleListingService;
        case 31383:
        case "TriangleMls":
            return AreaPageListing_Provider.TriangleMls;
        case 31384:
        case "TrinityCountyMls":
            return AreaPageListing_Provider.TrinityCountyMls;
        case 31385:
        case "TulareCountyMls":
            return AreaPageListing_Provider.TulareCountyMls;
        case 31386:
        case "TuolumneCountyAssociationOfRealtors":
            return AreaPageListing_Provider.TuolumneCountyAssociationOfRealtors;
        case 31387:
        case "UlsterCountyBoardOfRealtorsMls":
            return AreaPageListing_Provider.UlsterCountyBoardOfRealtorsMls;
        case 31388:
        case "UpperCumberlandAssociationOfRealtors":
            return AreaPageListing_Provider.UpperCumberlandAssociationOfRealtors;
        case 31389:
        case "UpperPeninsulaAssociationOfRealtors":
            return AreaPageListing_Provider.UpperPeninsulaAssociationOfRealtors;
        case 31390:
        case "VailBoardOfRealtorsMls":
            return AreaPageListing_Provider.VailBoardOfRealtorsMls;
        case 31391:
        case "ValleyMls":
            return AreaPageListing_Provider.ValleyMls;
        case 31392:
        case "WacoAssociationOfRealtors":
            return AreaPageListing_Provider.WacoAssociationOfRealtors;
        case 31393:
        case "WasatchFrontRegionalMls":
            return AreaPageListing_Provider.WasatchFrontRegionalMls;
        case 31394:
        case "WashingtonBeaufortCountyBoardOfRealtors":
            return AreaPageListing_Provider.WashingtonBeaufortCountyBoardOfRealtors;
        case 31395:
        case "WashingtonCountyBoardOfRealtors":
            return AreaPageListing_Provider.WashingtonCountyBoardOfRealtors;
        case 31396:
        case "WestAlabamaMultipleListingService":
            return AreaPageListing_Provider.WestAlabamaMultipleListingService;
        case 31397:
        case "WestCentralAssociationOfRealtors":
            return AreaPageListing_Provider.WestCentralAssociationOfRealtors;
        case 31398:
        case "WestcliffeListingService":
            return AreaPageListing_Provider.WestcliffeListingService;
        case 31399:
        case "WesternArizonaRealtorDataExchange":
            return AreaPageListing_Provider.WesternArizonaRealtorDataExchange;
        case 31400:
        case "WesternRegionalInformationSystemsAndTechnologyInc":
            return AreaPageListing_Provider.WesternRegionalInformationSystemsAndTechnologyInc;
        case 31401:
        case "WesternUpstateAssociationOfRealtors":
            return AreaPageListing_Provider.WesternUpstateAssociationOfRealtors;
        case 31402:
        case "WestPennMultiList":
            return AreaPageListing_Provider.WestPennMultiList;
        case 31403:
        case "WheelingBoardOfRealtors":
            return AreaPageListing_Provider.WheelingBoardOfRealtors;
        case 31404:
        case "WhiteMountainAssociationOfRealtors":
            return AreaPageListing_Provider.WhiteMountainAssociationOfRealtors;
        case 31405:
        case "WillametteValleyMultipleListingService":
            return AreaPageListing_Provider.WillametteValleyMultipleListingService;
        case 31406:
        case "WilsonBoardOfRealtors":
            return AreaPageListing_Provider.WilsonBoardOfRealtors;
        case 31407:
        case "WinnipegRegionalRealEstateBoard":
            return AreaPageListing_Provider.WinnipegRegionalRealEstateBoard;
        case 31408:
        case "WyomingMls":
            return AreaPageListing_Provider.WyomingMls;
        case 31409:
        case "YumaAssociationOfRealtors":
            return AreaPageListing_Provider.YumaAssociationOfRealtors;
        case 31412:
        case "NorthCarolinaRegionalMultipleListingService":
            return AreaPageListing_Provider.NorthCarolinaRegionalMultipleListingService;
        case 90000:
        case "AgentUpload":
            return AreaPageListing_Provider.AgentUpload;
        case -1:
        case "UNRECOGNIZED":
        default:
            return AreaPageListing_Provider.UNRECOGNIZED;
    }
}
function areaPageListing_ProviderToJSON(object) {
    switch (object) {
        case AreaPageListing_Provider.NoProvider:
            return "NoProvider";
        case AreaPageListing_Provider.VrebIdx:
            return "VrebIdx";
        case AreaPageListing_Provider.LdonIdx:
            return "LdonIdx";
        case AreaPageListing_Provider.NsarIdx:
            return "NsarIdx";
        case AreaPageListing_Provider.NsarVow:
            return "NsarVow";
        case AreaPageListing_Provider.AlbIdx:
            return "AlbIdx";
        case AreaPageListing_Provider.CrebIdx:
            return "CrebIdx";
        case AreaPageListing_Provider.BrcIdx:
            return "BrcIdx";
        case AreaPageListing_Provider.TrebVow:
            return "TrebVow";
        case AreaPageListing_Provider.TrebIdx:
            return "TrebIdx";
        case AreaPageListing_Provider.RahbIdx:
            return "RahbIdx";
        case AreaPageListing_Provider.ItsoIdx:
            return "ItsoIdx";
        case AreaPageListing_Provider.OrebVow:
            return "OrebVow";
        case AreaPageListing_Provider.CreaDdf:
            return "CreaDdf";
        case AreaPageListing_Provider.ItsoVow:
            return "ItsoVow";
        case AreaPageListing_Provider.Pillar9Idx:
            return "Pillar9Idx";
        case AreaPageListing_Provider.Pillar9Vow:
            return "Pillar9Vow";
        case AreaPageListing_Provider.RebgvIdx:
            return "RebgvIdx";
        case AreaPageListing_Provider.RebgvVow:
            return "RebgvVow";
        case AreaPageListing_Provider.StellarMlsIdx:
            return "StellarMlsIdx";
        case AreaPageListing_Provider.MiamiSefIdxPlus:
            return "MiamiSefIdxPlus";
        case AreaPageListing_Provider.BrightMls:
            return "BrightMls";
        case AreaPageListing_Provider.AberdeenBoardOfRealtors:
            return "AberdeenBoardOfRealtors";
        case AreaPageListing_Provider.AdirondackChamplainValleyMls:
            return "AdirondackChamplainValleyMls";
        case AreaPageListing_Provider.AikenMls:
            return "AikenMls";
        case AreaPageListing_Provider.AlamanceMultipleListingService:
            return "AlamanceMultipleListingService";
        case AreaPageListing_Provider.AlaskaMultipleListingService:
            return "AlaskaMultipleListingService";
        case AreaPageListing_Provider.AlleghenyHighlandAssociationOfRealtors:
            return "AlleghenyHighlandAssociationOfRealtors";
        case AreaPageListing_Provider.AmeliaIslandundefinedNassauCountyAssociationOfRealtors:
            return "AmeliaIslandundefinedNassauCountyAssociationOfRealtors";
        case AreaPageListing_Provider.ArizonaRegionalMultipleListingService:
            return "ArizonaRegionalMultipleListingService";
        case AreaPageListing_Provider.ArizonaRegionalMultipleListingServiceExpPortalOnly:
            return "ArizonaRegionalMultipleListingServiceExpPortalOnly";
        case AreaPageListing_Provider.AshlandAreaBoardOfRealtors:
            return "AshlandAreaBoardOfRealtors";
        case AreaPageListing_Provider.AshlandBoardOfRealtors:
            return "AshlandBoardOfRealtors";
        case AreaPageListing_Provider.AspenGlenwoodMls:
            return "AspenGlenwoodMls";
        case AreaPageListing_Provider.AssociatedMultilistServicesOfOklahoma:
            return "AssociatedMultilistServicesOfOklahoma";
        case AreaPageListing_Provider.AthensAreaAssociationOfRealtors:
            return "AthensAreaAssociationOfRealtors";
        case AreaPageListing_Provider.AthensCountyBoardOfRealtors:
            return "AthensCountyBoardOfRealtors";
        case AreaPageListing_Provider.AustinCentralTexasRealtyInformationService:
            return "AustinCentralTexasRealtyInformationService";
        case AreaPageListing_Provider.BadlandsBoardOfRealtorsIncMls:
            return "BadlandsBoardOfRealtorsIncMls";
        case AreaPageListing_Provider.BakersfieldAssociationOfRealtors:
            return "BakersfieldAssociationOfRealtors";
        case AreaPageListing_Provider.BaldwinRealtors:
            return "BaldwinRealtors";
        case AreaPageListing_Provider.BayAreaRealEstateInformationServicesInc:
            return "BayAreaRealEstateInformationServicesInc";
        case AreaPageListing_Provider.BeachesMls:
            return "BeachesMls";
        case AreaPageListing_Provider.BeachesMlsExpPortalOnly:
            return "BeachesMlsExpPortalOnly";
        case AreaPageListing_Provider.BeaumontBoardOfRealtorsIncMls:
            return "BeaumontBoardOfRealtorsIncMls";
        case AreaPageListing_Provider.BerkshireCountyBoardOfRealtors:
            return "BerkshireCountyBoardOfRealtors";
        case AreaPageListing_Provider.BigSkyCountryMls:
            return "BigSkyCountryMls";
        case AreaPageListing_Provider.BillingsAssociationOfRealtors:
            return "BillingsAssociationOfRealtors";
        case AreaPageListing_Provider.BillingsAssociationOfRealtorsExpPortalOnly:
            return "BillingsAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.BismarckMandanBoardOfRealtors:
            return "BismarckMandanBoardOfRealtors";
        case AreaPageListing_Provider.BlackHillsAssociationOfRealtors:
            return "BlackHillsAssociationOfRealtors";
        case AreaPageListing_Provider.BluegrassRealtors:
            return "BluegrassRealtors";
        case AreaPageListing_Provider.BonitaSpringsEsteroAssociationOfRealtors:
            return "BonitaSpringsEsteroAssociationOfRealtors";
        case AreaPageListing_Provider.Brasil:
            return "Brasil";
        case AreaPageListing_Provider.BrazoriaCountyBoardOfRealtors:
            return "BrazoriaCountyBoardOfRealtors";
        case AreaPageListing_Provider.BrooklynNewYorkMls:
            return "BrooklynNewYorkMls";
        case AreaPageListing_Provider.BrunswickCountyMls:
            return "BrunswickCountyMls";
        case AreaPageListing_Provider.BryancollegeStationRegionalMls:
            return "BryancollegeStationRegionalMls";
        case AreaPageListing_Provider.CalaverasCountyAssociationOfRealtors:
            return "CalaverasCountyAssociationOfRealtors";
        case AreaPageListing_Provider.CaliforniaRegionalMultipleListingService:
            return "CaliforniaRegionalMultipleListingService";
        case AreaPageListing_Provider.CambriaSomersetAssociationOfRealtors:
            return "CambriaSomersetAssociationOfRealtors";
        case AreaPageListing_Provider.CanopyMls:
            return "CanopyMls";
        case AreaPageListing_Provider.CapeCodundefinedIslandsAssociationOfRealtors:
            return "CapeCodundefinedIslandsAssociationOfRealtors";
        case AreaPageListing_Provider.CapeFearRealtors:
            return "CapeFearRealtors";
        case AreaPageListing_Provider.CapeMayCountyAssociationOfRealtors:
            return "CapeMayCountyAssociationOfRealtors";
        case AreaPageListing_Provider.CapitalAreaTechnologyRealtorServices:
            return "CapitalAreaTechnologyRealtorServices";
        case AreaPageListing_Provider.CarpetCapitalAssociationOfRealtors:
            return "CarpetCapitalAssociationOfRealtors";
        case AreaPageListing_Provider.CarpetCapitalAssociationOfRealtorsExpPortalOnly:
            return "CarpetCapitalAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.CarteretCountyAssociationOfRealtors:
            return "CarteretCountyAssociationOfRealtors";
        case AreaPageListing_Provider.CedarRapidsAreaAssociationOfRealtors:
            return "CedarRapidsAreaAssociationOfRealtors";
        case AreaPageListing_Provider.CentralGeorgiaMls:
            return "CentralGeorgiaMls";
        case AreaPageListing_Provider.CentralGeorgiaMlsExpPortalOnly:
            return "CentralGeorgiaMlsExpPortalOnly";
        case AreaPageListing_Provider.CentralHillCountryBoardOfRealtors:
            return "CentralHillCountryBoardOfRealtors";
        case AreaPageListing_Provider.CentralIllinoisBoardOfRealtors:
            return "CentralIllinoisBoardOfRealtors";
        case AreaPageListing_Provider.CentralJerseyMultipleListingSystemInc:
            return "CentralJerseyMultipleListingSystemInc";
        case AreaPageListing_Provider.CentralMississippiMls:
            return "CentralMississippiMls";
        case AreaPageListing_Provider.CentralPanhandleAssociationOfRealtors:
            return "CentralPanhandleAssociationOfRealtors";
        case AreaPageListing_Provider.CentralSusquehannaValleyBoardOfRealtors:
            return "CentralSusquehannaValleyBoardOfRealtors";
        case AreaPageListing_Provider.CentralTexasMultipleListingService:
            return "CentralTexasMultipleListingService";
        case AreaPageListing_Provider.CentralVirginiaRegionalMultipleListingService:
            return "CentralVirginiaRegionalMultipleListingService";
        case AreaPageListing_Provider.CentralWestTennesseeAssociationOfRealtors:
            return "CentralWestTennesseeAssociationOfRealtors";
        case AreaPageListing_Provider.CentralWisconsinMls:
            return "CentralWisconsinMls";
        case AreaPageListing_Provider.CharlottesvilleAreaAssociationOfRealtors:
            return "CharlottesvilleAreaAssociationOfRealtors";
        case AreaPageListing_Provider.ChsRegionalMls:
            return "ChsRegionalMls";
        case AreaPageListing_Provider.ClatsopAssociationOfRealtors:
            return "ClatsopAssociationOfRealtors";
        case AreaPageListing_Provider.ClearfieldjeffersonAssociationOfRealtors:
            return "ClearfieldjeffersonAssociationOfRealtors";
        case AreaPageListing_Provider.CoastalCarolinaAssociationOfRealtors:
            return "CoastalCarolinaAssociationOfRealtors";
        case AreaPageListing_Provider.CoeurDaleneMultipleListingService:
            return "CoeurDaleneMultipleListingService";
        case AreaPageListing_Provider.ColoradoRealEstateNetworkInc:
            return "ColoradoRealEstateNetworkInc";
        case AreaPageListing_Provider.Columbia:
            return "Columbia";
        case AreaPageListing_Provider.ColumbiaBoardOfRealtors:
            return "ColumbiaBoardOfRealtors";
        case AreaPageListing_Provider.ColumbiaGreeneAndNorthernDutchessMls:
            return "ColumbiaGreeneAndNorthernDutchessMls";
        case AreaPageListing_Provider.ColumbusAndCentralOhioMultipleListingService:
            return "ColumbusAndCentralOhioMultipleListingService";
        case AreaPageListing_Provider.ColumbusBoardOfRealtors:
            return "ColumbusBoardOfRealtors";
        case AreaPageListing_Provider.ConsolidatedMlsInc:
            return "ConsolidatedMlsInc";
        case AreaPageListing_Provider.ContraCostaAorBayEastAorAndBridgeMls:
            return "ContraCostaAorBayEastAorAndBridgeMls";
        case AreaPageListing_Provider.CooperativeArkansasRealtorsMultipleListingService:
            return "CooperativeArkansasRealtorsMultipleListingService";
        case AreaPageListing_Provider.CorpusChristiAssociationOfRealtors:
            return "CorpusChristiAssociationOfRealtors";
        case AreaPageListing_Provider.Crea:
            return "Crea";
        case AreaPageListing_Provider.DaytonaBeachAreaAssociationOfRealtors:
            return "DaytonaBeachAreaAssociationOfRealtors";
        case AreaPageListing_Provider.DaytonRealtorsMls:
            return "DaytonRealtorsMls";
        case AreaPageListing_Provider.DemoMls:
            return "DemoMls";
        case AreaPageListing_Provider.DesMoinesAreaAssociationOfRealtorsInc:
            return "DesMoinesAreaAssociationOfRealtorsInc";
        case AreaPageListing_Provider.DixieGilchristLevyCountiesBoardOfRealtors:
            return "DixieGilchristLevyCountiesBoardOfRealtors";
        case AreaPageListing_Provider.DominicanRepublic:
            return "DominicanRepublic";
        case AreaPageListing_Provider.DublinBoardOfRealtors:
            return "DublinBoardOfRealtors";
        case AreaPageListing_Provider.DummyMlsForQa:
            return "DummyMlsForQa";
        case AreaPageListing_Provider.ElkoCountyBoardOfRealtors:
            return "ElkoCountyBoardOfRealtors";
        case AreaPageListing_Provider.ElmiracorningRegionalBoardOfRealtorsMls:
            return "ElmiracorningRegionalBoardOfRealtorsMls";
        case AreaPageListing_Provider.EmeraldCoastAssociationOfRealtors:
            return "EmeraldCoastAssociationOfRealtors";
        case AreaPageListing_Provider.EmeraldCoastAssociationOfRealtorsExpPortalOnly:
            return "EmeraldCoastAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.ExpPortal1:
            return "ExpPortal1";
        case AreaPageListing_Provider.ExpPortal10:
            return "ExpPortal10";
        case AreaPageListing_Provider.ExpPortal11:
            return "ExpPortal11";
        case AreaPageListing_Provider.ExpPortal12:
            return "ExpPortal12";
        case AreaPageListing_Provider.ExpPortal13:
            return "ExpPortal13";
        case AreaPageListing_Provider.ExpPortal14:
            return "ExpPortal14";
        case AreaPageListing_Provider.ExpPortal15:
            return "ExpPortal15";
        case AreaPageListing_Provider.ExpPortal18:
            return "ExpPortal18";
        case AreaPageListing_Provider.ExpPortal19:
            return "ExpPortal19";
        case AreaPageListing_Provider.ExpPortal2:
            return "ExpPortal2";
        case AreaPageListing_Provider.ExpPortal20:
            return "ExpPortal20";
        case AreaPageListing_Provider.ExpPortal21:
            return "ExpPortal21";
        case AreaPageListing_Provider.ExpPortal22:
            return "ExpPortal22";
        case AreaPageListing_Provider.ExpPortal23:
            return "ExpPortal23";
        case AreaPageListing_Provider.ExpPortal24Smart:
            return "ExpPortal24Smart";
        case AreaPageListing_Provider.ExpPortal24CrMls:
            return "ExpPortal24CrMls";
        case AreaPageListing_Provider.ExpPortal3:
            return "ExpPortal3";
        case AreaPageListing_Provider.ExpPortal4:
            return "ExpPortal4";
        case AreaPageListing_Provider.ExpPortal5:
            return "ExpPortal5";
        case AreaPageListing_Provider.ExpPortal6:
            return "ExpPortal6";
        case AreaPageListing_Provider.ExpPortal7:
            return "ExpPortal7";
        case AreaPageListing_Provider.ExpPortal8:
            return "ExpPortal8";
        case AreaPageListing_Provider.ExpPortal9:
            return "ExpPortal9";
        case AreaPageListing_Provider.FargoMoorheadAreaAssociationOfRealtors:
            return "FargoMoorheadAreaAssociationOfRealtors";
        case AreaPageListing_Provider.FirelandsMls:
            return "FirelandsMls";
        case AreaPageListing_Provider.FirstMultipleListingService:
            return "FirstMultipleListingService";
        case AreaPageListing_Provider.FlintHillsAssociationOfRealtors:
            return "FlintHillsAssociationOfRealtors";
        case AreaPageListing_Provider.FloridaKeysBoardOfRealtors:
            return "FloridaKeysBoardOfRealtors";
        case AreaPageListing_Provider.FortDodgeMls:
            return "FortDodgeMls";
        case AreaPageListing_Provider.France:
            return "France";
        case AreaPageListing_Provider.FresnoMls:
            return "FresnoMls";
        case AreaPageListing_Provider.GalvestonAssociationOfRealtorsMls:
            return "GalvestonAssociationOfRealtorsMls";
        case AreaPageListing_Provider.GardenStateMls:
            return "GardenStateMls";
        case AreaPageListing_Provider.GardenStateMlsExpPortalOnly:
            return "GardenStateMlsExpPortalOnly";
        case AreaPageListing_Provider.GeorgiaMultipleListingService:
            return "GeorgiaMultipleListingService";
        case AreaPageListing_Provider.Germany:
            return "Germany";
        case AreaPageListing_Provider.GlobalMlsInc:
            return "GlobalMlsInc";
        case AreaPageListing_Provider.GoldsboroWayneCountyAssociationOfRealtors:
            return "GoldsboroWayneCountyAssociationOfRealtors";
        case AreaPageListing_Provider.GrandCountyBoardOfRealtors:
            return "GrandCountyBoardOfRealtors";
        case AreaPageListing_Provider.GrandIslandBoardOfRealtors:
            return "GrandIslandBoardOfRealtors";
        case AreaPageListing_Provider.GrandJunctionAreaRealtorsAssociationMls:
            return "GrandJunctionAreaRealtorsAssociationMls";
        case AreaPageListing_Provider.GreaterAlabamaMls:
            return "GreaterAlabamaMls";
        case AreaPageListing_Provider.GreaterAntelopeValleyAssociationOfRealtors:
            return "GreaterAntelopeValleyAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterAugustaAssociationOfRealtors:
            return "GreaterAugustaAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterBatonRougeAssociationOfRealtors:
            return "GreaterBatonRougeAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterChattanoogaAssociationOfRealtors:
            return "GreaterChattanoogaAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterChattanoogaAssociationOfRealtorsExpPortalOnly:
            return "GreaterChattanoogaAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.GreaterElPasoAssociationOfRealtors:
            return "GreaterElPasoAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterErieBoardOfRealtorsMls:
            return "GreaterErieBoardOfRealtorsMls";
        case AreaPageListing_Provider.GreaterGreenvilleAssociationOfRealtors:
            return "GreaterGreenvilleAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterLasVegasAssociationOfRealtorsInc:
            return "GreaterLasVegasAssociationOfRealtorsInc";
        case AreaPageListing_Provider.GreaterLehighValleyRealtors:
            return "GreaterLehighValleyRealtors";
        case AreaPageListing_Provider.GreaterLouisvilleAssociationOfRealtors:
            return "GreaterLouisvilleAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterMasonCityBoardOfRealtors:
            return "GreaterMasonCityBoardOfRealtors";
        case AreaPageListing_Provider.GreaterMcallenAssociationOfRealtors:
            return "GreaterMcallenAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterRegionalAssociationOfRealtors:
            return "GreaterRegionalAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterNorthwestIndianaAssociationOfRealtors:
            return "GreaterNorthwestIndianaAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterOwensboroRealtorAssociation:
            return "GreaterOwensboroRealtorAssociation";
        case AreaPageListing_Provider.GreaterPortsmouthAreaMultipleListingService:
            return "GreaterPortsmouthAreaMultipleListingService";
        case AreaPageListing_Provider.GreaterSouthernMls:
            return "GreaterSouthernMls";
        case AreaPageListing_Provider.GreaterTylerAssociationOfRealtors:
            return "GreaterTylerAssociationOfRealtors";
        case AreaPageListing_Provider.GreaterTylerAssociationOfRealtorsExpPortalOnly:
            return "GreaterTylerAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.GreatPlainsRegionalMls:
            return "GreatPlainsRegionalMls";
        case AreaPageListing_Provider.GreatSmokyMountainsAssociationOfRealtors:
            return "GreatSmokyMountainsAssociationOfRealtors";
        case AreaPageListing_Provider.Greece:
            return "Greece";
        case AreaPageListing_Provider.GreenvillepittAssociationOfRealtorsMls:
            return "GreenvillepittAssociationOfRealtorsMls";
        case AreaPageListing_Provider.GreenwichAssociationOfRealtors:
            return "GreenwichAssociationOfRealtors";
        case AreaPageListing_Provider.GulfCoastMultipleListingService:
            return "GulfCoastMultipleListingService";
        case AreaPageListing_Provider.GulfSouthRealEstateInformationNetwork:
            return "GulfSouthRealEstateInformationNetwork";
        case AreaPageListing_Provider.HattiesburgAreaAssociationOfRealtors:
            return "HattiesburgAreaAssociationOfRealtors";
        case AreaPageListing_Provider.HawaiiInformationService:
            return "HawaiiInformationService";
        case AreaPageListing_Provider.HeartlandAssociationOfRealtors:
            return "HeartlandAssociationOfRealtors";
        case AreaPageListing_Provider.HeartlandMls:
            return "HeartlandMls";
        case AreaPageListing_Provider.HeartOfKentuckyAssociationOfRealtors:
            return "HeartOfKentuckyAssociationOfRealtors";
        case AreaPageListing_Provider.HernandoCountyAssociationOfRealtors:
            return "HernandoCountyAssociationOfRealtors";
        case AreaPageListing_Provider.HighCountryAssociationOfRealtors:
            return "HighCountryAssociationOfRealtors";
        case AreaPageListing_Provider.HighlandLakesAssociationOfRealtorsMls:
            return "HighlandLakesAssociationOfRealtorsMls";
        case AreaPageListing_Provider.HighlandsCashiersBoardOfRealtors:
            return "HighlandsCashiersBoardOfRealtors";
        case AreaPageListing_Provider.HinesvilleAreaBoardOfRealtorsIncMls:
            return "HinesvilleAreaBoardOfRealtorsIncMls";
        case AreaPageListing_Provider.HonoluluBoardOfRealtors:
            return "HonoluluBoardOfRealtors";
        case AreaPageListing_Provider.HonoluluBoardOfRealtorsExp:
            return "HonoluluBoardOfRealtorsExp";
        case AreaPageListing_Provider.HopkinsvilleChristianCountyBoardOfRealtors:
            return "HopkinsvilleChristianCountyBoardOfRealtors";
        case AreaPageListing_Provider.HotSpringsBoardOfRealtors:
            return "HotSpringsBoardOfRealtors";
        case AreaPageListing_Provider.HoustonRealtorsInformationService:
            return "HoustonRealtorsInformationService";
        case AreaPageListing_Provider.HudsonCountyMultipleListingService:
            return "HudsonCountyMultipleListingService";
        case AreaPageListing_Provider.HumboldtCountyMls:
            return "HumboldtCountyMls";
        case AreaPageListing_Provider.InclineVillageBoardOfRealtors:
            return "InclineVillageBoardOfRealtors";
        case AreaPageListing_Provider.India:
            return "India";
        case AreaPageListing_Provider.IndianaRegionalMls:
            return "IndianaRegionalMls";
        case AreaPageListing_Provider.InformationAndRealEstateServices:
            return "InformationAndRealEstateServices";
        case AreaPageListing_Provider.IntermountainMultipleListingService:
            return "IntermountainMultipleListingService";
        case AreaPageListing_Provider.IowaAssociationOfRealtors:
            return "IowaAssociationOfRealtors";
        case AreaPageListing_Provider.IowaGreatLakesBoardOfRealtors:
            return "IowaGreatLakesBoardOfRealtors";
        case AreaPageListing_Provider.Israel:
            return "Israel";
        case AreaPageListing_Provider.Italy:
            return "Italy";
        case AreaPageListing_Provider.JacksonvilleBoardOfRealtorsNc:
            return "JacksonvilleBoardOfRealtorsNc";
        case AreaPageListing_Provider.JeffersonCityAreaBoardOfRealtors:
            return "JeffersonCityAreaBoardOfRealtors";
        case AreaPageListing_Provider.KanabUtMls:
            return "KanabUtMls";
        case AreaPageListing_Provider.KanawhaValleyBoardOfRealtors:
            return "KanawhaValleyBoardOfRealtors";
        case AreaPageListing_Provider.KeyWestAssociationOfRealtorsMls:
            return "KeyWestAssociationOfRealtorsMls";
        case AreaPageListing_Provider.KnoxvilleAreaAssociationOfRealtors:
            return "KnoxvilleAreaAssociationOfRealtors";
        case AreaPageListing_Provider.LakeCountryBoardOfRealtors:
            return "LakeCountryBoardOfRealtors";
        case AreaPageListing_Provider.LakeHavasuAssociationMls:
            return "LakeHavasuAssociationMls";
        case AreaPageListing_Provider.LakeSuperiorAreaRealtors:
            return "LakeSuperiorAreaRealtors";
        case AreaPageListing_Provider.LakewayAreaAssociationOfRealtors:
            return "LakewayAreaAssociationOfRealtors";
        case AreaPageListing_Provider.LawrenceBoardOfRealtors:
            return "LawrenceBoardOfRealtors";
        case AreaPageListing_Provider.LeeCountyAssociationOfRealtors:
            return "LeeCountyAssociationOfRealtors";
        case AreaPageListing_Provider.LincolnCountyBoardOfRealtors:
            return "LincolnCountyBoardOfRealtors";
        case AreaPageListing_Provider.LongleafPineRealtors:
            return "LongleafPineRealtors";
        case AreaPageListing_Provider.LongviewAreaAssociationOfRealtors:
            return "LongviewAreaAssociationOfRealtors";
        case AreaPageListing_Provider.LowcountryRegionalMultipleListingServiceInc:
            return "LowcountryRegionalMultipleListingServiceInc";
        case AreaPageListing_Provider.LubbockAssociationOfRealtors:
            return "LubbockAssociationOfRealtors";
        case AreaPageListing_Provider.LynchburgVirginiaMls:
            return "LynchburgVirginiaMls";
        case AreaPageListing_Provider.MaineRealEstateInformationSystemInc:
            return "MaineRealEstateInformationSystemInc";
        case AreaPageListing_Provider.MansfieldAssociationOfRealtors:
            return "MansfieldAssociationOfRealtors";
        case AreaPageListing_Provider.MarcoIslandAreaAssociationOfRealtors:
            return "MarcoIslandAreaAssociationOfRealtors";
        case AreaPageListing_Provider.MarthasVineyardMls:
            return "MarthasVineyardMls";
        case AreaPageListing_Provider.MartinCountyRealtorsOfTheTreasureCoast:
            return "MartinCountyRealtorsOfTheTreasureCoast";
        case AreaPageListing_Provider.MemphisAreaAssociationOfRealtors:
            return "MemphisAreaAssociationOfRealtors";
        case AreaPageListing_Provider.MercerTazewellCoBor:
            return "MercerTazewellCoBor";
        case AreaPageListing_Provider.MetrolistCa:
            return "MetrolistCa";
        case AreaPageListing_Provider.MetroMls:
            return "MetroMls";
        case AreaPageListing_Provider.Mexico:
            return "Mexico";
        case AreaPageListing_Provider.MiborServiceCorporation:
            return "MiborServiceCorporation";
        case AreaPageListing_Provider.MichiganRegionalInformationCenter:
            return "MichiganRegionalInformationCenter";
        case AreaPageListing_Provider.MidAmericaRegionalInformationSystems:
            return "MidAmericaRegionalInformationSystems";
        case AreaPageListing_Provider.MiddleGeorgiaMls:
            return "MiddleGeorgiaMls";
        case AreaPageListing_Provider.MiddleTennesseeRegionalMls:
            return "MiddleTennesseeRegionalMls";
        case AreaPageListing_Provider.MidhudsonMultipleListingService:
            return "MidhudsonMultipleListingService";
        case AreaPageListing_Provider.MidwestRealEstateData:
            return "MidwestRealEstateData";
        case AreaPageListing_Provider.MilledgevilleMls:
            return "MilledgevilleMls";
        case AreaPageListing_Provider.MlsListingsInc:
            return "MlsListingsInc";
        case AreaPageListing_Provider.MlsNow:
            return "MlsNow";
        case AreaPageListing_Provider.MlsOfCentralOregon:
            return "MlsOfCentralOregon";
        case AreaPageListing_Provider.MlsOfGreaterCincinnatiInc:
            return "MlsOfGreaterCincinnatiInc";
        case AreaPageListing_Provider.MlsOfYakimaAssociation:
            return "MlsOfYakimaAssociation";
        case AreaPageListing_Provider.MlsPropertyInformationNetwork:
            return "MlsPropertyInformationNetwork";
        case AreaPageListing_Provider.MlsTechnology:
            return "MlsTechnology";
        case AreaPageListing_Provider.MlsUnited:
            return "MlsUnited";
        case AreaPageListing_Provider.MonmouthoceanMultipleListingService:
            return "MonmouthoceanMultipleListingService";
        case AreaPageListing_Provider.MontanaRegionalMls:
            return "MontanaRegionalMls";
        case AreaPageListing_Provider.MontgomeryAreaAssociationOfRealtorsMls:
            return "MontgomeryAreaAssociationOfRealtorsMls";
        case AreaPageListing_Provider.MountainLakesBoardOfRealtors:
            return "MountainLakesBoardOfRealtors";
        case AreaPageListing_Provider.MtRushmoreAreaAssociationOfRealtors:
            return "MtRushmoreAreaAssociationOfRealtors";
        case AreaPageListing_Provider.MultipleListingServiceMirealsource:
            return "MultipleListingServiceMirealsource";
        case AreaPageListing_Provider.MultipleListingServiceOfHiltonHeadIslandInc:
            return "MultipleListingServiceOfHiltonHeadIslandInc";
        case AreaPageListing_Provider.MultipleListingServiceOfSouthernArizona:
            return "MultipleListingServiceOfSouthernArizona";
        case AreaPageListing_Provider.NaplesAreaBoardOfRealtors:
            return "NaplesAreaBoardOfRealtors";
        case AreaPageListing_Provider.NeuseRiverRegionMlsInc:
            return "NeuseRiverRegionMlsInc";
        case AreaPageListing_Provider.NewCanaanBoardOfRealtors:
            return "NewCanaanBoardOfRealtors";
        case AreaPageListing_Provider.NewJerseyMls:
            return "NewJerseyMls";
        case AreaPageListing_Provider.NewSmyrnaBeachBoardOfRealtors:
            return "NewSmyrnaBeachBoardOfRealtors";
        case AreaPageListing_Provider.NewYorkStateAllianceOfMlss:
            return "NewYorkStateAllianceOfMlss";
        case AreaPageListing_Provider.NewZealand:
            return "NewZealand";
        case AreaPageListing_Provider.NorthCentralWestVirginiaRealEstateInformationNetwork:
            return "NorthCentralWestVirginiaRealEstateInformationNetwork";
        case AreaPageListing_Provider.NortheastArkansasBoardOfRealtors:
            return "NortheastArkansasBoardOfRealtors";
        case AreaPageListing_Provider.NortheastGeorgiaBoardOfRealtors:
            return "NortheastGeorgiaBoardOfRealtors";
        case AreaPageListing_Provider.NortheastIowaRegionalBoardOfRealtors:
            return "NortheastIowaRegionalBoardOfRealtors";
        case AreaPageListing_Provider.NortheastLouisianaAssociationOfRealtors:
            return "NortheastLouisianaAssociationOfRealtors";
        case AreaPageListing_Provider.NortheastOklahomaBoardOfRealtors:
            return "NortheastOklahomaBoardOfRealtors";
        case AreaPageListing_Provider.NorthernArizonaAssociationOfRealtors:
            return "NorthernArizonaAssociationOfRealtors";
        case AreaPageListing_Provider.NorthernGreatLakesRealtorsMls:
            return "NorthernGreatLakesRealtorsMls";
        case AreaPageListing_Provider.NorthernKentuckyMultipleListingService:
            return "NorthernKentuckyMultipleListingService";
        case AreaPageListing_Provider.NorthernNevadaRegionalMlsInc:
            return "NorthernNevadaRegionalMlsInc";
        case AreaPageListing_Provider.NorthFloridaMls:
            return "NorthFloridaMls";
        case AreaPageListing_Provider.NorthSantaBarbaraCountyRegionalMls:
            return "NorthSantaBarbaraCountyRegionalMls";
        case AreaPageListing_Provider.Northstarmls:
            return "Northstarmls";
        case AreaPageListing_Provider.NorthTexasRealEstateInformationSystems:
            return "NorthTexasRealEstateInformationSystems";
        case AreaPageListing_Provider.NorthwestArkansasBoardOfRealtors:
            return "NorthwestArkansasBoardOfRealtors";
        case AreaPageListing_Provider.NorthwesternWisconsinMultipleListingService:
            return "NorthwesternWisconsinMultipleListingService";
        case AreaPageListing_Provider.NorthwestIowaMls:
            return "NorthwestIowaMls";
        case AreaPageListing_Provider.NorthwestMississippiAssociationOfRealtors:
            return "NorthwestMississippiAssociationOfRealtors";
        case AreaPageListing_Provider.NorthwestMls:
            return "NorthwestMls";
        case AreaPageListing_Provider.NorthwestOhioRealEstateInformationSystems:
            return "NorthwestOhioRealEstateInformationSystems";
        case AreaPageListing_Provider.NorthwoodsAssociationOfRealtors:
            return "NorthwoodsAssociationOfRealtors";
        case AreaPageListing_Provider.OldKentuckyHomeBoardOfRealtors:
            return "OldKentuckyHomeBoardOfRealtors";
        case AreaPageListing_Provider.OnekeyMls:
            return "OnekeyMls";
        case AreaPageListing_Provider.OuterBanksAssociationOfRealtors:
            return "OuterBanksAssociationOfRealtors";
        case AreaPageListing_Provider.OzarkGatewayAssociationOfRealtors:
            return "OzarkGatewayAssociationOfRealtors";
        case AreaPageListing_Provider.PacificRegionalMls:
            return "PacificRegionalMls";
        case AreaPageListing_Provider.PageLakePowellMls:
            return "PageLakePowellMls";
        case AreaPageListing_Provider.PalestineAssociationOfRealtors:
            return "PalestineAssociationOfRealtors";
        case AreaPageListing_Provider.PalmBeachBoardOfRealtors:
            return "PalmBeachBoardOfRealtors";
        case AreaPageListing_Provider.PalmettoMultipleListingService:
            return "PalmettoMultipleListingService";
        case AreaPageListing_Provider.Panama:
            return "Panama";
        case AreaPageListing_Provider.ParkCityBoardOfRealtors:
            return "ParkCityBoardOfRealtors";
        case AreaPageListing_Provider.PearlRiverCountyBoardOfRealtors:
            return "PearlRiverCountyBoardOfRealtors";
        case AreaPageListing_Provider.PensacolaAssociationOfRealtors:
            return "PensacolaAssociationOfRealtors";
        case AreaPageListing_Provider.PermianBasinBoardOfRealtors:
            return "PermianBasinBoardOfRealtors";
        case AreaPageListing_Provider.PikesPeakAssociationOfRealtors:
            return "PikesPeakAssociationOfRealtors";
        case AreaPageListing_Provider.PikewayneAssociationOfRealtorsMls:
            return "PikewayneAssociationOfRealtorsMls";
        case AreaPageListing_Provider.PoconoMountainsAssociationOfRealtors:
            return "PoconoMountainsAssociationOfRealtors";
        case AreaPageListing_Provider.PortNechesPortArthurNederlandBoardOfRealtorsIncMls:
            return "PortNechesPortArthurNederlandBoardOfRealtorsIncMls";
        case AreaPageListing_Provider.Portugal:
            return "Portugal";
        case AreaPageListing_Provider.PrescottAreaAssociationOfRealtors:
            return "PrescottAreaAssociationOfRealtors";
        case AreaPageListing_Provider.Primemls:
            return "Primemls";
        case AreaPageListing_Provider.PuebloAssociationOfRealtors:
            return "PuebloAssociationOfRealtors";
        case AreaPageListing_Provider.PuertoRico:
            return "PuertoRico";
        case AreaPageListing_Provider.Qamls2:
            return "Qamls2";
        case AreaPageListing_Provider.Qamls3:
            return "Qamls3";
        case AreaPageListing_Provider.Qamls4:
            return "Qamls4";
        case AreaPageListing_Provider.RandolphCountyBoardOfRealtors:
            return "RandolphCountyBoardOfRealtors";
        case AreaPageListing_Provider.RangeAssociationOfRealtors:
            return "RangeAssociationOfRealtors";
        case AreaPageListing_Provider.RealcompLimitedIi:
            return "RealcompLimitedIi";
        case AreaPageListing_Provider.RealEstateInformationNetworkInc:
            return "RealEstateInformationNetworkInc";
        case AreaPageListing_Provider.Realmls:
            return "Realmls";
        case AreaPageListing_Provider.RealtorAssociationOfAcadiana:
            return "RealtorAssociationOfAcadiana";
        case AreaPageListing_Provider.RealtorAssociationOfFranklinAndGulfCounties:
            return "RealtorAssociationOfFranklinAndGulfCounties";
        case AreaPageListing_Provider.RealtorAssociationOfNortheastWisconsin:
            return "RealtorAssociationOfNortheastWisconsin";
        case AreaPageListing_Provider.RealtorAssociationOfSouthernKentuckyInc:
            return "RealtorAssociationOfSouthernKentuckyInc";
        case AreaPageListing_Provider.RealtorAssociationOfSouthernMinnesota:
            return "RealtorAssociationOfSouthernMinnesota";
        case AreaPageListing_Provider.RealtorAssociationOfTheSiouxEmpireMls:
            return "RealtorAssociationOfTheSiouxEmpireMls";
        case AreaPageListing_Provider.RealtorsAssociationOfCitrusCounty:
            return "RealtorsAssociationOfCitrusCounty";
        case AreaPageListing_Provider.RealtorsAssociationOfIndianRiverCounty:
            return "RealtorsAssociationOfIndianRiverCounty";
        case AreaPageListing_Provider.RealtorsAssociationOfMauiInc:
            return "RealtorsAssociationOfMauiInc";
        case AreaPageListing_Provider.Recolorado:
            return "Recolorado";
        case AreaPageListing_Provider.RegionalMultipleListingServices:
            return "RegionalMultipleListingServices";
        case AreaPageListing_Provider.RidgecrestAreaAssociationOfRealtors:
            return "RidgecrestAreaAssociationOfRealtors";
        case AreaPageListing_Provider.RiverCountiesAssociationOfRealtors:
            return "RiverCountiesAssociationOfRealtors";
        case AreaPageListing_Provider.RmlsAllianceLlc:
            return "RmlsAllianceLlc";
        case AreaPageListing_Provider.RoanokeValleyAssociationOfRealtors:
            return "RoanokeValleyAssociationOfRealtors";
        case AreaPageListing_Provider.RockfordAreaMls:
            return "RockfordAreaMls";
        case AreaPageListing_Provider.RockyMountAreaAssociationOfRealtors:
            return "RockyMountAreaAssociationOfRealtors";
        case AreaPageListing_Provider.RoyalPalmCoastRealtorAssociation:
            return "RoyalPalmCoastRealtorAssociation";
        case AreaPageListing_Provider.RuidosolincolnCountyAssociationOfRealtors:
            return "RuidosolincolnCountyAssociationOfRealtors";
        case AreaPageListing_Provider.RussellvilleBoardOfRealtors:
            return "RussellvilleBoardOfRealtors";
        case AreaPageListing_Provider.SanAngeloAssociationOfRealtors:
            return "SanAngeloAssociationOfRealtors";
        case AreaPageListing_Provider.SanAntonioBoardOfRealtors:
            return "SanAntonioBoardOfRealtors";
        case AreaPageListing_Provider.SanDiegoMls:
            return "SanDiegoMls";
        case AreaPageListing_Provider.SanFranciscoAssociationOfRealtors:
            return "SanFranciscoAssociationOfRealtors";
        case AreaPageListing_Provider.SanJuanAssociationOfRealtors:
            return "SanJuanAssociationOfRealtors";
        case AreaPageListing_Provider.SantaBarbaraMultipleListingService:
            return "SantaBarbaraMultipleListingService";
        case AreaPageListing_Provider.SantaFeAssociationOfRealtorsInc:
            return "SantaFeAssociationOfRealtorsInc";
        case AreaPageListing_Provider.SavannahMultilistCorporation:
            return "SavannahMultilistCorporation";
        case AreaPageListing_Provider.SciotoValleyAssociationOfRealtors:
            return "SciotoValleyAssociationOfRealtors";
        case AreaPageListing_Provider.SedonaVerdeValleyAssociationOfRealtors:
            return "SedonaVerdeValleyAssociationOfRealtors";
        case AreaPageListing_Provider.ShastaMls:
            return "ShastaMls";
        case AreaPageListing_Provider.SmartMls:
            return "SmartMls";
        case AreaPageListing_Provider.SnakeRiverRegionalMls:
            return "SnakeRiverRegionalMls";
        case AreaPageListing_Provider.SouthAfrica:
            return "SouthAfrica";
        case AreaPageListing_Provider.SouthBrowardBoardOfRealtors:
            return "SouthBrowardBoardOfRealtors";
        case AreaPageListing_Provider.SouthCentralAssociationOfRealtorsMls:
            return "SouthCentralAssociationOfRealtorsMls";
        case AreaPageListing_Provider.SouthCentralKansasMls:
            return "SouthCentralKansasMls";
        case AreaPageListing_Provider.SouthCentralWisconsinMlsCorporation:
            return "SouthCentralWisconsinMlsCorporation";
        case AreaPageListing_Provider.SoutheastAlaskaMls:
            return "SoutheastAlaskaMls";
        case AreaPageListing_Provider.SoutheastKansasMultipleListingSystem:
            return "SoutheastKansasMultipleListingSystem";
        case AreaPageListing_Provider.SouthernIndianaRealtorAssociation:
            return "SouthernIndianaRealtorAssociation";
        case AreaPageListing_Provider.SouthernMissouriRegionalMlsLlc:
            return "SouthernMissouriRegionalMlsLlc";
        case AreaPageListing_Provider.SouthernNewMexicoMls:
            return "SouthernNewMexicoMls";
        case AreaPageListing_Provider.SouthGeorgiaMls:
            return "SouthGeorgiaMls";
        case AreaPageListing_Provider.SouthJerseyShoreRegionalMls:
            return "SouthJerseyShoreRegionalMls";
        case AreaPageListing_Provider.SouthPadreIslandBoardOfRealtors:
            return "SouthPadreIslandBoardOfRealtors";
        case AreaPageListing_Provider.SouthwestMls:
            return "SouthwestMls";
        case AreaPageListing_Provider.SouthwestVirginiaAssociationOfRealtors:
            return "SouthwestVirginiaAssociationOfRealtors";
        case AreaPageListing_Provider.SpaceCoastAssociationOfRealtors:
            return "SpaceCoastAssociationOfRealtors";
        case AreaPageListing_Provider.SpaceCoastAssociationOfRealtorsExpPortalOnly:
            return "SpaceCoastAssociationOfRealtorsExpPortalOnly";
        case AreaPageListing_Provider.Spain:
            return "Spain";
        case AreaPageListing_Provider.SpartanburgAssociationOfRealtorsInc:
            return "SpartanburgAssociationOfRealtorsInc";
        case AreaPageListing_Provider.SpokaneAssociationOfRealtors:
            return "SpokaneAssociationOfRealtors";
        case AreaPageListing_Provider.StatenIslandBoardOfRealtors:
            return "StatenIslandBoardOfRealtors";
        case AreaPageListing_Provider.StateWideMlsOfRhodeIslandInc:
            return "StateWideMlsOfRhodeIslandInc";
        case AreaPageListing_Provider.StAugustineStJohnsCountyBoardOfRealtors:
            return "StAugustineStJohnsCountyBoardOfRealtors";
        case AreaPageListing_Provider.StillwaterBoardOfRealtors:
            return "StillwaterBoardOfRealtors";
        case AreaPageListing_Provider.StrategicMlsAlliance:
            return "StrategicMlsAlliance";
        case AreaPageListing_Provider.SummitAssociationOfRealtors:
            return "SummitAssociationOfRealtors";
        case AreaPageListing_Provider.SunflowerAssociationOfRealtors:
            return "SunflowerAssociationOfRealtors";
        case AreaPageListing_Provider.TahoeSierraBoardOfRealtors:
            return "TahoeSierraBoardOfRealtors";
        case AreaPageListing_Provider.TaosCountyAssociationOfRealtors:
            return "TaosCountyAssociationOfRealtors";
        case AreaPageListing_Provider.TennesseeVirginiaRegionalMultipleListingService:
            return "TennesseeVirginiaRegionalMultipleListingService";
        case AreaPageListing_Provider.TetonBoardOfRealtors:
            return "TetonBoardOfRealtors";
        case AreaPageListing_Provider.TexarkanaBoardOfRealtors:
            return "TexarkanaBoardOfRealtors";
        case AreaPageListing_Provider.TillamookCountyBoardOfRealtorsMls:
            return "TillamookCountyBoardOfRealtorsMls";
        case AreaPageListing_Provider.TopsailIslandAssociationOfRealtors:
            return "TopsailIslandAssociationOfRealtors";
        case AreaPageListing_Provider.TriadMultipleListingService:
            return "TriadMultipleListingService";
        case AreaPageListing_Provider.TriangleMls:
            return "TriangleMls";
        case AreaPageListing_Provider.TrinityCountyMls:
            return "TrinityCountyMls";
        case AreaPageListing_Provider.TulareCountyMls:
            return "TulareCountyMls";
        case AreaPageListing_Provider.TuolumneCountyAssociationOfRealtors:
            return "TuolumneCountyAssociationOfRealtors";
        case AreaPageListing_Provider.UlsterCountyBoardOfRealtorsMls:
            return "UlsterCountyBoardOfRealtorsMls";
        case AreaPageListing_Provider.UpperCumberlandAssociationOfRealtors:
            return "UpperCumberlandAssociationOfRealtors";
        case AreaPageListing_Provider.UpperPeninsulaAssociationOfRealtors:
            return "UpperPeninsulaAssociationOfRealtors";
        case AreaPageListing_Provider.VailBoardOfRealtorsMls:
            return "VailBoardOfRealtorsMls";
        case AreaPageListing_Provider.ValleyMls:
            return "ValleyMls";
        case AreaPageListing_Provider.WacoAssociationOfRealtors:
            return "WacoAssociationOfRealtors";
        case AreaPageListing_Provider.WasatchFrontRegionalMls:
            return "WasatchFrontRegionalMls";
        case AreaPageListing_Provider.WashingtonBeaufortCountyBoardOfRealtors:
            return "WashingtonBeaufortCountyBoardOfRealtors";
        case AreaPageListing_Provider.WashingtonCountyBoardOfRealtors:
            return "WashingtonCountyBoardOfRealtors";
        case AreaPageListing_Provider.WestAlabamaMultipleListingService:
            return "WestAlabamaMultipleListingService";
        case AreaPageListing_Provider.WestCentralAssociationOfRealtors:
            return "WestCentralAssociationOfRealtors";
        case AreaPageListing_Provider.WestcliffeListingService:
            return "WestcliffeListingService";
        case AreaPageListing_Provider.WesternArizonaRealtorDataExchange:
            return "WesternArizonaRealtorDataExchange";
        case AreaPageListing_Provider.WesternRegionalInformationSystemsAndTechnologyInc:
            return "WesternRegionalInformationSystemsAndTechnologyInc";
        case AreaPageListing_Provider.WesternUpstateAssociationOfRealtors:
            return "WesternUpstateAssociationOfRealtors";
        case AreaPageListing_Provider.WestPennMultiList:
            return "WestPennMultiList";
        case AreaPageListing_Provider.WheelingBoardOfRealtors:
            return "WheelingBoardOfRealtors";
        case AreaPageListing_Provider.WhiteMountainAssociationOfRealtors:
            return "WhiteMountainAssociationOfRealtors";
        case AreaPageListing_Provider.WillametteValleyMultipleListingService:
            return "WillametteValleyMultipleListingService";
        case AreaPageListing_Provider.WilsonBoardOfRealtors:
            return "WilsonBoardOfRealtors";
        case AreaPageListing_Provider.WinnipegRegionalRealEstateBoard:
            return "WinnipegRegionalRealEstateBoard";
        case AreaPageListing_Provider.WyomingMls:
            return "WyomingMls";
        case AreaPageListing_Provider.YumaAssociationOfRealtors:
            return "YumaAssociationOfRealtors";
        case AreaPageListing_Provider.NorthCarolinaRegionalMultipleListingService:
            return "NorthCarolinaRegionalMultipleListingService";
        case AreaPageListing_Provider.AgentUpload:
            return "AgentUpload";
        case AreaPageListing_Provider.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
function createBaseRange() {
    return {};
}
exports.Range = {
    encode(_, writer = new wire_1.BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.Range.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(_) {
        const message = createBaseRange();
        return message;
    },
};
function createBaseRange_Integer() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.Range_Integer = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(8).int32(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(16).int32(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(24).int32(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(32).int32(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Integer();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.gt = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.gte = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.lt = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.lte = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = Math.round(message.gt);
        }
        if (message.gte !== undefined) {
            obj.gte = Math.round(message.gte);
        }
        if (message.lt !== undefined) {
            obj.lt = Math.round(message.lt);
        }
        if (message.lte !== undefined) {
            obj.lte = Math.round(message.lte);
        }
        return obj;
    },
    create(base) {
        return exports.Range_Integer.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRange_Integer();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseRange_Date() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined, timeZone: undefined };
}
exports.Range_Date = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.gt), writer.uint32(10).fork()).join();
        }
        if (message.gte !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.gte), writer.uint32(18).fork()).join();
        }
        if (message.lt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lt), writer.uint32(26).fork()).join();
        }
        if (message.lte !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lte), writer.uint32(34).fork()).join();
        }
        if (message.timeZone !== undefined) {
            writer.uint32(42).string(message.timeZone);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Date();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.gt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.gte = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.lt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.lte = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.timeZone = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? fromJsonTimestamp(object.gt) : undefined,
            gte: isSet(object.gte) ? fromJsonTimestamp(object.gte) : undefined,
            lt: isSet(object.lt) ? fromJsonTimestamp(object.lt) : undefined,
            lte: isSet(object.lte) ? fromJsonTimestamp(object.lte) : undefined,
            timeZone: isSet(object.time_zone) ? globalThis.String(object.time_zone) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = message.gt.toISOString();
        }
        if (message.gte !== undefined) {
            obj.gte = message.gte.toISOString();
        }
        if (message.lt !== undefined) {
            obj.lt = message.lt.toISOString();
        }
        if (message.lte !== undefined) {
            obj.lte = message.lte.toISOString();
        }
        if (message.timeZone !== undefined) {
            obj.time_zone = message.timeZone;
        }
        return obj;
    },
    create(base) {
        return exports.Range_Date.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseRange_Date();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        message.timeZone = (_e = object.timeZone) !== null && _e !== void 0 ? _e : undefined;
        return message;
    },
};
function createBaseRange_Float() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.Range_Float = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(13).float(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(21).float(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(29).float(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(37).float(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRange_Float();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 13) {
                        break;
                    }
                    message.gt = reader.float();
                    continue;
                }
                case 2: {
                    if (tag !== 21) {
                        break;
                    }
                    message.gte = reader.float();
                    continue;
                }
                case 3: {
                    if (tag !== 29) {
                        break;
                    }
                    message.lt = reader.float();
                    continue;
                }
                case 4: {
                    if (tag !== 37) {
                        break;
                    }
                    message.lte = reader.float();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = message.gt;
        }
        if (message.gte !== undefined) {
            obj.gte = message.gte;
        }
        if (message.lt !== undefined) {
            obj.lt = message.lt;
        }
        if (message.lte !== undefined) {
            obj.lte = message.lte;
        }
        return obj;
    },
    create(base) {
        return exports.Range_Float.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseRange_Float();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function createBaseTypeOfProperty() {
    return { propertyTypes: [], propertySubTypes: [] };
}
exports.TypeOfProperty = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.propertyTypes) {
            writer.uint32(10).string(v);
        }
        for (const v of message.propertySubTypes) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTypeOfProperty();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.propertyTypes.push(reader.string());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.propertySubTypes.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            propertyTypes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertyTypes)
                ? object.propertyTypes.map((e) => globalThis.String(e))
                : [],
            propertySubTypes: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertySubTypes)
                ? object.propertySubTypes.map((e) => globalThis.String(e))
                : [],
        };
    },
    toJSON(message) {
        var _a, _b;
        const obj = {};
        if ((_a = message.propertyTypes) === null || _a === void 0 ? void 0 : _a.length) {
            obj.propertyTypes = message.propertyTypes;
        }
        if ((_b = message.propertySubTypes) === null || _b === void 0 ? void 0 : _b.length) {
            obj.propertySubTypes = message.propertySubTypes;
        }
        return obj;
    },
    create(base) {
        return exports.TypeOfProperty.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseTypeOfProperty();
        message.propertyTypes = ((_a = object.propertyTypes) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.propertySubTypes = ((_b = object.propertySubTypes) === null || _b === void 0 ? void 0 : _b.map((e) => e)) || [];
        return message;
    },
};
function createBaseFilter() {
    return {
        listingType: 0,
        statusId: 0,
        price: undefined,
        styles: [],
        listedDate: undefined,
        bedroomsExact: undefined,
        bedroomsRange: undefined,
        bathroomsExact: undefined,
        bathroomsRange: undefined,
        parkingExact: undefined,
        parkingRange: undefined,
        squareFeet: undefined,
        propertyType: [],
        hasGarage: false,
        hasPool: false,
        hasOpenHouse: false,
        hasWaterFront: false,
        hasFirePlace: false,
        hasLocker: false,
        maintenance: 0,
        boundaryTopLeft: [],
        boundaryBottomRight: [],
        zoom: 0,
        providerId: 0,
        hasImage: false,
        typeOfProperty: [],
        standardStatus: 0,
    };
}
exports.Filter = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.listingType !== 0) {
            writer.uint32(8).int32(message.listingType);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.price !== undefined) {
            exports.Range_Float.encode(message.price, writer.uint32(26).fork()).join();
        }
        writer.uint32(34).fork();
        for (const v of message.styles) {
            writer.int32(v);
        }
        writer.join();
        if (message.listedDate !== undefined) {
            exports.Range_Date.encode(message.listedDate, writer.uint32(42).fork()).join();
        }
        if (message.bedroomsExact !== undefined) {
            writer.uint32(48).uint32(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            exports.Range_Integer.encode(message.bedroomsRange, writer.uint32(58).fork()).join();
        }
        if (message.bathroomsExact !== undefined) {
            writer.uint32(64).uint32(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            exports.Range_Integer.encode(message.bathroomsRange, writer.uint32(74).fork()).join();
        }
        if (message.parkingExact !== undefined) {
            writer.uint32(80).uint32(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            exports.Range_Integer.encode(message.parkingRange, writer.uint32(90).fork()).join();
        }
        if (message.squareFeet !== undefined) {
            exports.Range_Float.encode(message.squareFeet, writer.uint32(98).fork()).join();
        }
        writer.uint32(106).fork();
        for (const v of message.propertyType) {
            writer.int32(v);
        }
        writer.join();
        if (message.hasGarage !== false) {
            writer.uint32(112).bool(message.hasGarage);
        }
        if (message.hasPool !== false) {
            writer.uint32(120).bool(message.hasPool);
        }
        if (message.hasOpenHouse !== false) {
            writer.uint32(128).bool(message.hasOpenHouse);
        }
        if (message.hasWaterFront !== false) {
            writer.uint32(136).bool(message.hasWaterFront);
        }
        if (message.hasFirePlace !== false) {
            writer.uint32(144).bool(message.hasFirePlace);
        }
        if (message.hasLocker !== false) {
            writer.uint32(152).bool(message.hasLocker);
        }
        if (message.maintenance !== 0) {
            writer.uint32(165).float(message.maintenance);
        }
        writer.uint32(170).fork();
        for (const v of message.boundaryTopLeft) {
            writer.float(v);
        }
        writer.join();
        writer.uint32(178).fork();
        for (const v of message.boundaryBottomRight) {
            writer.float(v);
        }
        writer.join();
        if (message.zoom !== 0) {
            writer.uint32(189).float(message.zoom);
        }
        if (message.providerId !== 0) {
            writer.uint32(208).int32(message.providerId);
        }
        if (message.hasImage !== false) {
            writer.uint32(216).bool(message.hasImage);
        }
        for (const v of message.typeOfProperty) {
            exports.TypeOfProperty.encode(v, writer.uint32(226).fork()).join();
        }
        if (message.standardStatus !== 0) {
            writer.uint32(232).int32(message.standardStatus);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFilter();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.price = exports.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag === 32) {
                        message.styles.push(reader.int32());
                        continue;
                    }
                    if (tag === 34) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.styles.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.listedDate = exports.Range_Date.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.bedroomsExact = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.bedroomsRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.bathroomsExact = reader.uint32();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.bathroomsRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.parkingExact = reader.uint32();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.parkingRange = exports.Range_Integer.decode(reader, reader.uint32());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.squareFeet = exports.Range_Float.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag === 104) {
                        message.propertyType.push(reader.int32());
                        continue;
                    }
                    if (tag === 106) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.propertyType.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.hasGarage = reader.bool();
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.hasPool = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.hasOpenHouse = reader.bool();
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.hasWaterFront = reader.bool();
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.hasFirePlace = reader.bool();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.hasLocker = reader.bool();
                    continue;
                }
                case 20: {
                    if (tag !== 165) {
                        break;
                    }
                    message.maintenance = reader.float();
                    continue;
                }
                case 21: {
                    if (tag === 173) {
                        message.boundaryTopLeft.push(reader.float());
                        continue;
                    }
                    if (tag === 170) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.boundaryTopLeft.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 22: {
                    if (tag === 181) {
                        message.boundaryBottomRight.push(reader.float());
                        continue;
                    }
                    if (tag === 178) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.boundaryBottomRight.push(reader.float());
                        }
                        continue;
                    }
                    break;
                }
                case 23: {
                    if (tag !== 189) {
                        break;
                    }
                    message.zoom = reader.float();
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 27: {
                    if (tag !== 216) {
                        break;
                    }
                    message.hasImage = reader.bool();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.typeOfProperty.push(exports.TypeOfProperty.decode(reader, reader.uint32()));
                    continue;
                }
                case 29: {
                    if (tag !== 232) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            listingType: isSet(object.listingType) ? areaPageListing_ListingTypeFromJSON(object.listingType) : 0,
            statusId: isSet(object.status_id) ? areaPageListing_StatusFromJSON(object.status_id) : 0,
            price: isSet(object.price) ? exports.Range_Float.fromJSON(object.price) : undefined,
            styles: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.styles) ? object.styles.map((e) => styleFromJSON(e)) : [],
            listedDate: isSet(object.listed_date) ? exports.Range_Date.fromJSON(object.listed_date) : undefined,
            bedroomsExact: isSet(object.bedrooms_exact) ? globalThis.Number(object.bedrooms_exact) : undefined,
            bedroomsRange: isSet(object.bedrooms_range) ? exports.Range_Integer.fromJSON(object.bedrooms_range) : undefined,
            bathroomsExact: isSet(object.bathrooms_exact) ? globalThis.Number(object.bathrooms_exact) : undefined,
            bathroomsRange: isSet(object.bathrooms_range) ? exports.Range_Integer.fromJSON(object.bathrooms_range) : undefined,
            parkingExact: isSet(object.parking_exact) ? globalThis.Number(object.parking_exact) : undefined,
            parkingRange: isSet(object.parking_range) ? exports.Range_Integer.fromJSON(object.parking_range) : undefined,
            squareFeet: isSet(object.squareFeet) ? exports.Range_Float.fromJSON(object.squareFeet) : undefined,
            propertyType: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.propertyType)
                ? object.propertyType.map((e) => propertyTypeFromJSON(e))
                : [],
            hasGarage: isSet(object.garage) ? globalThis.Boolean(object.garage) : false,
            hasPool: isSet(object.pool) ? globalThis.Boolean(object.pool) : false,
            hasOpenHouse: isSet(object.openHouse) ? globalThis.Boolean(object.openHouse) : false,
            hasWaterFront: isSet(object.waterfront) ? globalThis.Boolean(object.waterfront) : false,
            hasFirePlace: isSet(object.fireplace) ? globalThis.Boolean(object.fireplace) : false,
            hasLocker: isSet(object.has_locker) ? globalThis.Boolean(object.has_locker) : false,
            maintenance: isSet(object.maintenance) ? globalThis.Number(object.maintenance) : 0,
            boundaryTopLeft: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.boundaryTopLeft)
                ? object.boundaryTopLeft.map((e) => globalThis.Number(e))
                : [],
            boundaryBottomRight: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.boundaryBottomRight)
                ? object.boundaryBottomRight.map((e) => globalThis.Number(e))
                : [],
            zoom: isSet(object.zoom) ? globalThis.Number(object.zoom) : 0,
            providerId: isSet(object.provider_id) ? areaPageListing_ProviderFromJSON(object.provider_id) : 0,
            hasImage: isSet(object.hasImage) ? globalThis.Boolean(object.hasImage) : false,
            typeOfProperty: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.typeOfProperty)
                ? object.typeOfProperty.map((e) => exports.TypeOfProperty.fromJSON(e))
                : [],
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
        };
    },
    toJSON(message) {
        var _a, _b, _c, _d, _e;
        const obj = {};
        if (message.listingType !== 0) {
            obj.listingType = areaPageListing_ListingTypeToJSON(message.listingType);
        }
        if (message.statusId !== 0) {
            obj.status_id = areaPageListing_StatusToJSON(message.statusId);
        }
        if (message.price !== undefined) {
            obj.price = exports.Range_Float.toJSON(message.price);
        }
        if ((_a = message.styles) === null || _a === void 0 ? void 0 : _a.length) {
            obj.styles = message.styles.map((e) => styleToJSON(e));
        }
        if (message.listedDate !== undefined) {
            obj.listed_date = exports.Range_Date.toJSON(message.listedDate);
        }
        if (message.bedroomsExact !== undefined) {
            obj.bedrooms_exact = Math.round(message.bedroomsExact);
        }
        if (message.bedroomsRange !== undefined) {
            obj.bedrooms_range = exports.Range_Integer.toJSON(message.bedroomsRange);
        }
        if (message.bathroomsExact !== undefined) {
            obj.bathrooms_exact = Math.round(message.bathroomsExact);
        }
        if (message.bathroomsRange !== undefined) {
            obj.bathrooms_range = exports.Range_Integer.toJSON(message.bathroomsRange);
        }
        if (message.parkingExact !== undefined) {
            obj.parking_exact = Math.round(message.parkingExact);
        }
        if (message.parkingRange !== undefined) {
            obj.parking_range = exports.Range_Integer.toJSON(message.parkingRange);
        }
        if (message.squareFeet !== undefined) {
            obj.squareFeet = exports.Range_Float.toJSON(message.squareFeet);
        }
        if ((_b = message.propertyType) === null || _b === void 0 ? void 0 : _b.length) {
            obj.propertyType = message.propertyType.map((e) => propertyTypeToJSON(e));
        }
        if (message.hasGarage !== false) {
            obj.garage = message.hasGarage;
        }
        if (message.hasPool !== false) {
            obj.pool = message.hasPool;
        }
        if (message.hasOpenHouse !== false) {
            obj.openHouse = message.hasOpenHouse;
        }
        if (message.hasWaterFront !== false) {
            obj.waterfront = message.hasWaterFront;
        }
        if (message.hasFirePlace !== false) {
            obj.fireplace = message.hasFirePlace;
        }
        if (message.hasLocker !== false) {
            obj.has_locker = message.hasLocker;
        }
        if (message.maintenance !== 0) {
            obj.maintenance = message.maintenance;
        }
        if ((_c = message.boundaryTopLeft) === null || _c === void 0 ? void 0 : _c.length) {
            obj.boundaryTopLeft = message.boundaryTopLeft;
        }
        if ((_d = message.boundaryBottomRight) === null || _d === void 0 ? void 0 : _d.length) {
            obj.boundaryBottomRight = message.boundaryBottomRight;
        }
        if (message.zoom !== 0) {
            obj.zoom = message.zoom;
        }
        if (message.providerId !== 0) {
            obj.provider_id = areaPageListing_ProviderToJSON(message.providerId);
        }
        if (message.hasImage !== false) {
            obj.hasImage = message.hasImage;
        }
        if ((_e = message.typeOfProperty) === null || _e === void 0 ? void 0 : _e.length) {
            obj.typeOfProperty = message.typeOfProperty.map((e) => exports.TypeOfProperty.toJSON(e));
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.Filter.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        const message = createBaseFilter();
        message.listingType = (_a = object.listingType) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.price = (object.price !== undefined && object.price !== null)
            ? exports.Range_Float.fromPartial(object.price)
            : undefined;
        message.styles = ((_c = object.styles) === null || _c === void 0 ? void 0 : _c.map((e) => e)) || [];
        message.listedDate = (object.listedDate !== undefined && object.listedDate !== null)
            ? exports.Range_Date.fromPartial(object.listedDate)
            : undefined;
        message.bedroomsExact = (_d = object.bedroomsExact) !== null && _d !== void 0 ? _d : undefined;
        message.bedroomsRange = (object.bedroomsRange !== undefined && object.bedroomsRange !== null)
            ? exports.Range_Integer.fromPartial(object.bedroomsRange)
            : undefined;
        message.bathroomsExact = (_e = object.bathroomsExact) !== null && _e !== void 0 ? _e : undefined;
        message.bathroomsRange = (object.bathroomsRange !== undefined && object.bathroomsRange !== null)
            ? exports.Range_Integer.fromPartial(object.bathroomsRange)
            : undefined;
        message.parkingExact = (_f = object.parkingExact) !== null && _f !== void 0 ? _f : undefined;
        message.parkingRange = (object.parkingRange !== undefined && object.parkingRange !== null)
            ? exports.Range_Integer.fromPartial(object.parkingRange)
            : undefined;
        message.squareFeet = (object.squareFeet !== undefined && object.squareFeet !== null)
            ? exports.Range_Float.fromPartial(object.squareFeet)
            : undefined;
        message.propertyType = ((_g = object.propertyType) === null || _g === void 0 ? void 0 : _g.map((e) => e)) || [];
        message.hasGarage = (_h = object.hasGarage) !== null && _h !== void 0 ? _h : false;
        message.hasPool = (_j = object.hasPool) !== null && _j !== void 0 ? _j : false;
        message.hasOpenHouse = (_k = object.hasOpenHouse) !== null && _k !== void 0 ? _k : false;
        message.hasWaterFront = (_l = object.hasWaterFront) !== null && _l !== void 0 ? _l : false;
        message.hasFirePlace = (_m = object.hasFirePlace) !== null && _m !== void 0 ? _m : false;
        message.hasLocker = (_o = object.hasLocker) !== null && _o !== void 0 ? _o : false;
        message.maintenance = (_p = object.maintenance) !== null && _p !== void 0 ? _p : 0;
        message.boundaryTopLeft = ((_q = object.boundaryTopLeft) === null || _q === void 0 ? void 0 : _q.map((e) => e)) || [];
        message.boundaryBottomRight = ((_r = object.boundaryBottomRight) === null || _r === void 0 ? void 0 : _r.map((e) => e)) || [];
        message.zoom = (_s = object.zoom) !== null && _s !== void 0 ? _s : 0;
        message.providerId = (_t = object.providerId) !== null && _t !== void 0 ? _t : 0;
        message.hasImage = (_u = object.hasImage) !== null && _u !== void 0 ? _u : false;
        message.typeOfProperty = ((_v = object.typeOfProperty) === null || _v === void 0 ? void 0 : _v.map((e) => exports.TypeOfProperty.fromPartial(e))) || [];
        message.standardStatus = (_w = object.standardStatus) !== null && _w !== void 0 ? _w : 0;
        return message;
    },
};
function createBaseAreaPageListingRequest() {
    return { sortBy: 0, filter: undefined };
}
exports.AreaPageListingRequest = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.sortBy !== 0) {
            writer.uint32(8).int32(message.sortBy);
        }
        if (message.filter !== undefined) {
            exports.Filter.encode(message.filter, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListingRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.sortBy = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.filter = exports.Filter.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            sortBy: isSet(object.sort_by) ? sortByFromJSON(object.sort_by) : 0,
            filter: isSet(object.filter) ? exports.Filter.fromJSON(object.filter) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.sortBy !== 0) {
            obj.sort_by = sortByToJSON(message.sortBy);
        }
        if (message.filter !== undefined) {
            obj.filter = exports.Filter.toJSON(message.filter);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListingRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseAreaPageListingRequest();
        message.sortBy = (_a = object.sortBy) !== null && _a !== void 0 ? _a : 0;
        message.filter = (object.filter !== undefined && object.filter !== null)
            ? exports.Filter.fromPartial(object.filter)
            : undefined;
        return message;
    },
};
function createBaseAreaPageListingResponse() {
    return { data: [], PageNumber: 0, PageSize: 0, TotalCount: 0, TotalPages: 0 };
}
exports.AreaPageListingResponse = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.data) {
            exports.AreaPageListing.encode(v, writer.uint32(10).fork()).join();
        }
        if (message.PageNumber !== 0) {
            writer.uint32(16).uint32(message.PageNumber);
        }
        if (message.PageSize !== 0) {
            writer.uint32(24).uint32(message.PageSize);
        }
        if (message.TotalCount !== 0) {
            writer.uint32(32).uint32(message.TotalCount);
        }
        if (message.TotalPages !== 0) {
            writer.uint32(40).uint32(message.TotalPages);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListingResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.data.push(exports.AreaPageListing.decode(reader, reader.uint32()));
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.PageNumber = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.PageSize = reader.uint32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.TotalCount = reader.uint32();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.TotalPages = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            data: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.data) ? object.data.map((e) => exports.AreaPageListing.fromJSON(e)) : [],
            PageNumber: isSet(object.PageNumber) ? globalThis.Number(object.PageNumber) : 0,
            PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : 0,
            TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
            TotalPages: isSet(object.TotalPages) ? globalThis.Number(object.TotalPages) : 0,
        };
    },
    toJSON(message) {
        var _a;
        const obj = {};
        if ((_a = message.data) === null || _a === void 0 ? void 0 : _a.length) {
            obj.data = message.data.map((e) => exports.AreaPageListing.toJSON(e));
        }
        if (message.PageNumber !== 0) {
            obj.PageNumber = Math.round(message.PageNumber);
        }
        if (message.PageSize !== 0) {
            obj.PageSize = Math.round(message.PageSize);
        }
        if (message.TotalCount !== 0) {
            obj.TotalCount = Math.round(message.TotalCount);
        }
        if (message.TotalPages !== 0) {
            obj.TotalPages = Math.round(message.TotalPages);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListingResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseAreaPageListingResponse();
        message.data = ((_a = object.data) === null || _a === void 0 ? void 0 : _a.map((e) => exports.AreaPageListing.fromPartial(e))) || [];
        message.PageNumber = (_b = object.PageNumber) !== null && _b !== void 0 ? _b : 0;
        message.PageSize = (_c = object.PageSize) !== null && _c !== void 0 ? _c : 0;
        message.TotalCount = (_d = object.TotalCount) !== null && _d !== void 0 ? _d : 0;
        message.TotalPages = (_e = object.TotalPages) !== null && _e !== void 0 ? _e : 0;
        return message;
    },
};
function createBaseAreaPageListing() {
    return {
        id: 0,
        statusId: 0,
        listingType: 0,
        propertyType: "",
        mls: "",
        slug: "",
        address: "",
        postalCode: "",
        province: "",
        neighbourhood: "",
        neighbourhoodSlug: "",
        subDivision: "",
        subDivisionSlug: "",
        price: 0,
        SoldPrice: 0,
        squareFootage: undefined,
        bedrooms: 0,
        bedroomsPartial: 0,
        bathrooms: 0,
        bathroomsPartial: 0,
        imageRootStorageKey: "",
        createdAt: undefined,
        updatedOn: undefined,
        soldAt: undefined,
        expiredAt: undefined,
        providerId: 0,
        lastStatus: "",
        addressUrlAbsolutePath: "",
        listingUrlAbsolutePath: "",
        position: "",
        hasGarage: false,
        hasPool: false,
        hasOpenHouse: false,
        hasWaterFront: false,
        hasFirePlace: false,
        hasLocker: false,
        maintenance: 0,
        streetName: "",
        streetNumber: "",
        unit: "",
        termsOfUseRequired: false,
        brokerage: "",
        imageSource: "",
        countryCode: "",
        typeOfProperty: "",
        subTypeOfProperty: "",
        expAgentId: 0,
        standardStatus: 0,
        displayAddress: undefined,
    };
}
exports.AreaPageListing = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== 0) {
            writer.uint32(8).int32(message.id);
        }
        if (message.statusId !== 0) {
            writer.uint32(16).int32(message.statusId);
        }
        if (message.listingType !== 0) {
            writer.uint32(24).int32(message.listingType);
        }
        if (message.propertyType !== "") {
            writer.uint32(34).string(message.propertyType);
        }
        if (message.mls !== "") {
            writer.uint32(42).string(message.mls);
        }
        if (message.slug !== "") {
            writer.uint32(50).string(message.slug);
        }
        if (message.address !== "") {
            writer.uint32(58).string(message.address);
        }
        if (message.postalCode !== "") {
            writer.uint32(66).string(message.postalCode);
        }
        if (message.province !== "") {
            writer.uint32(74).string(message.province);
        }
        if (message.neighbourhood !== "") {
            writer.uint32(82).string(message.neighbourhood);
        }
        if (message.neighbourhoodSlug !== "") {
            writer.uint32(90).string(message.neighbourhoodSlug);
        }
        if (message.subDivision !== "") {
            writer.uint32(98).string(message.subDivision);
        }
        if (message.subDivisionSlug !== "") {
            writer.uint32(106).string(message.subDivisionSlug);
        }
        if (message.price !== 0) {
            writer.uint32(117).float(message.price);
        }
        if (message.SoldPrice !== 0) {
            writer.uint32(125).float(message.SoldPrice);
        }
        if (message.squareFootage !== undefined) {
            exports.AreaPageListing_IntegerRange.encode(message.squareFootage, writer.uint32(130).fork()).join();
        }
        if (message.bedrooms !== 0) {
            writer.uint32(136).uint64(message.bedrooms);
        }
        if (message.bedroomsPartial !== 0) {
            writer.uint32(144).uint64(message.bedroomsPartial);
        }
        if (message.bathrooms !== 0) {
            writer.uint32(152).uint64(message.bathrooms);
        }
        if (message.bathroomsPartial !== 0) {
            writer.uint32(160).uint64(message.bathroomsPartial);
        }
        if (message.imageRootStorageKey !== "") {
            writer.uint32(170).string(message.imageRootStorageKey);
        }
        if (message.createdAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(178).fork()).join();
        }
        if (message.updatedOn !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.updatedOn), writer.uint32(186).fork()).join();
        }
        if (message.soldAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.soldAt), writer.uint32(194).fork()).join();
        }
        if (message.expiredAt !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiredAt), writer.uint32(202).fork()).join();
        }
        if (message.providerId !== 0) {
            writer.uint32(208).int32(message.providerId);
        }
        if (message.lastStatus !== "") {
            writer.uint32(218).string(message.lastStatus);
        }
        if (message.addressUrlAbsolutePath !== "") {
            writer.uint32(226).string(message.addressUrlAbsolutePath);
        }
        if (message.listingUrlAbsolutePath !== "") {
            writer.uint32(234).string(message.listingUrlAbsolutePath);
        }
        if (message.position !== "") {
            writer.uint32(242).string(message.position);
        }
        if (message.hasGarage !== false) {
            writer.uint32(248).bool(message.hasGarage);
        }
        if (message.hasPool !== false) {
            writer.uint32(256).bool(message.hasPool);
        }
        if (message.hasOpenHouse !== false) {
            writer.uint32(264).bool(message.hasOpenHouse);
        }
        if (message.hasWaterFront !== false) {
            writer.uint32(272).bool(message.hasWaterFront);
        }
        if (message.hasFirePlace !== false) {
            writer.uint32(280).bool(message.hasFirePlace);
        }
        if (message.hasLocker !== false) {
            writer.uint32(288).bool(message.hasLocker);
        }
        if (message.maintenance !== 0) {
            writer.uint32(301).float(message.maintenance);
        }
        if (message.streetName !== "") {
            writer.uint32(306).string(message.streetName);
        }
        if (message.streetNumber !== "") {
            writer.uint32(314).string(message.streetNumber);
        }
        if (message.unit !== "") {
            writer.uint32(322).string(message.unit);
        }
        if (message.termsOfUseRequired !== false) {
            writer.uint32(328).bool(message.termsOfUseRequired);
        }
        if (message.brokerage !== "") {
            writer.uint32(338).string(message.brokerage);
        }
        if (message.imageSource !== "") {
            writer.uint32(346).string(message.imageSource);
        }
        if (message.countryCode !== "") {
            writer.uint32(354).string(message.countryCode);
        }
        if (message.typeOfProperty !== "") {
            writer.uint32(362).string(message.typeOfProperty);
        }
        if (message.subTypeOfProperty !== "") {
            writer.uint32(370).string(message.subTypeOfProperty);
        }
        if (message.expAgentId !== 0) {
            writer.uint32(376).uint64(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            writer.uint32(384).int32(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            display_1.Display.encode(message.displayAddress, writer.uint32(394).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListing();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.id = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.statusId = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.listingType = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.propertyType = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.mls = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.address = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.province = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.neighbourhood = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.neighbourhoodSlug = reader.string();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.subDivision = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.subDivisionSlug = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 117) {
                        break;
                    }
                    message.price = reader.float();
                    continue;
                }
                case 15: {
                    if (tag !== 125) {
                        break;
                    }
                    message.SoldPrice = reader.float();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.squareFootage = exports.AreaPageListing_IntegerRange.decode(reader, reader.uint32());
                    continue;
                }
                case 17: {
                    if (tag !== 136) {
                        break;
                    }
                    message.bedrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.bedroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.bathrooms = longToNumber(reader.uint64());
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.bathroomsPartial = longToNumber(reader.uint64());
                    continue;
                }
                case 21: {
                    if (tag !== 170) {
                        break;
                    }
                    message.imageRootStorageKey = reader.string();
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.createdAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.updatedOn = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.soldAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.expiredAt = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.providerId = reader.int32();
                    continue;
                }
                case 27: {
                    if (tag !== 218) {
                        break;
                    }
                    message.lastStatus = reader.string();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.addressUrlAbsolutePath = reader.string();
                    continue;
                }
                case 29: {
                    if (tag !== 234) {
                        break;
                    }
                    message.listingUrlAbsolutePath = reader.string();
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.position = reader.string();
                    continue;
                }
                case 31: {
                    if (tag !== 248) {
                        break;
                    }
                    message.hasGarage = reader.bool();
                    continue;
                }
                case 32: {
                    if (tag !== 256) {
                        break;
                    }
                    message.hasPool = reader.bool();
                    continue;
                }
                case 33: {
                    if (tag !== 264) {
                        break;
                    }
                    message.hasOpenHouse = reader.bool();
                    continue;
                }
                case 34: {
                    if (tag !== 272) {
                        break;
                    }
                    message.hasWaterFront = reader.bool();
                    continue;
                }
                case 35: {
                    if (tag !== 280) {
                        break;
                    }
                    message.hasFirePlace = reader.bool();
                    continue;
                }
                case 36: {
                    if (tag !== 288) {
                        break;
                    }
                    message.hasLocker = reader.bool();
                    continue;
                }
                case 37: {
                    if (tag !== 301) {
                        break;
                    }
                    message.maintenance = reader.float();
                    continue;
                }
                case 38: {
                    if (tag !== 306) {
                        break;
                    }
                    message.streetName = reader.string();
                    continue;
                }
                case 39: {
                    if (tag !== 314) {
                        break;
                    }
                    message.streetNumber = reader.string();
                    continue;
                }
                case 40: {
                    if (tag !== 322) {
                        break;
                    }
                    message.unit = reader.string();
                    continue;
                }
                case 41: {
                    if (tag !== 328) {
                        break;
                    }
                    message.termsOfUseRequired = reader.bool();
                    continue;
                }
                case 42: {
                    if (tag !== 338) {
                        break;
                    }
                    message.brokerage = reader.string();
                    continue;
                }
                case 43: {
                    if (tag !== 346) {
                        break;
                    }
                    message.imageSource = reader.string();
                    continue;
                }
                case 44: {
                    if (tag !== 354) {
                        break;
                    }
                    message.countryCode = reader.string();
                    continue;
                }
                case 45: {
                    if (tag !== 362) {
                        break;
                    }
                    message.typeOfProperty = reader.string();
                    continue;
                }
                case 46: {
                    if (tag !== 370) {
                        break;
                    }
                    message.subTypeOfProperty = reader.string();
                    continue;
                }
                case 47: {
                    if (tag !== 376) {
                        break;
                    }
                    message.expAgentId = longToNumber(reader.uint64());
                    continue;
                }
                case 48: {
                    if (tag !== 384) {
                        break;
                    }
                    message.standardStatus = reader.int32();
                    continue;
                }
                case 49: {
                    if (tag !== 394) {
                        break;
                    }
                    message.displayAddress = display_1.Display.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.Number(object.id) : 0,
            statusId: isSet(object.status_id) ? areaPageListing_StatusFromJSON(object.status_id) : 0,
            listingType: isSet(object.listing_type) ? areaPageListing_ListingTypeFromJSON(object.listing_type) : 0,
            propertyType: isSet(object.property_type) ? globalThis.String(object.property_type) : "",
            mls: isSet(object.mls) ? globalThis.String(object.mls) : "",
            slug: isSet(object.slug) ? globalThis.String(object.slug) : "",
            address: isSet(object.address) ? globalThis.String(object.address) : "",
            postalCode: isSet(object.postal_code) ? globalThis.String(object.postal_code) : "",
            province: isSet(object.province) ? globalThis.String(object.province) : "",
            neighbourhood: isSet(object.neighbourhood) ? globalThis.String(object.neighbourhood) : "",
            neighbourhoodSlug: isSet(object.neighbourhood_slug) ? globalThis.String(object.neighbourhood_slug) : "",
            subDivision: isSet(object.sub_division) ? globalThis.String(object.sub_division) : "",
            subDivisionSlug: isSet(object.sub_division_slug) ? globalThis.String(object.sub_division_slug) : "",
            price: isSet(object.price) ? globalThis.Number(object.price) : 0,
            SoldPrice: isSet(object.sold_price) ? globalThis.Number(object.sold_price) : 0,
            squareFootage: isSet(object.square_footage)
                ? exports.AreaPageListing_IntegerRange.fromJSON(object.square_footage)
                : undefined,
            bedrooms: isSet(object.bedrooms) ? globalThis.Number(object.bedrooms) : 0,
            bedroomsPartial: isSet(object.bedrooms_partial) ? globalThis.Number(object.bedrooms_partial) : 0,
            bathrooms: isSet(object.bathrooms) ? globalThis.Number(object.bathrooms) : 0,
            bathroomsPartial: isSet(object.bathrooms_partial) ? globalThis.Number(object.bathrooms_partial) : 0,
            imageRootStorageKey: isSet(object.image_root_storage_key) ? globalThis.String(object.image_root_storage_key) : "",
            createdAt: isSet(object.created_at) ? fromJsonTimestamp(object.created_at) : undefined,
            updatedOn: isSet(object.updated_on) ? fromJsonTimestamp(object.updated_on) : undefined,
            soldAt: isSet(object.sold_at) ? fromJsonTimestamp(object.sold_at) : undefined,
            expiredAt: isSet(object.expired_at) ? fromJsonTimestamp(object.expired_at) : undefined,
            providerId: isSet(object.provider_id) ? areaPageListing_ProviderFromJSON(object.provider_id) : 0,
            lastStatus: isSet(object.last_status) ? globalThis.String(object.last_status) : "",
            addressUrlAbsolutePath: isSet(object.address_url_absolute_path)
                ? globalThis.String(object.address_url_absolute_path)
                : "",
            listingUrlAbsolutePath: isSet(object.listing_url_absolute_path)
                ? globalThis.String(object.listing_url_absolute_path)
                : "",
            position: isSet(object.position) ? globalThis.String(object.position) : "",
            hasGarage: isSet(object.garage) ? globalThis.Boolean(object.garage) : false,
            hasPool: isSet(object.pool) ? globalThis.Boolean(object.pool) : false,
            hasOpenHouse: isSet(object.openHouse) ? globalThis.Boolean(object.openHouse) : false,
            hasWaterFront: isSet(object.waterfront) ? globalThis.Boolean(object.waterfront) : false,
            hasFirePlace: isSet(object.fireplace) ? globalThis.Boolean(object.fireplace) : false,
            hasLocker: isSet(object.has_locker) ? globalThis.Boolean(object.has_locker) : false,
            maintenance: isSet(object.maintenance) ? globalThis.Number(object.maintenance) : 0,
            streetName: isSet(object.street_name) ? globalThis.String(object.street_name) : "",
            streetNumber: isSet(object.street_number) ? globalThis.String(object.street_number) : "",
            unit: isSet(object.unit) ? globalThis.String(object.unit) : "",
            termsOfUseRequired: isSet(object.terms_of_use_required)
                ? globalThis.Boolean(object.terms_of_use_required)
                : false,
            brokerage: isSet(object.brokerage) ? globalThis.String(object.brokerage) : "",
            imageSource: isSet(object.image_source) ? globalThis.String(object.image_source) : "",
            countryCode: isSet(object.country_code) ? globalThis.String(object.country_code) : "",
            typeOfProperty: isSet(object.typeOfProperty) ? globalThis.String(object.typeOfProperty) : "",
            subTypeOfProperty: isSet(object.subTypeOfProperty) ? globalThis.String(object.subTypeOfProperty) : "",
            expAgentId: isSet(object.expAgentId) ? globalThis.Number(object.expAgentId) : 0,
            standardStatus: isSet(object.standardStatus) ? (0, standard_status_1.standardStatusFromJSON)(object.standardStatus) : 0,
            displayAddress: isSet(object.display_address) ? display_1.Display.fromJSON(object.display_address) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== 0) {
            obj.id = Math.round(message.id);
        }
        if (message.statusId !== 0) {
            obj.status_id = areaPageListing_StatusToJSON(message.statusId);
        }
        if (message.listingType !== 0) {
            obj.listing_type = areaPageListing_ListingTypeToJSON(message.listingType);
        }
        if (message.propertyType !== "") {
            obj.property_type = message.propertyType;
        }
        if (message.mls !== "") {
            obj.mls = message.mls;
        }
        if (message.slug !== "") {
            obj.slug = message.slug;
        }
        if (message.address !== "") {
            obj.address = message.address;
        }
        if (message.postalCode !== "") {
            obj.postal_code = message.postalCode;
        }
        if (message.province !== "") {
            obj.province = message.province;
        }
        if (message.neighbourhood !== "") {
            obj.neighbourhood = message.neighbourhood;
        }
        if (message.neighbourhoodSlug !== "") {
            obj.neighbourhood_slug = message.neighbourhoodSlug;
        }
        if (message.subDivision !== "") {
            obj.sub_division = message.subDivision;
        }
        if (message.subDivisionSlug !== "") {
            obj.sub_division_slug = message.subDivisionSlug;
        }
        if (message.price !== 0) {
            obj.price = message.price;
        }
        if (message.SoldPrice !== 0) {
            obj.sold_price = message.SoldPrice;
        }
        if (message.squareFootage !== undefined) {
            obj.square_footage = exports.AreaPageListing_IntegerRange.toJSON(message.squareFootage);
        }
        if (message.bedrooms !== 0) {
            obj.bedrooms = Math.round(message.bedrooms);
        }
        if (message.bedroomsPartial !== 0) {
            obj.bedrooms_partial = Math.round(message.bedroomsPartial);
        }
        if (message.bathrooms !== 0) {
            obj.bathrooms = Math.round(message.bathrooms);
        }
        if (message.bathroomsPartial !== 0) {
            obj.bathrooms_partial = Math.round(message.bathroomsPartial);
        }
        if (message.imageRootStorageKey !== "") {
            obj.image_root_storage_key = message.imageRootStorageKey;
        }
        if (message.createdAt !== undefined) {
            obj.created_at = message.createdAt.toISOString();
        }
        if (message.updatedOn !== undefined) {
            obj.updated_on = message.updatedOn.toISOString();
        }
        if (message.soldAt !== undefined) {
            obj.sold_at = message.soldAt.toISOString();
        }
        if (message.expiredAt !== undefined) {
            obj.expired_at = message.expiredAt.toISOString();
        }
        if (message.providerId !== 0) {
            obj.provider_id = areaPageListing_ProviderToJSON(message.providerId);
        }
        if (message.lastStatus !== "") {
            obj.last_status = message.lastStatus;
        }
        if (message.addressUrlAbsolutePath !== "") {
            obj.address_url_absolute_path = message.addressUrlAbsolutePath;
        }
        if (message.listingUrlAbsolutePath !== "") {
            obj.listing_url_absolute_path = message.listingUrlAbsolutePath;
        }
        if (message.position !== "") {
            obj.position = message.position;
        }
        if (message.hasGarage !== false) {
            obj.garage = message.hasGarage;
        }
        if (message.hasPool !== false) {
            obj.pool = message.hasPool;
        }
        if (message.hasOpenHouse !== false) {
            obj.openHouse = message.hasOpenHouse;
        }
        if (message.hasWaterFront !== false) {
            obj.waterfront = message.hasWaterFront;
        }
        if (message.hasFirePlace !== false) {
            obj.fireplace = message.hasFirePlace;
        }
        if (message.hasLocker !== false) {
            obj.has_locker = message.hasLocker;
        }
        if (message.maintenance !== 0) {
            obj.maintenance = message.maintenance;
        }
        if (message.streetName !== "") {
            obj.street_name = message.streetName;
        }
        if (message.streetNumber !== "") {
            obj.street_number = message.streetNumber;
        }
        if (message.unit !== "") {
            obj.unit = message.unit;
        }
        if (message.termsOfUseRequired !== false) {
            obj.terms_of_use_required = message.termsOfUseRequired;
        }
        if (message.brokerage !== "") {
            obj.brokerage = message.brokerage;
        }
        if (message.imageSource !== "") {
            obj.image_source = message.imageSource;
        }
        if (message.countryCode !== "") {
            obj.country_code = message.countryCode;
        }
        if (message.typeOfProperty !== "") {
            obj.typeOfProperty = message.typeOfProperty;
        }
        if (message.subTypeOfProperty !== "") {
            obj.subTypeOfProperty = message.subTypeOfProperty;
        }
        if (message.expAgentId !== 0) {
            obj.expAgentId = Math.round(message.expAgentId);
        }
        if (message.standardStatus !== 0) {
            obj.standardStatus = (0, standard_status_1.standardStatusToJSON)(message.standardStatus);
        }
        if (message.displayAddress !== undefined) {
            obj.display_address = display_1.Display.toJSON(message.displayAddress);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListing.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
        const message = createBaseAreaPageListing();
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : 0;
        message.statusId = (_b = object.statusId) !== null && _b !== void 0 ? _b : 0;
        message.listingType = (_c = object.listingType) !== null && _c !== void 0 ? _c : 0;
        message.propertyType = (_d = object.propertyType) !== null && _d !== void 0 ? _d : "";
        message.mls = (_e = object.mls) !== null && _e !== void 0 ? _e : "";
        message.slug = (_f = object.slug) !== null && _f !== void 0 ? _f : "";
        message.address = (_g = object.address) !== null && _g !== void 0 ? _g : "";
        message.postalCode = (_h = object.postalCode) !== null && _h !== void 0 ? _h : "";
        message.province = (_j = object.province) !== null && _j !== void 0 ? _j : "";
        message.neighbourhood = (_k = object.neighbourhood) !== null && _k !== void 0 ? _k : "";
        message.neighbourhoodSlug = (_l = object.neighbourhoodSlug) !== null && _l !== void 0 ? _l : "";
        message.subDivision = (_m = object.subDivision) !== null && _m !== void 0 ? _m : "";
        message.subDivisionSlug = (_o = object.subDivisionSlug) !== null && _o !== void 0 ? _o : "";
        message.price = (_p = object.price) !== null && _p !== void 0 ? _p : 0;
        message.SoldPrice = (_q = object.SoldPrice) !== null && _q !== void 0 ? _q : 0;
        message.squareFootage = (object.squareFootage !== undefined && object.squareFootage !== null)
            ? exports.AreaPageListing_IntegerRange.fromPartial(object.squareFootage)
            : undefined;
        message.bedrooms = (_r = object.bedrooms) !== null && _r !== void 0 ? _r : 0;
        message.bedroomsPartial = (_s = object.bedroomsPartial) !== null && _s !== void 0 ? _s : 0;
        message.bathrooms = (_t = object.bathrooms) !== null && _t !== void 0 ? _t : 0;
        message.bathroomsPartial = (_u = object.bathroomsPartial) !== null && _u !== void 0 ? _u : 0;
        message.imageRootStorageKey = (_v = object.imageRootStorageKey) !== null && _v !== void 0 ? _v : "";
        message.createdAt = (_w = object.createdAt) !== null && _w !== void 0 ? _w : undefined;
        message.updatedOn = (_x = object.updatedOn) !== null && _x !== void 0 ? _x : undefined;
        message.soldAt = (_y = object.soldAt) !== null && _y !== void 0 ? _y : undefined;
        message.expiredAt = (_z = object.expiredAt) !== null && _z !== void 0 ? _z : undefined;
        message.providerId = (_0 = object.providerId) !== null && _0 !== void 0 ? _0 : 0;
        message.lastStatus = (_1 = object.lastStatus) !== null && _1 !== void 0 ? _1 : "";
        message.addressUrlAbsolutePath = (_2 = object.addressUrlAbsolutePath) !== null && _2 !== void 0 ? _2 : "";
        message.listingUrlAbsolutePath = (_3 = object.listingUrlAbsolutePath) !== null && _3 !== void 0 ? _3 : "";
        message.position = (_4 = object.position) !== null && _4 !== void 0 ? _4 : "";
        message.hasGarage = (_5 = object.hasGarage) !== null && _5 !== void 0 ? _5 : false;
        message.hasPool = (_6 = object.hasPool) !== null && _6 !== void 0 ? _6 : false;
        message.hasOpenHouse = (_7 = object.hasOpenHouse) !== null && _7 !== void 0 ? _7 : false;
        message.hasWaterFront = (_8 = object.hasWaterFront) !== null && _8 !== void 0 ? _8 : false;
        message.hasFirePlace = (_9 = object.hasFirePlace) !== null && _9 !== void 0 ? _9 : false;
        message.hasLocker = (_10 = object.hasLocker) !== null && _10 !== void 0 ? _10 : false;
        message.maintenance = (_11 = object.maintenance) !== null && _11 !== void 0 ? _11 : 0;
        message.streetName = (_12 = object.streetName) !== null && _12 !== void 0 ? _12 : "";
        message.streetNumber = (_13 = object.streetNumber) !== null && _13 !== void 0 ? _13 : "";
        message.unit = (_14 = object.unit) !== null && _14 !== void 0 ? _14 : "";
        message.termsOfUseRequired = (_15 = object.termsOfUseRequired) !== null && _15 !== void 0 ? _15 : false;
        message.brokerage = (_16 = object.brokerage) !== null && _16 !== void 0 ? _16 : "";
        message.imageSource = (_17 = object.imageSource) !== null && _17 !== void 0 ? _17 : "";
        message.countryCode = (_18 = object.countryCode) !== null && _18 !== void 0 ? _18 : "";
        message.typeOfProperty = (_19 = object.typeOfProperty) !== null && _19 !== void 0 ? _19 : "";
        message.subTypeOfProperty = (_20 = object.subTypeOfProperty) !== null && _20 !== void 0 ? _20 : "";
        message.expAgentId = (_21 = object.expAgentId) !== null && _21 !== void 0 ? _21 : 0;
        message.standardStatus = (_22 = object.standardStatus) !== null && _22 !== void 0 ? _22 : 0;
        message.displayAddress = (object.displayAddress !== undefined && object.displayAddress !== null)
            ? display_1.Display.fromPartial(object.displayAddress)
            : undefined;
        return message;
    },
};
function createBaseAreaPageListing_IntegerRange() {
    return { gt: undefined, gte: undefined, lt: undefined, lte: undefined };
}
exports.AreaPageListing_IntegerRange = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.gt !== undefined) {
            writer.uint32(8).int32(message.gt);
        }
        if (message.gte !== undefined) {
            writer.uint32(16).int32(message.gte);
        }
        if (message.lt !== undefined) {
            writer.uint32(24).int32(message.lt);
        }
        if (message.lte !== undefined) {
            writer.uint32(32).int32(message.lte);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAreaPageListing_IntegerRange();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.gt = reader.int32();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.gte = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.lt = reader.int32();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.lte = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            gt: isSet(object.gt) ? globalThis.Number(object.gt) : undefined,
            gte: isSet(object.gte) ? globalThis.Number(object.gte) : undefined,
            lt: isSet(object.lt) ? globalThis.Number(object.lt) : undefined,
            lte: isSet(object.lte) ? globalThis.Number(object.lte) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.gt !== undefined) {
            obj.gt = Math.round(message.gt);
        }
        if (message.gte !== undefined) {
            obj.gte = Math.round(message.gte);
        }
        if (message.lt !== undefined) {
            obj.lt = Math.round(message.lt);
        }
        if (message.lte !== undefined) {
            obj.lte = Math.round(message.lte);
        }
        return obj;
    },
    create(base) {
        return exports.AreaPageListing_IntegerRange.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d;
        const message = createBaseAreaPageListing_IntegerRange();
        message.gt = (_a = object.gt) !== null && _a !== void 0 ? _a : undefined;
        message.gte = (_b = object.gte) !== null && _b !== void 0 ? _b : undefined;
        message.lt = (_c = object.lt) !== null && _c !== void 0 ? _c : undefined;
        message.lte = (_d = object.lte) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=area_page.js.map